<app-scroll-to-top></app-scroll-to-top>
<input id="business_post_file_input_candidate" #myFileInputcandidate style="display: none;" type="file" (click)="myFileInputcandidate.value=null"
  (change)="fileChangeEvent($event, profilePhotoUpload)" accept=".jpg, .jpeg,.png" />
<input id="myFileInput3" style="display: none;" multiple type="file" accept=".jpg,.jpeg,.png"
  #myFileInput3 (click)="myFileInput3.value=null" (change)="fileUpload($event, 'image', null)" />
<input multiple id="myFileInput4" style="display: none;" type="file" accept="video/*"
  (change)="fileUpload($event, 'video', null)" #myFileInput4 (click)="myFileInput4.value=null" />

<ng-template #postTemplate>
  <div class="hpanel">
    <div *ngIf="commonVariables.postFormflag">

      <div class="common-header-flex">
        <div>Create A Post</div>
        <button id="business_post_close_wrapper_button">
          <span id="business_post_close_button" (click)="close()" class="common-close">&times;</span>
        </button>
      </div>

      <div class="panel-body border-radius-top-left-right-6">
        <div class="row encased" [class.has-media]="selectedMediaType === 'photo' || selectedMediaType === 'video' || uploadFiles.length > 0">
          <div class="col-sm-2 pd-rt-0">


            <div *ngIf="profPhoto != undefined">
              <img id="business_post_user_profile_image" class="avtar" (click)="userprofile(undefined, loginUser.userId)" src="{{ profPhoto }}" />
            </div>
            <div id="business_post_user_profile_avatar" *ngIf="profPhoto == undefined" (click)="userprofile(undefined, loginUser.userId)">
              <div class="circles" [style.background-color]="getColortwo(loginUser?.firstName, loginUser?.lastName)">
                <div class="circle-text"  [style.color]="getTextColor(profileitems?.firstName, profileitems?.lastName)"style="font-size: 18px !important; font-weight: bold;">
                  {{ getInitialstwo(loginUser?.firstName, loginUser?.lastName) }}</div>
              </div>
            </div>

          </div>
          <div class="col-sm-10 pd-lt-0">
            <div class="row" [class.name-row-no-menu]="Commomdatass != 'USER'">
              <h6 class="ellipse2 text-only" title="{{profName}}">{{profName}}</h6>
            </div>
            <div class="row" [formGroup]="postTypeForm" style="display: flex;"
              *ngIf="(editPost && privacyValue == 'Connections') || !editPost">
              <input id="postType" formControlName="postType" [value]="privacyValue" style="display: none!important;">
              <div yPosition="below" *ngIf="Commomdatass == 'USER'" xPosition="after" [matMenuTriggerFor]="menu">
                <button id="business_post_privacy_menu_button" class="btn btn-default">
                  <ng-icon name="tablerWorld" *ngIf="privacyValue == 'Everyone'"></ng-icon>
                  <ng-icon name="tablerUsers" *ngIf="privacyValue == 'Connections'"></ng-icon>
                  <ng-icon name="tablerNetwork" *ngIf="privacyValue == 'Network'"></ng-icon>
                  <ng-icon name="tablerUsers" *ngIf="privacyValue == 'Community'"></ng-icon>
                  <span class="opaa1"> {{privacyValue}}
                    <ng-icon name="tablerChevronDown" style="padding-left: 0.3rem;"></ng-icon>
                  </span>
                </button>
                <mat-menu #menu="matMenu">
                  <button id="business_post_privacy_everyone_button" class="mat-menu-height" mat-menu-item [disabled]="editPost"
                    (click)="changePostModal('Everyone', 'post')">
                    <ng-icon name="tablerWorld"></ng-icon>
                    <span class="opaa1">Everyone</span>
                  </button>
                  <button id="business_post_privacy_connections_button" type="button" [disabled]="editPost && privacyValue != 'Connections'"
                    (click)="changePostModal('Connections', 'post')" class="mat-menu-height" mat-menu-item>
                    <ng-icon name="tablerUsers"></ng-icon>
                    <span class="opaa1">Connections</span>
                  </button>
                  <button id="business_post_privacy_network_button" type="button" [disabled]="editPost" (click)="changePostModal('Network', 'post')"
                    class="mat-menu-height" mat-menu-item>
                    <ng-icon name="tablerNetwork"></ng-icon>
                    <span class="opaa1">Network</span>
                  </button>
                  <button id="business_post_privacy_community_button" type="button" [disabled]="editPost" (click)="changePostModal('Community', 'post')"
                    class="mat-menu-height" mat-menu-item>
                    <ng-icon name="tablerUsers"></ng-icon>
                    <span class="opaa1">Community</span>
                  </button>
                </mat-menu>
              </div>
              <!-- Same chip row as the Edit modal (#editpost): first two names collapsed,
                   "and N others" expands the full list inside a scrolling element. -->
              <div class="privacy-entity-chips">
                <div class="privacy-entity-chips__list" [class.privacy-entity-chips__list--scroll]="showAllPrivacyEntities">
                  <div title="{{entity}}" class="ioxlp"
                    *ngFor="let entity of (showAllPrivacyEntities ? selectedEntities : selectedEntities.slice(0, 2))">
                    {{entity}}
                  </div>
                </div>
                <span class="jc-v3-skill-more" role="button" *ngIf="selectedEntities.length > 2"
                  (click)="togglePrivacyEntities(); $event.stopPropagation()">
                  <ng-container *ngIf="!showAllPrivacyEntities">and {{ selectedEntities.length - 2 }} others</ng-container>
                  <ng-container *ngIf="showAllPrivacyEntities">Show less</ng-container>
                </span>
              </div>
            </div>
          </div>
        </div>
        <form [formGroup]="urlLinkDetctForm">
          <div class="R-summary">
            <div class="form-control" formControlName="snippedLinkText" [(ngModel)]="commanddata" name="message"
            id="summessage" [ngxSummernote]="config1">
          </div>
            <div class="text-danger" *ngIf="urlLinkDetctForm.controls.snippedLinkText.errors?.maxchar">
              {{FORMERROR.ABOUT_YOUR_MAX}}
            </div>
          </div>
        </form>
        <div class="kjsiopzx"
          *ngIf="linkTitle != null || linkImage != null || linkDescription != null || linkURL != null">
          <div class="djwjpbf">
            <img src="{{linkImage}}" alt="">
          </div>
          <div class="sdiuqwfp">
            <h5>{{linkTitle}}</h5>
            <div>{{linkDescription}}</div>
            <div class="sdfkfldp">
              <a href="{{linkURL}}" target="_blank">{{linkURL}}</a>
            </div>
          </div>
        </div>
        <div class="uisd" *ngIf="uploadFiles.length > 0">
          <div class="row post-img-align udlfphg">
            <carousel [noWrap]="true" [showIndicators]="false" [interval]="0">
              <slide *ngFor="let item of uploadFiles">
                <ng-container class="col-sm-6" *ngIf="item['t'] === 'image'">
                  <img [src]="item['src']" width="100%" />
                </ng-container>
                <ng-container class="col-sm-6" *ngIf="item['t'] === 'video'">
                  <video id="business_post_video_player" width="100%" controls (click)="toggleVideo()"   #videoPlayer>
                    <source [src]="item['src']" [type]="item['ft']" />
                  </video>
                </ng-container>
                <ng-container class="col-sm-6" *ngIf="item['t'] === 'others'">
                  <div class="attach-others">name</div>
                </ng-container>
              </slide>
            </carousel>
          </div>
        </div>
        <div class="row ajkl1">
          <div class="dkjgwwx">
            <label>Add to your post</label>
          </div>
          <div id="business_post_upload_photo_button" title="Photo" (click)="uploadMediaHere1('photo')">
            <!-- <ng-icon name="tablerCamera" class="tr"></ng-icon> -->
            <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="13" r="3" stroke="#6a6c6f" stroke-width="1.5" />
              <path
                d="M9.77778 21H14.2222C17.3433 21 18.9038 21 20.0248 20.2646C20.51 19.9462 20.9267 19.5371 21.251 19.0607C22 17.9601 22 16.4279 22 13.3636C22 10.2994 22 8.76721 21.251 7.6666C20.9267 7.19014 20.51 6.78104 20.0248 6.46268C19.3044 5.99013 18.4027 5.82123 17.022 5.76086C16.3631 5.76086 15.7959 5.27068 15.6667 4.63636C15.4728 3.68489 14.6219 3 13.6337 3H10.3663C9.37805 3 8.52715 3.68489 8.33333 4.63636C8.20412 5.27068 7.63685 5.76086 6.978 5.76086C5.59733 5.82123 4.69555 5.99013 3.97524 6.46268C3.48995 6.78104 3.07328 7.19014 2.74902 7.6666C2 8.76721 2 10.2994 2 13.3636C2 16.4279 2 17.9601 2.74902 19.0607C3.07328 19.5371 3.48995 19.9462 3.97524 20.2646C5.09624 21 6.65675 21 9.77778 21Z"
                stroke="#6a6c6f" stroke-width="1.5" />
              <path d="M19 10H18" stroke="#6a6c6f" stroke-width="1.5" stroke-linecap="round" />
            </svg>
            <div class="image-upload photo-icon-click mt-10">
            </div>
          </div>
          <div id="business_post_upload_video_button" title="Video" (click)="uploadMediaHere1('video')">
            <!-- <ng-icon name="tablerVideo" class="tr"></ng-icon> -->
            <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none">
              <path
                d="M12.53 20.4201H6.21C3.05 20.4201 2 18.3201 2 16.2101V7.79008C2 4.63008 3.05 3.58008 6.21 3.58008H12.53C15.69 3.58008 16.74 4.63008 16.74 7.79008V16.2101C16.74 19.3701 15.68 20.4201 12.53 20.4201Z"
                stroke="#6a6c6f" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path
                d="M19.52 17.0999L16.74 15.1499V8.83989L19.52 6.88989C20.88 5.93989 22 6.51989 22 8.18989V15.8099C22 17.4799 20.88 18.0599 19.52 17.0999Z"
                stroke="#6a6c6f" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path
                d="M11.5 11C12.3284 11 13 10.3284 13 9.5C13 8.67157 12.3284 8 11.5 8C10.6716 8 10 8.67157 10 9.5C10 10.3284 10.6716 11 11.5 11Z"
                stroke="#6a6c6f" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            <div class="image-upload1 photo-icon-click mt-10">
            </div>
          </div>
          <div title="Link">
            <!-- <ng-icon name="tablerExternalLink" class="tr" style="font-size:15px;"></ng-icon> -->
            <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none">
              <path
                d="M12.7917 15.7991L14.2223 14.3676C16.5926 11.9959 16.5926 8.15054 14.2223 5.7788C11.8521 3.40707 8.0091 3.40707 5.63885 5.7788L2.77769 8.64174C0.407436 11.0135 0.407436 14.8588 2.77769 17.2306C3.87688 18.3304 5.29279 18.9202 6.73165 19"
                stroke="#6a6c6f" stroke-width="1.5" stroke-linecap="round" />
              <path
                d="M11.2083 8.20092L9.77769 9.63239C7.40744 12.0041 7.40744 15.8495 9.77769 18.2212C12.1479 20.5929 15.9909 20.5929 18.3612 18.2212L21.2223 15.3583C23.5926 12.9865 23.5926 9.14118 21.2223 6.76945C20.1231 5.66957 18.7072 5.07976 17.2683 5"
                stroke="#6a6c6f" stroke-width="1.5" stroke-linecap="round" />
            </svg>
            <div class="image-upload12 photo-icon-click mt-10">
              <label for="file-input12">
              </label>
            </div>
          </div>

        </div>
        <div class="row uqpp">
          <button class="btn primary-btn btn-block" id="postbtn" (click)="save()">
            Post
          </button>
        </div>
      </div>

    </div>
    <div>

      <div class="common-header-flex" *ngIf="commonVariables.postPrivacyFlag">
        <div>Select {{ postviewModelName }}</div>
        <button id="business_post_select_privacy_close_wrapper_button">
          <span id="business_post_select_privacy_close_button" (click)="dismiss()" class="common-close">&times;</span>
        </button>
      </div>

      <div class="modal-body" *ngIf="commonVariables.postPrivacyFlag">
        <div class="lbl" *ngIf="networkZeroFlag">
          You are not part of any Networks
        </div>
        <div class="lbl" *ngIf="teamZeroFlag">
          You are not part of any Workspace
        </div>
        <div class="lbl" *ngIf="connectionZeroFlag">
          You do not have connections
        </div>
        <div class="lbl" *ngIf="communityZeroFlag">
          You are not part of any Communities
        </div>
        <div class="m-t-mins-9 post-search-box" *ngIf="!networkZeroFlag && !communityZeroFlag && !teamZeroFlag && !connectionZeroFlag">
          <ng-icon name="tablerSearch" class="post-search-icon"></ng-icon>
          <input type="text" class="form-control tr post-search-input" name="searchName" id="" aria-describedby="helpId"
            placeholder="Search" (keyup)="onSearch($event)" [(ngModel)]="searchName" />
        </div>
        <!-- Inline skeleton rows while the active tab's list loads. -->
        <div class="modal-scroll-list" *ngIf="modalListLoading">
          <div class="row" *ngFor="let s of [1,2,3,4,5,6]">
            <div class="col-lg-12 oi">
              <div class="row poi">
                <div class="col-sm-1">
                  <span class="gs-net-skel-avatar"></span>
                </div>
                <div class="col-sm-10">
                  <span class="gs-net-skel-line gs-net-skel-line--name"></span>
                  <span class="gs-net-skel-line gs-net-skel-line--sub"></span>
                </div>
                <div class="col-sm-1 rm">
                  <span class="gs-net-skel-check"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-scroll-list"
             *ngIf="!modalListLoading"
             [class.modal-scroll-list--capped]="(modelList?.length || 0) > 6"
             infiniteScroll
             [infiniteScrollDistance]="2"
             [infiniteScrollThrottle]="300"
             [scrollWindow]="false"
             [infiniteScrollDisabled]="postviewModelName !== 'Connections' && postviewModelName !== 'Network'"
             (scrolled)="onModalScrollDown()">
        <div class="row" *ngFor="
            let data of modelList
              | filter: searchName;
            let i = index
          ">
          <!-- Connections -->
          <div class="col-lg-12 oi" *ngIf="postviewModelName == 'Connections'">
            <div class="row poi">
              <div class="col-sm-1">
                <img *ngIf="data['photo']" class="img-profile" [src]="imgUrl + data['photo']" />
                <div *ngIf="!data['photo']">
                  <div class="circles mr-rt-10 avtar"
                    [style.background-color]="getColortwo( data?.firstName,data?.lastName)">
                    <div class="circle-text" [style.color]="getTextColor(data?.firstName, data?.lastName)" style="font-weight: bold; font-size: 16px;">{{ getInitialstwo( data?.firstName,data?.lastName) }}</div>
                  </div>
                </div>
              </div>
              <div class="col-sm-10">
                <label title="{{ data.firstName }} {{ data.lastName }} ">
                  <a class="ft-12">{{ data.firstName }} {{ data.lastName }}</a>
                </label>
                <div class="overflow-hiden-" title="{{ data.title }}">
                  {{ data.title }}
                </div>
              </div>
              <div class="col-sm-1 rm">
                <!-- <input
                  type="checkbox"
                  [(ngModel)]="data.checked"
                  value="{{ data.userId }}"
                  (change)="onCheckboxChange(data, $event)"
                /> -->
                <div class="custom-checkbox em">
                  <label class="checkbox-label font-bold" style="text-align: center">
                    <input type="checkbox" [(ngModel)]="data.checked" value="{{ data.userId }}"
                      (change)="onCheckboxChange(data, $event)" />
                    <span class="checkmark"></span>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <!-- Network -->
          <div class="col-lg-12 oi" *ngIf="postviewModelName == 'Network'">
            <div class="row poi">
              <div class="col-sm-1 p0">
                <img class="img-profile" [src]="imgUrl + data['logo']"
                  onerror="src='assets/icon/icons8-share-400.png'" />
              </div>
              <div class="col-sm-10 rm">
                <label class="overflow-hiden-" data-toggle="tooltip" data-placement="top"
                  title="{{ data.networkName }}  ">
                  <a class="ft-12">{{ data.networkName }} </a>
                </label>
              </div>
              <div class="col-sm-1 rm">
                <div class="custom-checkbox em">
                  <label class="checkbox-label font-bold" style="text-align: center">
                    <input type="checkbox" [(ngModel)]="data.checked" value="{{ data.userId }}"
                      (change)="onCheckboxChange(data, $event)" />
                    <span class="checkmark"></span>
                  </label>
                </div>
                <!-- <input type="checkbox" [(ngModel)]="data.checked" value="{{ data.userId }}"
                  (change)="onCheckboxChange(data, $event)" /> -->
                <!-- <input type="checkbox"    value="{{data.userId}}" (change)="onCheckboxChange(data,$event)"> -->
              </div>
            </div>
          </div>
          <!-- Community kjkhkjh-->
          <div *ngIf="postviewModelName == 'Community'">
            <div class="col-lg-12 oi">
              <div class="row poi">
                <div class="col-sm-1 p0">
                  <img *ngIf="data['logo']" class="img-profile" [src]="imgUrl + data['logo']" />
                  <div *ngIf="!data['logo']" class="svg-background-community">
                    <ng-icon name="tablerUsersGroup" class="svg-position"></ng-icon>
                  </div>
                </div>
                <div class="col-sm-10 rm">
                  <label class="overflow-hiden-" data-toggle="tooltip" data-placement="top"
                    title="{{ data.communityName }}  ">
                    <h6 class="fw-bold m-0">
                      <a class="ft-12"><span> {{ data.communityName }} </span> </a>
                    </h6>
                  </label>
                </div>
                <div class="col-sm-1 p0 rm">
                  <div class="custom-checkbox em">
                    <label class="checkbox-label font-bold" style="text-align: center">
                      <input type="checkbox" [(ngModel)]="data.checked" value="{{ data.userId }}"
                        (change)="onCheckboxChange(data, $event)" />
                      <span class="checkmark"></span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Skeleton rows mirror the REAL row markup of the active tab, because the
             two differ: Connections = padded avatar col + name/title (2 lines);
             Network = `p0` avatar col (logo flush left) + `.rm` text col with the
             network name only. Reusing one shape left the logo ~12px right and
             showed a second line the Network rows never have. -->
        <ng-template #skelConnectionsRow>
          <div class="col-lg-12 oi">
            <div class="row poi">
              <div class="col-sm-1"><span class="gs-net-skel-avatar"></span></div>
              <div class="col-sm-10">
                <span class="gs-net-skel-line gs-net-skel-line--name"></span>
                <span class="gs-net-skel-line gs-net-skel-line--sub"></span>
              </div>
              <div class="col-sm-1 rm"><span class="gs-net-skel-check"></span></div>
            </div>
          </div>
        </ng-template>
        <ng-template #skelNetworkRow>
          <div class="col-lg-12 oi">
            <div class="row poi">
              <div class="col-sm-1 p0"><span class="gs-net-skel-avatar gs-net-skel-avatar--network"></span></div>
              <div class="col-sm-10 rm">
                <span class="gs-net-skel-line gs-net-skel-line--name gs-net-skel-line--network"></span>
              </div>
              <div class="col-sm-1 rm"><span class="gs-net-skel-check"></span></div>
            </div>
          </div>
        </ng-template>
        <!-- Community = Network shape, except its checkbox column is `p0` too, so
             the check placeholder sits flush instead of pulled 5px left. -->
        <ng-template #skelCommunityRow>
          <div class="col-lg-12 oi">
            <div class="row poi">
              <div class="col-sm-1 p0"><span class="gs-net-skel-avatar gs-net-skel-avatar--network"></span></div>
              <div class="col-sm-10 rm">
                <span class="gs-net-skel-line gs-net-skel-line--name gs-net-skel-line--network"></span>
              </div>
              <div class="col-sm-1 p0 rm"><span class="gs-net-skel-check gs-net-skel-check--flush"></span></div>
            </div>
          </div>
        </ng-template>

        <!-- Bottom skeleton rows shown while the next page loads on scroll. -->
        <ng-container *ngIf="connectionLoadingMore || networkLoadingMore">
          <div class="row" *ngFor="let s of [1, 2]">
            <ng-container *ngTemplateOutlet="postviewModelName === 'Network' ? skelNetworkRow
              : (postviewModelName === 'Community' ? skelCommunityRow : skelConnectionsRow)"></ng-container>
          </div>
        </ng-container>
        <div class="" *ngIf="postviewModelName === 'Connections' || postviewModelName === 'Network'"></div>
        <div class="connections-lbl text-center"
             *ngIf="!modalListLoading && !connectionLoadingMore && postviewModelName === 'Connections' && !connectionsHasMore && modelList?.length > 0">
          <div class="col-sm-12">
            <ng-icon name="tablerCircleCheck" class="end-of-list-icon"></ng-icon>
          </div>
          <div class="col-sm-12">
            <p class="biase" style="padding-bottom: 2rem;">You've reached the bottom of the page</p>
          </div>
        </div>
        <div class="" *ngIf="postviewModelName === 'Connections'"></div>
        <div class="network-lbl text-center"
             *ngIf="!modalListLoading && !networkLoadingMore && postviewModelName === 'Network' && !networkHasMore && modelList?.length > 0">
          <div class="col-sm-12">
            <ng-icon name="tablerCircleCheck" class="end-of-list-icon"></ng-icon>
          </div>
          <div class="col-sm-12">
            <p class="biase"  style="padding-top: 1rem; padding-bottom: 2rem;">You've reached the bottom of the page</p>
          </div>
          <div class="network-bottom-spacer"></div>
        </div>
        <!-- Plain .lbl for every tab. The Community-only .community-lbl carried
             margin-top: -3rem, which dragged this message up over the search box;
             the Photo/Video and Edit pickers never had it, so dropping it here
             makes all four dialogs render the empty state identically. -->
        <div class="lbl"
             *ngIf="!modalListLoading && searchName && !(modelList | filter: searchName)?.length && (postviewModelName === 'Network' || postviewModelName === 'Connections' || postviewModelName === 'Community')">
          No records available!
        </div>
      </div>

      <div class="custom-panel-footer" *ngIf="commonVariables.postPrivacyFlag">
        <!-- ... -->
        <div class="panel-footer">
          <div class="footer-flex">

            <button id="business_post_privacy_cancel_button" class="btn btn-default mr-2" (click)="dismiss()">
              Cancel
            </button>

            <button id="business_post_privacy_continue_button" *ngIf="!networkZeroFlag || !communityZeroFlag || !teamZeroFlag || !connectionZeroFlag"
              class="btn btn-primary" [disabled]="checkedList.length === 0"
              (click)="savePostSelected(postviewModelName)">
              Continue
            </button>

          </div>
        </div>
      </div>

    </div>
    <!-- Email domain validation -->
    <div class="custom-panel-heading" *ngIf="commonVariables.emailDomainValidation">
      <div class="panel-heading">
        <div class="row panel-tools">
          <div class="col-sm-2">
            <button id="business_post_email_validation_close_button" type="button" class="close" aria-label="Close" (click)="closeEmailDomainValidator()">
              <span style="font-size: 26px;font-weight: 400;color:#fff;" aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
        <div class="padding-top-0 margin-bottom-5 margin-top-5" style="margin-left: 8px !important;color:#fff;">Validate
          Business Email</div>
      </div>
    </div>
    <div class="panel-body border-radius-top-left-right-6" *ngIf="commonVariables.emailDomainValidation">
      <form [formGroup]="domainForm" action="">
        <div class="app-form">
          <div class="form-group row">
            <!-- <div class="row">
              <div class="col-sm-12 domain-msg">
                It seems that none of your emails are of a business domain. You have to provide business email as your primary source of contact for creating a job. Please, provide a business email below to proceed.
              </div>
            </div> -->
            <div class="row alrt-dngr">
              <div class="alert alert-danger addd-dngr" role="alert">
                You need to have a business email address as your primary email on your profile to be able to create a
                business page.<br><br>
                Please update the same and try again.<br><br>
                A validation code will be sent to the business email address provided.<br><br>&nbsp; &nbsp; &nbsp;
                &nbsp;
                * You can always have your generic email address as secondary email, to regain access to your profile
                once you change organizations.<br><br>
                <!-- After authenticating the business email it will become your primary email address, and you will be using it for the login credentials. -->
              </div>
            </div>
            <!-- <div class="row">
              <div class="col-sm-12 domain-msg">
                It seems that your secondary email address is of a business domain. You have to consider changing it to your primary by clicking the Swap Email button below to be able to create jobs.
              </div>
            </div> -->
            <!-- <div class="row">
              <div class="col-sm-12 domain-msg">
                It seems that you have not provided a secondary email address. It will be helpful to link you back when you change your work place to authenticate your future business email domains.
              </div>
            </div> -->
            <div class="col-sm-6" style="padding-bottom: 15px;">
              <label for="priEmail" class="control-label font-bold">Primary Email</label>
              <div>{{primaryEmail}}</div>
              <!-- <input class="form-control input-sm" formControlName="priEmail" type="text"> -->
            </div>
            <div class="col-sm-6" style="padding-bottom: 15px;">
              <label for="secEmail" class="control-label font-bold">Secondary Email</label>
              <div>{{secondaryEmail}}</div>
              <!-- <input class="form-control input-sm" formControlName="secEmail" type="text"> -->
            </div>
            <div class="col-sm-12" *ngIf="!otpEmailSent" style="padding-bottom: 15px;">
              <label for="swapEmail" class="">Business Email
                Address</label>
              <input class="form-control input-sm" id="swapEmail" formControlName="swapEmail" type="text">
              <div *ngIf="
                  (domainValidatorSubmit && domainControl.swapEmail.invalid) ||
                  (domainControl.swapEmail.invalid &&
                    (domainControl.swapEmail.dirty ||
                      domainControl.swapEmail.touched))
                " class="error-msg">
                <div *ngIf="domainControl.swapEmail.errors.required">
                  Business Email is required
                </div>
                <div *ngIf="domainControl.swapEmail.errors.genericDomain">
                  Please, enter a business email domain
                </div>
                <div *ngIf="domainControl.swapEmail.errors.pattern">
                  Enter a vaild email address
                </div>
                <div *ngIf="domainControl.swapEmail.errors.emailExistsAlready">
                  That email is taken already. Please, enter a different one.
                </div>
              </div>
            </div>
            <div class="col-sm-12" style="display:flex; column-gap: 13px;
            align-items: center;" *ngIf="otpEmailSent">
              <label for="">Business Email</label>
              <!-- <span (click)="edit()" class="edit-email">(edit)</span> -->
              {{domainForm.value.swapEmail}}
            </div>
            <div class="row alrt-dngr">
              <div *ngIf="otpEmailSent" class="alert alert-info addd-dngr" role="alert">
                An authentication code has been sent to your business email. Please, enter it below.
              </div>
            </div>
            <div class="col-sm-12" *ngIf="otpEmailSent">
              <label for="domainValidationOtp" class="control-label required-field font-bold">Enter OTP</label>
              <input class="form-control input-sm" id="domainValidationOtp" formControlName="domainValidationOtp" type="text">
              <div *ngIf="
                    (domainValidatorSubmit && domainControl.domainValidationOtp.invalid) ||
                    (domainControl.domainValidationOtp.invalid &&
                      (domainControl.domainValidationOtp.dirty ||
                        domainControl.domainValidationOtp.touched))
                  " class="error-msg">
                <div *ngIf="domainControl.domainValidationOtp.errors.required">
                  Please, enter OTP.
                </div>
                <div *ngIf="domainControl.domainValidationOtp.errors.wrongDomainValidationOtp">
                  Incorrect OTP. Enter the right one.
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="custom-panel-footer" *ngIf="commonVariables.emailDomainValidation">
      <div class="panel-footer">
        <div class="shifu">
          <button id="business_post_candidate_proceed_button" class="btn  btn-primary"
            *ngIf="(userType == 'BENCH_RECRUITER' || userType == 'FREELANCE_RECRUITER' || userType == 'MANAGEMENT_TALENT_ACQUISITION') && currentEntity == 'CANDIDATE' && !otpEmailSent"
            type="submit" (click)="proceedAfterValidation('CANDIDATE')">Proceed</button>
          <button id="business_post_jobs_proceed_button" class="btn  btn-primary"
            *ngIf="(userType == 'RECRUITER' || userType == 'FREELANCE_RECRUITER' || userType == 'MANAGEMENT_TALENT_ACQUISITION') && currentEntity == 'JOBS' && !otpEmailSent"
            type="submit" (click)="proceedAfterValidation('JOBS')">Proceed</button>
          <button id="business_post_jobs_cancel_validation_button"
            *ngIf="(userType == 'RECRUITER' || userType == 'FREELANCE_RECRUITER' || userType == 'MANAGEMENT_TALENT_ACQUISITION') && currentEntity == 'JOBS' && !otpEmailSent"
            class="btn btn-default" (click)="closeValidator('JOBS')">Cancel</button>
          <button id="business_post_candidate_cancel_validation_button"
            *ngIf="(userType == 'BENCH_RECRUITER' || userType == 'FREELANCE_RECRUITER' || userType == 'MANAGEMENT_TALENT_ACQUISITION') && currentEntity == 'CANDIDATE' && !otpEmailSent"
            class="btn btn-default" (click)="closeValidator('CANDIDATE')">Cancel</button>
          <button id="business_post_jobs_validate_otp_button" class="btn  btn-primary"
            *ngIf="(userType == 'RECRUITER' || userType == 'FREELANCE_RECRUITER' || userType == 'MANAGEMENT_TALENT_ACQUISITION') && currentEntity == 'JOBS' &&  otpEmailSent"
            type="submit" (click)="validateOtp('JOBS')">Validate OTP</button>
          <button id="business_post_candidate_validate_otp_button" class="btn  btn-primary"
            *ngIf="(userType == 'BENCH_RECRUITER' || userType == 'FREELANCE_RECRUITER' || userType == 'MANAGEMENT_TALENT_ACQUISITION') && currentEntity == 'CANDIDATE' &&  otpEmailSent"
            type="submit" (click)="validateOtp('CANDIDATE')">Validate OTP</button>
        </div>
      </div>
    </div>
    <!-- Job posting -->
    <!-- <div class="slide-in from-left"> -->
    <div *ngIf="commonVariables.jobPostingFlag" [ngClass]="callMethod()">
      <!-- [@slide-in]="animState" -->
      <div class="common-header-flex">
        <div>Create Job</div>
        <button id="business_post_job_close_wrapper_button">
          <span id="business_post_job_close_button" (click)="cancelJob()" class="common-close">&times;</span>
        </button>
      </div>

      <div class="panel-body border-radius-top-left-right-6 custom-modal-body jobCandidateForm" style="background: transparent;">
        <form formValues [formGroup]="jobPostForm" id="jobfrom" formName="landingPagejobPostForm">
          <div class="app-form">
            <!-- Job Description - First Section with Professional Parsing UI -->
            <div class="row">
              <div class="col-sm-12">
                <label class="control-label required-field font-bold" style="font-weight:600;">Job Description</label>
                <p class="jd-hint-text">Paste or type your job description below and click "Parse JD" to auto-fill the form fields.</p>

                <div (paste)="onPaste3($event)" formControlName="jobDescription" id="jobSummernote"
                  [ngxSummernote]="jobDescConfig" class="note-editor.note-frame"></div>

                <!-- Validation Errors -->
                <div style="display: flex;justify-content:end; width: 100%;" *ngIf="
                  (submit && jobControls.jobDescription?.invalid) ||
                  (jobControls.jobDescription?.invalid &&
                    (jobControls.jobDescription?.dirty ||
                      jobControls.jobDescription?.touched))" class="error-msg mt-1">
                  <div *ngIf="jobControls.jobDescription?.errors?.required">
                    Job Description is required
                  </div>
                  <div *ngIf="jobControls.jobDescription?.errors?.minChar">
                    Job Description should at least have {{ JOB_DESCRIPTION.min }} Characters
                  </div>
                  <div *ngIf="jobControls.jobDescription?.errors?.maxChar">
                    Job Description can have a maximum of {{ JOB_DESCRIPTION.max }} Characters
                  </div>
                </div>

                <!-- JD Parsing Action Bar -->
                <div class="jd-parsing-action-bar" style="display: flex; width: 100%;">
                  <div class="jd-char-info">
                    <small class="char-limit">Maximum of {{ JOB_DESCRIPTION.max }} Characters allowed</small>
                  </div>

                  <div class="jd-parsing-controls">
                    <!-- Parse Button - Always visible when content exists -->
                    <button type="button"
                            class="btn btn-primary btn-sm jd-parse-btn"
                            (click)="parseJobDescription()"
                            [disabled]="isJdParsing || !jobControls.jobDescription?.value || jobControls.jobDescription?.value?.trim().length < 100">
                      <span *ngIf="!isJdParsing">
                        <ng-icon name="tablerWand" class="me-1"></ng-icon> Parse JD
                      </span>
                      <span *ngIf="isJdParsing">
                        <ng-icon name="tablerLoader2" class="me-1 spin"></ng-icon>
                        Parsing...
                      </span>
                    </button>

                    <!-- Retry Button - Shows on failure -->
                    <button type="button"
                            class="btn btn-warning btn-sm jd-retry-btn"
                            (click)="parseJobDescription()"
                            *ngIf="jdParseFailed && !isJdParsing">
                      <ng-icon name="tablerRefresh" class="me-1"></ng-icon> Retry Parse
                    </button>
                  </div>
                </div>

                <!-- Parsing Status Messages -->
                <div class="jd-parsing-status mt-2">
                  <div *ngIf="isJdParsing" class="parsing-status">
                    <ng-icon name="tablerLoader2" class="me-2 spin"></ng-icon>
                    <small class="text-info">Parsing job description...</small>
                  </div>

                  <div *ngIf="jdParseSuccess && !isJdParsing">
                    <small class="text-info">
                      Note: Please review the filled values before submitting.
                    </small>
                  </div>

                  <div *ngIf="jdParseSuccess && !isJdParsing" class="success-status">
                    <small class="text-success">
                      <ng-icon name="tablerCheck" class="me-1"></ng-icon>
                      Job description parsed successfully! Form fields have been auto-filled.
                    </small>
                  </div>

                  <div *ngIf="jdParseFailed && !isJdParsing" class="error-status">
                    <small class="text-danger">
                      <ng-icon name="tablerAlertCircle" class="me-1"></ng-icon>
                      Parsing failed. Please try again or fill the form manually.
                    </small>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group row">
              <div class="col-sm-6">
                <label for="clientName" class="control-label required-field font-bold">Job ID</label>
                <input type="text" maxlength="13" name="jobId" disabled id="jobId" formControlName="jobId"
                  class="form-control input-sm">
              </div>
              <div class="col-sm-6">
                <label for="currentorganization" [ngClass]="{'required-field': currentOrganisationRequired}"
                  class="control-label font-bold">Current Organization
                </label>
                <select class="form-control input-sm" #currentOrganization
                  (change)="OnChangeCurrentOrg(currentOrganization.value)" id="jobPostedBehalfOf" formControlName="jobPostedBehalfOf"
                  type="text">
                  <option value="null" selected disabled>Select Your Current Organization</option>
                  <option *ngFor="let organization of jobPostedBehalfOflist" [value]="organization.orgName">
                    {{organization.orgName}}</option>
                </select>
                <div *ngIf="
                    (submit && jobControls.jobPostedBehalfOf.invalid) ||
                    (jobControls.jobPostedBehalfOf.invalid &&
                      (jobControls.jobPostedBehalfOf.dirty ||
                        jobControls.jobPostedBehalfOf.touched))
                  " class="error-msg">
                  <div *ngIf="jobControls.jobPostedBehalfOf.errors.required">
                    Current Organization is required
                  </div>
                </div>
              </div>
              <div class="col-sm-6" style="padding-bottom: 15px;">
                <label for="clientType" class="control-label required-field font-bold">Client Type</label>
                <select class="form-control input-sm" (change)="onClientTypeChange($event.target.value)"
                  id="clientType" formControlName="clientType" type="text">
                  <option value="null" selected disabled>Select Client Classification </option>
                  <ng-container *ngFor="let client of clientTypeList">
                    <option [value]="client"> {{client}}</option>
                  </ng-container>
                </select>
                <div *ngIf="
                    (submit && jobControls.clientType.invalid) ||
                    (jobControls.clientType.invalid &&
                      (jobControls.clientType.dirty ||
                        jobControls.clientType.touched))
                  " class="error-msg">
                  <div *ngIf="jobControls.clientType.errors.required">
                    Client Type is required
                  </div>
                </div>
                <div class="custom-checkbox">
                  <label class="checkbox-label font-bold" style="text-align: center;margin-top: -4px;"> Show Client
                    Type
                    <input type="checkbox" name="showClientType" id="showClientType" formControlName="showClientType">
                    <span class="checkmark" style="top: 2px !important;" title="You can check or uncheck this to show or hide  client type"></span>
                  </label>
                </div>
              </div>
              <div class="col-sm-6" style="padding-bottom: 10px;">
                <label for="clientName" class="control-label required-field font-bold">Client Name</label>
                <input type="text" maxlength="76" placeholder="Organization's Name job created for" matInput
                  id="clientName" formControlName="clientName" debounceTime="1000" class="form-control" [matAutocomplete]="auto1"
                  (input)="getOrganization1(mytest1.value)" #mytest1 #filterData (paste)="onPaste1($event)" />
                <div>
                  <ng-container>
                    <mat-autocomplete #auto1="matAutocomplete" panelClass="client-name-autocomplete"
                      [hideSingleSelectionIndicator]="true">
                      <!-- Platform Business partition -->
                      <mat-optgroup label="Platform Business"
                        *ngIf="searchBarShow1 && platformOrgList1?.length > 0">
                        <mat-option *ngFor="let option of platformOrgList1 | slice: 0:20"
                          [value]="option.organizationName" (click)="onChngOrg(option)">
                          <div style="display: grid; row-gap: 0px; line-height: initial;">
                            <div>
                              <strong style="font-size: 13px; padding: 0px 6px 0px 0px;" class="ellipse">
                                {{option.organizationName}}
                              </strong>
                            </div>
                            <div style="line-height: 10px;">
                              <i>
                                <div style="font-size: 60%;">
                                  {{option.address1}}<span *ngIf="option.address1 && option.address2">{{", "}}</span>
                                  {{option.address2}}
                                </div>
                              </i>
                            </div>
                            <div style="line-height: 10px;">
                              <i>
                                <div style="font-size: 60%;">
                                  {{option.street}}<span *ngIf="option.street">{{", "}}</span>
                                  {{option.city}}<span *ngIf="option.city">{{", "}}</span>
                                  {{option.state}}<span *ngIf="option.state">{{", "}}</span>
                                  {{option.countryName}}
                                </div>
                              </i>
                            </div>
                          </div>
                        </mat-option>
                      </mat-optgroup>

                      <!-- Externally-created businesses partition -->
                      <mat-optgroup label="Client Companies"
                        *ngIf="searchBarShow1 && externalOrgList1?.length > 0">
                        <mat-option *ngFor="let option of externalOrgList1 | slice: 0:20"
                          [value]="option.organizationName" (click)="onChngOrg(option, 'EXTERNAL')">
                          <div style="display: grid; row-gap: 0px; line-height: initial;">
                            <div>
                              <strong style="font-size: 13px; padding: 0px 6px 0px 0px;" class="ellipse">
                                {{option.organizationName}}
                              </strong>
                            </div>
                          </div>
                        </mat-option>
                      </mat-optgroup>

                      <!-- Empty state — keeps the dropdown panel open with a hint
                           instead of disappearing when both partitions are empty. -->
                      <mat-option *ngIf="searchBarShow1 && clientNameSearched1
                          && (!platformOrgList1 || platformOrgList1.length === 0)
                          && (!externalOrgList1 || externalOrgList1.length === 0)"
                          disabled>
                        <span style="font-size: 12px; color: #888; font-style: italic;">
                          No matching businesses
                        </span>
                      </mat-option>
                    </mat-autocomplete>
                  </ng-container>
                </div>
                <div *ngIf="(submit && jobControls.clientName.invalid) ||
               (jobControls.clientName.invalid &&
                 (jobControls.clientName.dirty ||
                   jobControls.clientName.touched))
             " class="error-msg">
                  <div *ngIf="jobControls.clientName.errors.required">
                    Client Name is required
                  </div>
                  <div *ngIf="jobControls.clientName.errors.minword">
                    {{FORMERROR.CLIENTNAME_MIN}}
                  </div>
                  <div *ngIf="jobControls.clientName.errors.maxword">
                    {{FORMERROR.CLIENTNAME_MAX}}
                  </div>
                </div>
                <div *ngIf="jobControls.clientName.errors?.pattern && jobControls.clientName.touched" class="error-msg">
                  Enter valid Client Name
                </div>
                <div class="custom-checkbox">
                  <label class="checkbox-label font-bold" style="text-align: center;margin-top: -4px;"> Show Client
                    Name
                    <input type="checkbox" name="showClientName" id="showClientName" formControlName="showClientName">
                    <span class="checkmark" title="You can check or uncheck this to show or hide  client name"></span>
                  </label>
                </div>
              </div>
              <div class="col-sm-12 p-0" style="padding-bottom: 15px!important;">
                <div class="col-sm-6" >
                  <label for="jobClassification" class="control-label required-field font-bold">Engagement Type</label>
                  <select class="form-control input-sm" id="jobClassification" formControlName="jobClassification" type="text"
                    (change)="onengagementTypeChange($event.target.value)">
                    <option value="null" selected disabled>Select Job Classification</option>
                    <option *ngFor="let classification of engagementTypeList" [value]="classification">
                      {{classification}}</option>
                  </select>
                  <div *ngIf="
                  (submit && jobControls.jobClassification.invalid) ||
                  (jobControls.jobClassification.invalid &&
                    (jobControls.jobClassification.dirty ||
                      jobControls.jobClassification.touched))
                " class="error-msg">
                    <div *ngIf="jobControls.jobClassification.errors.required">
                      Job Classification is required
                    </div>
                  </div>
                </div>
                <div class="col-sm-6">
                  <label for="jobTitle" class="control-label required-field font-bold">Job Title</label>
                  <div  [attr.title]="selectedJobTitle">
                    <ng-select [items]="candidateJobTitleList" [inputAttrs]="{maxlength: '101'}"
                       [addTag]="true" [hideSelected]="false"
                      dropdownPosition="bottom" id="jobTitle" formControlName="jobTitle" [multiple]="false" placeholder="Job Title" [(ngModel)]="selectedJobTitle" [clearable]="true">
                      <ng-template ng-option-tmp let-item="item">
                        <div class="custom-option multi-line-option" [attr.title]="item">
                          {{ item }}
                        </div>
                      </ng-template>
                      <ng-template ng-label-tmp let-item="item" let-index="index" let-clear="clear">
                        <div class="custom-option single-line-truncate" [attr.title]="item">
                           
                          {{ item.length > 30 ? (item | slice:0:30) + '...' : item }}
                        </div>
                      </ng-template>
                    </ng-select>
                  </div>
                  <div *ngIf="
                  (submit && jobControls.jobTitle.invalid) ||
                  (jobControls.jobTitle.invalid &&
                    (jobControls.jobTitle.dirty ||
                      jobControls.jobTitle.touched))
                " class="error-msg">
                    <div *ngIf="jobControls.jobTitle.errors.required">
                      Job Title is required
                    </div>
                    <div *ngIf="jobControls.jobTitle.errors.minword">
                      {{FORMERROR.JOBTITLE_MIN}}
                    </div>
                    <div *ngIf="jobControls.jobTitle.errors.maxword">
                      {{FORMERROR.JOBTITLE_MAX}}
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-sm-12">
                <div class="row">
                  <div class="col-sm-6" style="padding-bottom: 15px;">
                    <label for="primarySkills" class="control-label required-field font-bold">Primary Skills</label>
                    <div >
                      <ng-select class="multiselectlable" [items]="primarySkillsList" [addTag]="true" [hideSelected]="false"
                        dropdownPosition="bottom" id="primarySkills" formControlName="primarySkills" maxSelectedItems="3" [multiple]="true"
                        [closeOnSelect]="false" [clearSearchOnAdd]="true" [(ngModel)]="primarySkillsSelected"
                        placeholder="e.g. Java, Spring, Hibernate">
                        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                          <div class="ng-select-checkbox-label">
                            <span class="ng-select-checkmark" [class.checked]="item$.selected"></span>
                            <span class="ng-select-checkbox-text">{{item}}</span>
                          </div>
                        </ng-template>
                      </ng-select>
                    </div>
                    <div class="flex">
                      <small style="font-size: 12px;">Enter no more than 3</small>
                    </div>
                      <div *ngIf="
                        (submit && jobControls.primarySkills.invalid) ||
                        (jobControls.primarySkills.invalid &&
                          (jobControls.primarySkills.dirty ||
                            jobControls.primarySkills.touched))
                      " class="error-msg">
                        <div *ngIf="jobControls.primarySkills.errors.required">
                          Primary Skills is required
                        </div>
                      </div>
                  </div>
                  <div class="col-sm-6" style="padding-bottom: 15px;">
                    <label for="secondarySkills" class="control-label  font-bold">Secondary Skills</label>
                    <div >
                      <ng-select class="multiselectlable" [items]="secondarySkillsList" [addTag]="true" [hideSelected]="false"
                        dropdownPosition="bottom" id="secondarySkills" formControlName="secondarySkills" maxSelectedItems="3"
                        [multiple]="true" [closeOnSelect]="false" [clearSearchOnAdd]="true"
                        [(ngModel)]="secondarySkillsSelected" placeholder="e.g. Java, Spring, Hibernate">
                        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                          <div class="ng-select-checkbox-label">
                            <span class="ng-select-checkmark" [class.checked]="item$.selected"></span>
                            <span class="ng-select-checkbox-text">{{item}}</span>
                          </div>
                        </ng-template>
                      </ng-select>
                    </div>
                    <div style="display:flex">
                      <div>
                        <small style="font-size: 12px;">Enter no more than 3</small>
                      </div>
                      <div *ngIf="
                  (submit && jobControls.secondarySkills.invalid) ||
                  (jobControls.secondarySkills.invalid &&
                    (jobControls.secondarySkills.dirty ||
                      jobControls.secondarySkills.touched))
                " class="error-msg">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 p-0" style="padding-bottom:7px;">
                <div class="col-sm-6">
                  <label for="location" class="control-label required-field font-bold">Country</label>
                  <select class="form-control input-sm" id="country" formControlName="country" type="text"
                    (change)="onChangeCountry($event.target.value, 'jobs')">
                    <option value="null" selected disabled>Country</option>
                    <option *ngFor="let country of countryList" [value]="country.countryCode">
                      {{country.countryName}}</option>
                  </select>
                  <div *ngIf="
                                (submit && jobControls.country.invalid) ||
                                (jobControls.country.invalid &&
                                  (jobControls.country.dirty ||
                                    jobControls.country.touched))
                              " class="error-msg">
                    <div *ngIf="jobControls.country.errors.required">
                      Country is required
                    </div>
                  </div>
                </div>
                <div class="col-sm-6" *ngIf="jobPostForm.value.country=='US'">
                  <label for="location" class="control-label required-field font-bold">State</label>
                  <select class="form-control input-sm" id="stateUS" formControlName="state" type="text">
                    <option value="null" selected=true disabled>State</option>
                    <option *ngFor="let state of usStatesList" [value]="state">{{state}}
                    </option>
                  </select>
                  <div *ngIf="
                            (submit && jobControls.state.invalid) ||
                            (jobControls.state.invalid &&
                              (jobControls.state.dirty ||
                                jobControls.state.touched))
                          " class="error-msg">
                    <div *ngIf="jobControls.state.errors.required">
                      State is required
                    </div>
                  </div>
                </div>
                <div class="col-sm-6" *ngIf="jobPostForm.value.country=='CA'">
                  <label for="location" class="control-label required-field font-bold">State</label>
                  <select class="form-control input-sm" id="stateCA" formControlName="state" type="text">
                    <option value="null" selected=true disabled>State</option>
                    <option *ngFor="let state of stateListCA" [value]="state.stateName">{{state.stateName}}
                    </option>
                  </select>
                  <div *ngIf="
                            (submit && jobControls.state.invalid) ||
                            (jobControls.state.invalid &&
                              (jobControls.state.dirty ||
                                jobControls.state.touched))
                          " class="error-msg">
                    <div *ngIf="jobControls.state.errors.required">
                      State is required
                    </div>
                  </div>
                </div>
                <div class="col-sm-6" *ngIf="jobPostForm.value.country=='IN'">
                  <label for="location" class="control-label required-field font-bold">State</label>
                  <select class="form-control input-sm" id="stateIN" formControlName="state" type="text">
                    <option value="null" selected=true disabled>State</option>
                    <option *ngFor="let state of stateListIN" [value]="state.stateName">{{state.stateName}}
                    </option>
                  </select>
                  <div *ngIf="
                            (submit && jobControls.state.invalid) ||
                            (jobControls.state.invalid &&
                              (jobControls.state.dirty ||
                                jobControls.state.touched))
                          " class="error-msg">
                    <div *ngIf="jobControls.state.errors.required">
                      State is required
                    </div>
                  </div>
                </div>
                <div class="col-sm-6" *ngIf="jobPostForm.value.country=='AU'">
                  <label for="location" class="control-label required-field font-bold">State</label>
                  <select class="form-control input-sm" id="stateAU" formControlName="state" type="text">
                    <option value="null" selected=true disabled>State</option>
                    <option *ngFor="let state of stateListAU" [value]="state.stateName">{{state.stateName}}
                    </option>
                  </select>
                  <div *ngIf="
                            (submit && jobControls.state.invalid) ||
                            (jobControls.state.invalid &&
                              (jobControls.state.dirty ||
                                jobControls.state.touched))
                          " class="error-msg">
                    <div *ngIf="jobControls.state.errors.required">
                      State is required
                    </div>
                  </div>
                </div>
                <div class="col-sm-6" *ngIf="jobPostForm.value.country!='AU'&&
                                                                    jobPostForm.value.country!='IN'&&
                                                                    jobPostForm.value.country!='CA'&&
                                                                    jobPostForm.value.country!='US'">
                  <label for="location" class="control-label required-field font-bold">State</label>
                  <input type="text" maxlength="51" placeholder="State" id="stateOther" formControlName="state"
                    class="form-control input-sm">
                  <div *ngIf="
                                (submit && jobControls.state.invalid) ||
                                (jobControls.state.invalid &&
                                  (jobControls.state.dirty ||
                                    jobControls.state.touched))
                              " class="error-msg">
                    <div *ngIf="jobControls.state.errors.required">
                      State is required
                    </div>
                    <div *ngIf="jobControls.state.errors.maxword">
                      {{FORMERROR.STATE_MAX}}
                    </div>
                  </div>
                </div>
                <!-- clear:both = City+Zip always start a fresh float line
                     (this copy has no .row split like job-template; without
                     the clear, a Country/State error made that column taller
                     and BS3 float-wrap staggered City/Zip). -->
                <div class="col-sm-6" style="clear: both;">
                  <label for="location" class="control-label required-field font-bold">City</label>
                  <input type="text" maxlength="51" placeholder="City" id="city" formControlName="city"
                    class="form-control input-sm">
                  <div *ngIf="
                                  (submit && jobControls.city.invalid) ||
                                  (jobControls.city.invalid &&
                                    (jobControls.city.dirty ||
                                      jobControls.city.touched))
                                " class="error-msg">
                    <div *ngIf="jobControls.city.errors.required">
                      City is required
                    </div>
                    <div *ngIf="jobControls.city.errors.maxword">p
                      {{FORMERROR.CITY_MAX}}
                    </div>
                  </div>
                </div>
                <div class="col-sm-6">
                  <label for="location" class="control-label required-field font-bold">Zip Code</label>
                  <input type="text" maxlength="12" placeholder="Zip Code" id="zipCode" formControlName="zipCode"
                    class="form-control input-sm">
                  <div *ngIf="
                                    (submit && jobControls.zipCode.invalid) ||
                                    (jobControls.zipCode.invalid &&
                                      (jobControls.zipCode.dirty ||
                                        jobControls.zipCode.touched))
                                  " class="error-msg">
                    <div *ngIf="jobControls.zipCode.errors?.required">
                      Zipcode is required
                    </div>
                    <div class="w-wrap" *ngIf="jobControls.zipCode.errors?.minword">
                      {{FORMERROR.ZIPCODE_MIN}}
                    </div>
                    <div class="w-wrap" *ngIf="jobControls.zipCode.errors?.maxword">
                      {{FORMERROR.ZIPCODE_MAX}}
                    </div>
                  </div>
                </div>  
              </div>
              <div class="col-sm-12" style="padding-bottom:7px;">
                <label for="duration" class="control-label required-field font-bold">Duration</label>
                <div class="row">
                  <div class="col-sm-6" style="padding-bottom: 15px;">
                    <select type="text" id="duration" formControlName="duration" class="form-control input-sm">
                      <option value=null disabled selected hidden>Duration</option>
                      <option *ngFor="let year of years" [value]="year">{{year}}</option>
                    </select>
                    <div *ngIf="(submit && jobControls.duration.invalid || jobControls.duration.touched)"
                      class="error-msg">
                      <div *ngIf="jobControls.duration.errors?.required">
                        Duration is required
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-6" style="padding-bottom: 15px;">
                    <select type="text" id="durationType" formControlName="durationType" class="form-control input-sm">
                      <option value=null disabled selected hidden>Type</option>
                      <option *ngFor="let durationType of durationTypeList" [value]="durationType">
                        {{durationType}}
                      </option>
                    </select>
                    <div *ngIf="(submit && jobControls.durationType.invalid || jobControls.durationType.touched)"
                      class="error-msg w-wrap">
                      <div *ngIf="jobControls.durationType.errors?.required">
                        DurationType is required
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-12">
                    <label for="duration" class="control-label required-field font-bold">Required Years of
                      Experience</label>

                  </div>
                  <div class="col-sm-6" style="padding-bottom: 15px;">
                    <select type="text" id="experienceFrom" formControlName="experienceFrom" class="form-control input-sm">
                      <option value=null [disabled]="true" selected>From</option>
                      <option *ngFor="let year of years" [value]="year" [disabled]="validateBeginning(year)">{{year}}
                      </option>
                    </select>
                    <div *ngIf="
                (submit && jobControls.experienceFrom.invalid) ||
                (jobControls.experienceFrom.invalid &&
                  (jobControls.experienceFrom.dirty ||
                    jobControls.experienceFrom.touched))
              " class="error-msg">
                      <div *ngIf="jobControls.experienceFrom.errors?.required">
                        From Year is required
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-6" style="padding-bottom: 15px;">
                    <select type="text" id="experienceTo" formControlName="experienceTo" class="form-control input-sm">
                      <option value=null [disabled]="true" selected>To</option>
                      <option *ngFor="let year of Toyears" [value]="year" [disabled]="validateLast(year)">{{year}}
                      </option>
                    </select>
                    <div *ngIf="
                (submit && jobControls.experienceTo.invalid) ||
                (jobControls.experienceTo.invalid &&
                  (jobControls.experienceTo.dirty ||
                    jobControls.experienceTo.touched))
              " class="error-msg">
                      <div *ngIf="jobControls.experienceTo.errors?.required">
                        To Year is required
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-sm-12" >
                <div class="col-sm-6 pl-0">
                  <div class="row">
                    <div class="col-sm-12" style="padding-bottom: 15px;">
                      <label for="payType" class="control-label required-field font-bold">Pay Type</label>
                      <select (change)="onChangePayType($event.target.value, 'jobs')" type="text"
                        id="payType" formControlName="payType" class="form-control input-sm">
                        <option [selected]=true value=null disabled>Choose Type</option>
                        <option *ngFor="let list of payTypeList" [value]="list">{{list}}</option>
                      </select>
                      <div *ngIf="
                                    (submit && jobControls.payType.invalid) ||
                                    (jobControls.payType.invalid &&
                                      (jobControls.payType.dirty ||
                                        jobControls.payType.touched))
                                  " class="error-msg">
                        <div style="position: relative; top: 4px;" *ngIf="jobControls.payType.errors.required">
                          Pay Type is required
                        </div>
                      </div>
                    </div>
               
                  </div>
                </div>
                <div class="col-sm-6" style="padding-right:0px;">
                      <label for="workMode" class="control-label required-field font-bold">Work Mode</label>
                      <select class="form-control input-sm" id="workMode" formControlName="workMode" type="text">
                        <option [value]="null" disabled>Select Your Work Mode</option>
                        <option value="Onsite">Onsite</option>
                        <option value="Remote">Remote</option>
                        <option value="Hybrid">Hybrid</option>
                      </select>
                      <div *ngIf="
                             (submit && jobControls.workMode.invalid) ||
                             (jobControls.workMode.invalid &&
                             (jobControls.workMode.dirty ||
                             jobControls.workMode.touched))  " class="error-msg">
                        <div *ngIf="jobControls.workMode.errors.required">
                          Work Mode is required
                        </div>
                      </div>
               
                </div>
              </div>
              <div class="col-sm-12">
                <label for="targetRateFrom" class="control-label required-field font-bold">Target Rate
                  Range</label>
              </div>
              <div class="row">
                <div class="col-sm-6" style="padding-bottom: 15px;padding-left: 30px;"> 
                    <div >
                      <input (keyup)="onTargetRateTyped($event.target.value, 'jobs')" id="targetRateFrom"
                        (keydown.enter)="$event.preventDefault()" maxlength="9" (keypress)="decimalFilter($event)"
                        type="text" class="form-control input-sm" placeholder="From"
                        formControlName="targetRateFrom">
                        <div class="input-group-append">
                            <span class="input-group-text currency-type-1">
                              <label *ngIf="jobPostForm.value.country=='US' || jobPostForm.value.country==null" for="USD"
                                class="currency-type">USD</label>
                              <label *ngIf="jobPostForm.value.country=='IN'" for="INR" class="currency-type">INR</label>
                              <label *ngIf="jobPostForm.value.country=='CA'" for="CAD" class="currency-type">CAD</label>
                              <label *ngIf="jobPostForm.value.country=='AU'" for="AUD" class="currency-type">AUD</label>
                              <label
                                *ngIf="jobPostForm.value.country!='US' && jobPostForm.value.country!='IN' && jobPostForm.value.country!='CA' && jobPostForm.value.country!='AU' && jobPostForm.value.country!=null"
                                for="CUR" class="currency-type">CUR</label>
                              </span>
                          </div>
                  </div>
                  <div *ngIf="
                  (submit && jobControls.targetRateFrom.invalid) ||
                      (jobControls.targetRateFrom.invalid &&
                        (jobControls.targetRateFrom.dirty ||
                          jobControls.targetRateFrom.touched))" class="error-msg">
                    <div *ngIf="jobControls.targetRateFrom.errors.required">
                      Target Rate is required
                    </div>
                    <div *ngIf="jobControls.targetRateFrom.errors.minword">
                      {{FORMERROR.TARGETRATE_MIN}}
                    </div>
                    <div *ngIf="jobControls.targetRateFrom.errors.maxword">
                      {{FORMERROR.TARGETRATE_MAX}}
                    </div>
                    <div
                      *ngIf="jobControls.targetRateFrom.errors?.invalidDecimal&&!jobControls.targetRateFrom.errors?.maxword">
                      {{FORMERROR.TARGETRATE_PATTERN}}
                    </div>
                  </div>
                </div>
                <div class="col-sm-6" style="padding-right: 30px;">
                  <input id="myText" (keyup)="onTargetRateTyped($event.target.value, 'jobs')"
                    (keypress)="decimalFilter($event)" type="text" maxlength="9" class="form-control input-sm"
                    placeholder="To" id="targetRate" formControlName="targetRateTo">
                      <div class="input-group-append">
                        <span class="input-group-text currency-type-2 right-16">
                        <label *ngIf="jobPostForm.value.country=='US' || jobPostForm.value.country==null" for="USD"
                          class="currency-type">USD</label>
                        <label *ngIf="jobPostForm.value.country=='IN'" for="INR" class="currency-type">INR</label>
                        <label *ngIf="jobPostForm.value.country=='CA'" for="CAD" class="currency-type">CAD</label>
                        <label *ngIf="jobPostForm.value.country=='AU'" for="AUD" class="currency-type">AUD</label>
                        <label
                          *ngIf="jobPostForm.value.country!='US' && jobPostForm.value.country!='IN' && jobPostForm.value.country!='CA' && jobPostForm.value.country!='AU' && jobPostForm.value.country!=null"
                          for="CUR" class="currency-type">CUR</label>
                        </span>
                    </div>
                  <div>
                  </div>
                  <div *ngIf="
                        (submit ) ||
                        ((jobControls.targetRateTo.dirty ||
                            jobControls.targetRateTo.touched))
                      " class="error-msg">
                    <div *ngIf="jobControls.targetRateTo.errors?.required">
                      Target Rate is required
                    </div>
                    <div *ngIf="jobControls.targetRateTo.errors?.minword">
                      {{FORMERROR.TARGETRATE_MIN}}
                    </div>
                    <div *ngIf="jobControls.targetRateTo.errors?.maxword">
                      {{FORMERROR.TARGETRATE_MAX}}
                    </div>
                    <div
                      *ngIf="jobPostForm.errors && jobPostForm?.errors?.rangevalidation&&!jobControls.targetRateFrom.errors?.invalidDecimal">
                      Invalid target rate range</div>
                    <div
                      *ngIf="jobControls.targetRateTo.errors?.invalidDecimal&&!jobControls.targetRateTo.errors?.maxword">
                      {{FORMERROR.TARGETRATE_PATTERN}}
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-sm-6"> 
                <label for="networks" class="control-label required-field font-bold">Publish To</label>
                <ng-select class="multiselectlable" [items]="networkGroups" bindLabel="name" bindValue="id"
                  placeholder="Select networks" [multiple]="true" [closeOnSelect]="false" [(ngModel)]="selectedNetworks"
                  id="selectedNetworks" formControlName="selectedNetworks" (change)="onNetworkSelectionChange(jobPostForm)">
                  <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                    <ng-container *ngIf="item.type">
                      <ng-container *ngIf="index === 0 || networkGroups[index - 1].type !== item.type">
                        <div class="networktype">{{ item.type }}</div>
                      </ng-container>

                      <div class="ng-select-checkbox-label"
                        [class.marketplace-locked]="(membershipType === 'Free' || userType === 'JOB_SEEKER') && item.id === '1'"
                        [class.permission-disabled]="item.disabled">
                        <span class="ng-select-checkmark" [class.checked]="item$.selected"></span>
                        <span class="ng-select-checkbox-text" [attr.title]="item.name">{{ item.name }}</span>
                        <ng-icon name="tablerBan" style="font-size:10px;margin-left:6px;color:#e53e3e;" *ngIf="item.disabled" title="Disabled by admin"></ng-icon>
                      </div>
                    </ng-container>
                  </ng-template>
                  <ng-template ng-label-tmp let-item="item" let-index="index" let-clear="clear">
                    <div class="selected-item" [attr.title]="item.name">
                      <span id="business_post_network_remove" class="ng-value-clear remove-icon" (click)="clear(item); $event.stopPropagation()"
                        *ngIf="!((membershipType === 'Free' || userType === 'JOB_SEEKER') && item.id === '1') && !isNetworkLocked(item.id) && !item.disabled">
                        ✕
                      </span>
                      <ng-icon name="tablerLock" style="font-size:10px;margin-right:4px;color:#8B5CF6;"
                        *ngIf="isNetworkLocked(item.id) && !item.disabled"></ng-icon>
                      <ng-icon name="tablerBan" style="font-size:10px;margin-right:4px;color:#e53e3e;"
                        *ngIf="item.disabled"></ng-icon>
                      <span class="ng-value-label">{{ item.name }}</span>
                    </div>
                  </ng-template>
                </ng-select>
                <div
                *ngIf="(submit && jobPostForm.controls.selectedNetworks.invalid) ||
                                        (jobPostForm.controls.selectedNetworks.invalid &&
                                        (jobPostForm.controls.selectedNetworks.dirty || jobPostForm.controls.selectedNetworks.touched))"
                class="error-msg">
                <div *ngIf="jobPostForm.controls.selectedNetworks.errors.required">
                  Publish to is required
                </div>
              </div>
              </div>
              <div class="col-sm-6">
                <div class="row">
                  <div class="col-sm-12">
                    <label for="securityClearance" class="control-label  font-bold">Security Clearance</label>
                  </div>
                  <div class="col-sm-12">
                    <div class="row">
                      <div class="col-sm-6" style="padding-bottom: 15px;">
                        <div class="custom-checkbox margin-top-5">
                          <label class="checkbox-label font-normal"> Yes
                            <input type="radio" [value]="true" id="securityClearanceYes" formControlName="securityClearance"
                              name="securityClearance">
                            <span title="Check Working Days" class="checkmark"></span>
                          </label>
                        </div>
                      </div>
                      <div class="col-sm-6" style="padding-bottom: 15px;">
                        <div class="custom-checkbox margin-top-5">
                          <label class="checkbox-label font-normal"> No
                            <input type="radio" [value]="false" id="securityClearanceNo" formControlName="securityClearance"
                              name="securityClearance">
                            <span title="Check Working Days" class="checkmark"></span>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Job Description section moved to top of form with JD parsing feature - commented out to avoid duplicate formControlName -->
              <!-- <div class="col-sm-12 R-summary">
                <label class="control-label required-field font-bold">Job Description </label>
                <div (paste)="onPaste3($event)" formControlName="jobDescription" id="jobSummernote"
                  [ngxSummernote]="config2" class="note-editor.note-frame"></div>
                <div *ngIf="
                (submit && jobControls.jobDescription.invalid) ||
                (jobControls.jobDescription.invalid &&
                  (jobControls.jobDescription.dirty ||
                    jobControls.jobDescription.touched))
              " class="error-msg">
                  <div *ngIf="jobControls.jobDescription.errors.required">
                    Job Description is required
                  </div>
                  <div *ngIf="jobControls.jobDescription.errors.minChar">
                    Job Description should at least have {{ JOB_DESCRIPTION.min }} Characters
                  </div>
                  <div *ngIf="jobControls.jobDescription.errors.maxChar">
                    Job Description can have a maximum of {{ JOB_DESCRIPTION.max }} Characters
                  </div>
                </div>
                <small>Maximum of{{ JOB_DESCRIPTION.max }} Characters allowed</small>
              </div> -->
            </div>
          </div>
        </form>
      </div>

      <div class="custom-panel-footer">
        <div class="panel-footer">
          <div class="footer-flex">
            <button id="business_post_job_cancel_button" [ngClass]="{'disabled': disable_for_draft==true}" class="btn btn-default"
              (click)="cancelJob()">Cancel</button>
            <button id="business_post_job_clear_button" [ngClass]="{'disabled': disable_for_draft==true}" class="btn btn-default"
              (click)="jobformreset()">Clear</button>
            <button id="business_post_job_save_draft_button" class="btn  btn-primary" type="submit" (click)="createJob('DRAFTED')"
              [disabled]="jobControls.clientName.invalid || jobControls.jobTitle.invalid||disable_for_draft==true">Save
              as Draft</button>
            <button id="business_post_job_post_button" class="btn  btn-primary" type="submit" (click)="createJob('ALL')">Post
              Job</button>
          </div>
        </div>
      </div>

    </div>
    <!-- credits availability checking -->
    <div>
      <!-- [@slide-in]="animState" -->
      <ng-container *ngIf="!showmodel ">
        <div class="common-header-flex" *ngIf="commonVariables.creditFlag">
          <div> Insufficient Credits</div>
          <button id="business_post_credits_close_wrapper_button">
            <span id="business_post_credits_close_button" class="common-close" (click)="closemodel()">×</span>
          </button>
        </div>
        <div class="panel-body border-radius-top-left-right-6 custom-modal-body" *ngIf="commonVariables.creditFlag">
          <div class="form-group row">
            <div class="row alrt-dngr">
              <div class="alert alert-danger addd-dngr" role="alert">
                You do not have enough credits. Please, purchase credits to proceed.
              </div>
            </div>
            <div class="row form-group text-center">
              <img src="assets/icon/not-enough-credits.jpg" alt="" srcset="" class="nocredits" />
            </div>
          </div>
        </div>
        <div class="custom-panel-footer">
          <div class="panel-footer" *ngIf="commonVariables.creditFlag">
            <div class="shifu">
              <button id="business_post_purchase_credits_button" class="btn  btn-primary" *ngIf="envName!='prod'" type="submit"
                (click)="routeToCredits()">Purchase Credits</button>
              <button id="business_post_credits_cancel_button" class="btn btn-default" (click)="closemodel()">Cancel</button>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
    <!-- </div> -->
    <!-- work experience validation -->
    <div *ngIf="commonVariables.workExperienceFlag">
      <app-workexperience-modal [header]="'Current Organization Details'" (ModalEmitter)="openJobOrCandidate($event)"
        (closeEmitter)="closeflagModal()" [ButtonName]="'Submit'" [content]="showContent" [supportModal]="supportModal" [expValuesReceivedFromOtherComponent]="true">
      </app-workexperience-modal>
    </div>

    <!-- education validation -->
    <div>
      <div class="custom-panel-heading" *ngIf="commonVariables.educationFlag">
        <div class="panel-heading">
          <div class="row panel-tools">
            <div class="col-sm-2">
              <button id="business_post_education_close_button" type="button" class="close" aria-label="Close" (click)="closeEducation()">
                <span style="font-size: 26px;font-weight: 400;color:#fff;" aria-hidden="true">&times;</span>
              </button>
            </div>
          </div>
          <div class="padding-top-0 margin-bottom-5 margin-top-5" style="margin-left: 8px !important;color:#fff;">Add
            Education</div>
        </div>
      </div>
      <div class="panel-body border-radius-top-left-right-6 custom-modal-body" *ngIf="commonVariables.educationFlag">
        <div class="form-group row">
          <div class="row alrt-dngr">
            <div class="alert alert-danger addd-dngr" role="alert">
              To be able to create a candidate profile for yourself, you must at least provide your education
              qualifications. Please, fill in
              your education details below to proceed.
            </div>
          </div>
        </div>
        <form [formGroup]="eduForm" class="app-form">
          <div formArrayName="educationDetail">
            <div *ngFor="let work of geteducation.controls; let i  = index; let lastItem = last;">
              <div [formGroupName]="i" class="form-horizontal">
                <div class="row">
                  <div class="form-group">
                    <label for="schoolName" class="col-sm-4 control-label required-field font-light">School / College
                      /
                      University</label>
                    <div class="col-sm-7">
                      <div class="row">
                        <div class="col-sm-12">
                          <input placeholder="School Name" class="form-control input-sm max-hight"
                            id="schoolName{{i}}" formControlName="schoolName"
                            [ngClass]="{ 'is-invalid': eduSaveFlag && getEducationFormGroup(i).controls['schoolName'].hasError }"
                            (typeaheadOnSelect)="onChangeSchool($event, i)"
                            (typeaheadNoResults)="changeTypeaheadNoResults(i, 'edu')" [typeahead]="instList"
                            [typeaheadMinLength]="1" typeaheadOptionField="institutionName"
                            [typeaheadItemTemplate]="customItemTemplate1" autocomplete="off"
                            [typeaheadOrderBy]="sortConfigEdu">
                          <ng-template #customItemTemplate1 let-model="item">
                            <span>
                              <strong style="font-size: 14px;">
                                {{model.institutionName}}
                              </strong>
                              <br>
                              <i>
                                <small>
                                  {{model.street }}<span *ngIf="model.street">{{","}}</span>
                                  {{model.city}}<span *ngIf="model.city">{{","}}</span>
                                  {{model.state}}<span *ngIf="model.state">{{","}}</span>
                                  {{model.country}}
                                </small>
                              </i>
                            </span>
                          </ng-template>
                          <div *ngIf="eduSaveFlag && getEducationFormGroup(i).controls['schoolName'].hasError ||
                                                        getEducationFormGroup(i).controls['schoolName'].hasError &&
                                                        (getEducationFormGroup(i).controls['schoolName'].dirty ||
                                                        getEducationFormGroup(i).controls['schoolName'].touched) "
                            class="error-msg">
                            <div *ngIf="getEducationFormGroup(i).controls['schoolName'].hasError('required')">
                              School is required</div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-12">
                          <div class="custom-checkbox" title="Check if this is your current education">
                            <label class="checkbox-label font-bold" style="text-align: center">Currently
                              Pursuing
                              <input type="checkbox" (change)="currentlyPursued($event, i)"
                                id="currentlyPursued{{i}}" formControlName="currentlyPursued" name="currentlyPursued"
                                [ngClass]="{ 'is-invalid': eduSaveFlag && getEducationFormGroup(i).controls['currentlyPursued'].hasError }">
                              <span class="checkmark" title="Check this if you're currently studying here"></span>
                            </label>
                          </div>
                          <div
                            style="position: absolute;  right: 170px; font-size: 12px; color: #c3002f; font-weight: 500;"
                            *ngIf="eduSaveFlag && getEducationFormGroup(i).controls['currentlyPursued'].hasError('validateEduIfChecked')">
                            Currently pursued is required
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group">
                    <label class="control-label required-field col-sm-4 font-light">Location</label>
                    <div class="col-sm-7">
                      <div class="row form-group">
                        <div class="col-sm-6 ">
                          <select class="form-control input-sm" id="eduCountry{{i}}" formControlName="country" type="text"
                            (change)="onChangeCountry($event.target.value,'edu')"
                            [ngClass]="{ 'is-invalid': eduSaveFlag && getEducationFormGroup(i).controls['country'].hasError }">
                            <option value="null" selected disabled>Country</option>
                            <option *ngFor="let country of countryList" [value]="country.countryCode">
                              {{country.countryName}}
                            </option>
                          </select>
                          <div *ngIf="eduSaveFlag && getEducationFormGroup(i).controls['country'].hasError ||
                                                        getEducationFormGroup(i).controls['country'].hasError &&
                                                        (getEducationFormGroup(i).controls['country'].dirty ||
                                                        getEducationFormGroup(i).controls['country'].touched) "
                            class="error-msg">
                            <div *ngIf="getEducationFormGroup(i).controls['country'].hasError('required')">
                              Country is required</div>
                          </div>
                        </div>
                        <div class="col-sm-6" *ngIf="educationDetail.value[i].country=='US'">
                          <input type="text" maxlength="12" (keypress)="digitKeyOnly($event)" placeholder="Zipcode"
                            id="eduZipcode{{i}}" formControlName="zipcode" class="form-control input-sm" (keyup)="onKeyZip($event,'edu', i)"
                            [ngClass]="{ 'is-invalid': eduSaveFlag && getEducationFormGroup(i).controls['zipcode'].hasError }">
                          <div *ngIf="eduSaveFlag && getEducationFormGroup(i).controls['zipcode'].hasError ||
                                                 getEducationFormGroup(i).controls['zipcode'].hasError &&
                                                 (getEducationFormGroup(i).controls['zipcode'].dirty ||
                                                 getEducationFormGroup(i).controls['zipcode'].touched) "
                            class="error-msg">
                            <div *ngIf="getEducationFormGroup(i).controls['zipcode'].hasError('pattern')">
                              Numbers only please</div>
                            <div *ngIf="getEducationFormGroup(i).controls['zipcode'].hasError('required')">
                              Zip code is required</div>
                            <div *ngIf="getEducationFormGroup(i).controls['zipcode'].hasError('minword')">
                              <div class="zip-min"></div>
                            </div>
                            <div *ngIf="getEducationFormGroup(i).controls['zipcode'].hasError('maxword')">
                              <div class="zip-max"></div>
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-6" *ngIf="educationDetail.value[i].country=='IN'">
                          <select class="form-control input-sm" id="eduStateIN{{i}}" formControlName="state" type="text"
                            [ngClass]="{ 'is-invalid': eduSaveFlag && getEducationFormGroup(i).controls['state'].hasError }">
                            <option value="null" selected disabled>State</option>
                            <option *ngFor="let state of stateListIN" [value]="state.stateName">{{state.stateName}}
                            </option>
                          </select>
                          <div *ngIf="eduSaveFlag && getEducationFormGroup(i).controls['state'].hasError ||
                                                 getEducationFormGroup(i).controls['state'].hasError &&
                                                 (getEducationFormGroup(i).controls['state'].dirty ||
                                                 getEducationFormGroup(i).controls['state'].touched) "
                            class="error-msg">
                            <div *ngIf="getEducationFormGroup(i).controls['state'].hasError('required')">
                              State is required</div>
                          </div>
                        </div>
                        <div class="col-sm-6" *ngIf="educationDetail.value[i].country=='CA'">
                          <select class="form-control input-sm" id="eduStateCA{{i}}" formControlName="state" type="text"
                            [ngClass]="{ 'is-invalid': eduSaveFlag && getEducationFormGroup(i).controls['state'].hasError }">
                            <option value="null" selected disabled>State</option>
                            <option *ngFor="let state of stateListCA" [value]="state.stateName">{{state.stateName}}
                            </option>
                          </select>
                          <div *ngIf="eduSaveFlag && getEducationFormGroup(i).controls['state'].hasError ||
                                                 getEducationFormGroup(i).controls['state'].hasError &&
                                                 (getEducationFormGroup(i).controls['state'].dirty ||
                                                 getEducationFormGroup(i).controls['state'].touched) "
                            class="error-msg">
                            <div *ngIf="getEducationFormGroup(i).controls['state'].hasError('required')">
                              State is required</div>
                          </div>
                        </div>
                        <div class="col-sm-6" *ngIf="educationDetail.value[i].country=='AU'">
                          <select class="form-control input-sm" id="eduStateAU{{i}}" formControlName="state" type="text"
                            [ngClass]="{ 'is-invalid': eduSaveFlag && getEducationFormGroup(i).controls['state'].hasError }">
                            <option value="null" selected disabled>State</option>
                            <option *ngFor="let state of stateListAU" [value]="state.stateName">{{state.stateName}}
                            </option>
                          </select>
                          <div *ngIf="eduSaveFlag && getEducationFormGroup(i).controls['state'].hasError ||
                                                 getEducationFormGroup(i).controls['state'].hasError &&
                                                 (getEducationFormGroup(i).controls['state'].dirty ||
                                                 getEducationFormGroup(i).controls['state'].touched) "
                            class="error-msg">
                            <div *ngIf="getEducationFormGroup(i).controls['state'].hasError('required')">
                              State is required</div>
                          </div>
                        </div>
                        <div class="col-sm-6" *ngIf="educationDetail.value[i].country!='AU'&&
                                                                            educationDetail.value[i].country!='CA'&&
                                                                            educationDetail.value[i].country!='IN'&&
                                                                            educationDetail.value[i].country!='US'">
                          <input id="eduStateOther{{i}}" formControlName="state" maxlength="51" class="form-control input-sm"
                            placeholder="State"
                            [ngClass]="{ 'is-invalid': eduSaveFlag && getEducationFormGroup(i).controls['state'].hasError }">
                          <div *ngIf="eduSaveFlag && getEducationFormGroup(i).controls['state'].hasError ||
                                                 getEducationFormGroup(i).controls['state'].hasError &&
                                                 (getEducationFormGroup(i).controls['state'].dirty ||
                                                 getEducationFormGroup(i).controls['state'].touched) "
                            class="error-msg">
                            <div *ngIf="getEducationFormGroup(i).controls['state'].hasError('required')">
                              State is required
                            </div>
                            <div *ngIf="getEducationFormGroup(i).controls['state'].hasError('maxword')">
                              {{FORMERROR.STATE_MAX}}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row form-group">
                        <div class="col-sm-6" *ngIf="educationDetail.value[i].country=='US'">
                          <input disabled type="text" placeholder="City" id="eduCityUS{{i}}" formControlName="city"
                            class="form-control input-sm"
                            [ngClass]="{ 'is-invalid': eduSaveFlag && getEducationFormGroup(i).controls['city'].hasError }">
                          <div *ngIf="eduSaveFlag && getEducationFormGroup(i).controls['city'].hasError ||
                                                getEducationFormGroup(i).controls['city'].hasError &&
                                                (getEducationFormGroup(i).controls['city'].dirty ||
                                                getEducationFormGroup(i).controls['city'].touched) " class="error-msg">
                            <div *ngIf="getEducationFormGroup(i).controls['city'].hasError('required')">
                              City is required</div>
                          </div>
                        </div>
                        <div class="col-sm-6" *ngIf="educationDetail.value[i].country!='US'">
                          <input type="text" placeholder="City" id="eduCity{{i}}" formControlName="city" class="form-control input-sm"
                            [ngClass]="{ 'is-invalid': eduSaveFlag && getEducationFormGroup(i).controls['city'].hasError }">
                          <div *ngIf="eduSaveFlag && getEducationFormGroup(i).controls['city'].hasError ||
                                                getEducationFormGroup(i).controls['city'].hasError &&
                                                (getEducationFormGroup(i).controls['city'].dirty ||
                                                getEducationFormGroup(i).controls['city'].touched) " class="error-msg">
                            <div *ngIf="getEducationFormGroup(i).controls['city'].hasError('required')">
                              City is required</div>
                          </div>
                        </div>
                        <div class="col-sm-6" *ngIf="educationDetail.value[i].country=='US'">
                          <input disabled id="eduStateUS{{i}}" formControlName="state" class="form-control input-sm" placeholder="State"
                            [ngClass]="{ 'is-invalid': eduSaveFlag && getEducationFormGroup(i).controls['state'].hasError }">
                          <div *ngIf="eduSaveFlag && getEducationFormGroup(i).controls['state'].hasError ||
                                                getEducationFormGroup(i).controls['state'].hasError &&
                                                (getEducationFormGroup(i).controls['state'].dirty ||
                                                getEducationFormGroup(i).controls['state'].touched) "
                            class="error-msg">
                            <div *ngIf="getEducationFormGroup(i).controls['state'].hasError('required')">
                              State is required
                            </div>
                            <div *ngIf="getEducationFormGroup(i).controls['state'].hasError('maxword')">
                              {{FORMERROR.STATE_MAX}}
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-6" *ngIf="educationDetail.value[i].country!='US'">
                          <!-- <input type="text" class="form-control input-sm" placeholder="Zipcode" formControlName="zipcode"> -->
                          <input type="text" maxlength="11" (keypress)="digitKeyOnly($event)" placeholder="Zipcode"
                            id="eduZipcodeNonUS{{i}}" formControlName="zipcode" class="form-control input-sm"
                            [ngClass]="{ 'is-invalid': eduSaveFlag && getEducationFormGroup(i).controls['zipcode'].hasError }">
                          <div *ngIf="eduSaveFlag && getEducationFormGroup(i).controls['zipcode'].hasError ||
                                              getEducationFormGroup(i).controls['zipcode'].hasError &&
                                              (getEducationFormGroup(i).controls['zipcode'].dirty ||
                                              getEducationFormGroup(i).controls['zipcode'].touched) "
                            class="error-msg">
                            <div *ngIf="getEducationFormGroup(i).controls['zipcode'].hasError('pattern')"> Numbers only
                              please</div>
                            <div *ngIf="getEducationFormGroup(i).controls['zipcode'].hasError('required')"> Zip code is
                              required</div>
                            <div class="w-wrap"
                              *ngIf="getEducationFormGroup(i).controls['zipcode'].hasError('minword')"> zipcode
                              <div class="zip-min"></div>
                            </div>
                            <div class="w-wrap"
                              *ngIf="getEducationFormGroup(i).controls['zipcode'].hasError('maxword')"> zipcode
                              <div class="zip-max"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-12">
                          <input type="text" placeholder="Street/Road/Nearby Landmark" id="eduStreet{{i}}" formControlName="street"
                            class="form-control input-sm"
                            [ngClass]="{ 'is-invalid': eduSaveFlag && getEducationFormGroup(i).controls['street'].hasError }">
                          <div *ngIf="eduSaveFlag && getEducationFormGroup(i).controls['street'].hasError ||
                                            getEducationFormGroup(i).controls['street'].hasError &&
                                            (getEducationFormGroup(i).controls['street'].dirty ||
                                            getEducationFormGroup(i).controls['street'].touched) " class="error-msg">
                            <div *ngIf="getEducationFormGroup(i).controls['street'].hasError('required')">
                              Street is required</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group">
                    <label for="degree" class="col-sm-4 control-label required-field font-light">Degree</label>
                    <!-- <label for="degree" *ngIf="!commonVariables?.studentFlag"
                                            class="col-sm-4 control-label font-light">Degree</label> -->
                    <div class="col-sm-7">
                      <input type="text" class="form-control input-sm" placeholder="Degree" id="degree{{i}}" formControlName="degree"
                        trim="blur"
                        [ngClass]="{ 'is-invalid': eduSaveFlag && getEducationFormGroup(i).controls['degree'].hasError }">
                      <div *ngIf="eduSaveFlag && getEducationFormGroup(i).controls['degree'].hasError ||
                                       getEducationFormGroup(i).controls['degree'].hasError &&
                                       (getEducationFormGroup(i).controls['degree'].dirty ||
                                       getEducationFormGroup(i).controls['degree'].touched) " class="error-msg">
                        <div *ngIf="getEducationFormGroup(i).controls['degree'].hasError('required')">
                          Degree is required</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group">
                    <label for="speciality" class="col-sm-4 required-field control-label font-light">Speciality</label>
                    <!-- <label for="speciality" *ngIf="!commonVariables?.studentFlag"
                                            class="col-sm-4 control-label font-light">Speciality</label> -->
                    <div class="col-sm-7">
                      <input type="text" class="form-control input-sm" placeholder="Speciality"
                        id="speciality{{i}}" formControlName="speciality" trim="blur"
                        [ngClass]="{ 'is-invalid': eduSaveFlag && getEducationFormGroup(i).controls['speciality'].hasError }">
                      <div *ngIf="eduSaveFlag && getEducationFormGroup(i).controls['speciality'].hasError ||
                                        getEducationFormGroup(i).controls['speciality'].hasError &&
                                        (getEducationFormGroup(i).controls['speciality'].dirty ||
                                        getEducationFormGroup(i).controls['speciality'].touched) " class="error-msg">
                        <div *ngIf="getEducationFormGroup(i).controls['speciality'].hasError('required')">
                          Speciality is required</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group">
                    <label class="control-label required-field col-sm-4 font-light">From
                      Date</label>
                    <!-- <label *ngIf="!commonVariables?.studentFlag" class="control-label col-sm-4 font-light">From
                                            Date</label> -->
                    <div class="col-sm-7">
                      <div class="row">
                        <div class="col-sm-6">
                          <select type="text" id="startMonth{{i}}" formControlName="startMonth" class="form-control input-sm"
                            (change)="monthChange(i,'edu')"
                            [ngClass]="{ 'is-invalid': eduSaveFlag && getEducationFormGroup(i).controls['startMonth'].hasError }">
                            <option value="null" selected disabled>Month</option>
                            <option *ngFor="let month of months" [value]="month.name"
                              [disabled]="checkMonth1(month.code,i,'edu')">{{month.name}}
                            </option>
                          </select>
                          <div *ngIf="eduSaveFlag && getEducationFormGroup(i).controls['startMonth'].hasError ||
                                        getEducationFormGroup(i).controls['startMonth'].hasError &&
                                        (getEducationFormGroup(i).controls['startMonth'].dirty ||
                                        getEducationFormGroup(i).controls['startMonth'].touched) " class="error-msg">
                            <div *ngIf="getEducationFormGroup(i).controls['startMonth'].hasError('required')">
                              From date is required</div>
                          </div>
                        </div>
                        <div class="col-sm-6">
                          <select type="text" id="startYear{{i}}" formControlName="startYear" class="form-control input-sm"
                            (change)="yearChange(i,$event,'edu',null)"
                            [ngClass]="{ 'is-invalid': eduSaveFlag && getEducationFormGroup(i).controls['startYear'].hasError }">
                            <option value="null" disabled>Year</option>
                            <option *ngFor="let year of years1" [value]="year">{{year}}
                            </option>
                          </select>
                          <div *ngIf="eduSaveFlag && getEducationFormGroup(i).controls['startYear'].hasError ||
                                                  getEducationFormGroup(i).controls['startYear'].hasError &&
                                                  (getEducationFormGroup(i).controls['startYear'].dirty ||
                                                  getEducationFormGroup(i).controls['startYear'].touched) "
                            class="error-msg">
                            <div *ngIf="getEducationFormGroup(i).controls['startYear'].hasError('required')">
                              Start Year is required</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row" *ngIf="educationDetail.value[i].currentlyPursued==false">
                  <div class="form-group">
                    <label class="control-label required-field col-sm-4 font-light">To Date</label>
                    <!-- <label *ngIf="!commonVariables?.studentFlag" class="control-label  col-sm-4 font-light">To
                                            Date</label> -->
                    <div class="col-sm-7">
                      <div class="row form-group">
                        <div class="col-sm-6">
                          <select type="text" id="endMonth{{i}}" formControlName="endMonth" class="form-control input-sm"
                            [ngClass]="{ 'is-invalid': eduSaveFlag && getEducationFormGroup(i).controls['endMonth'].hasError }">
                            <option value="null" selected disabled>Month</option>
                            <option *ngFor="let month of months" [value]="month.name"
                              [disabled]="checkMonth(month.code,i,'edu')">{{month.name}}
                            </option>
                          </select>
                          <div *ngIf="eduSaveFlag && getEducationFormGroup(i).controls['endMonth'].hasError ||
                                                getEducationFormGroup(i).controls['endMonth'].hasError &&
                                                (getEducationFormGroup(i).controls['endMonth'].dirty ||
                                                getEducationFormGroup(i).controls['endMonth'].touched) "
                            class="error-msg">
                            <div *ngIf="getEducationFormGroup(i).controls['endMonth'].hasError('required')">
                              To date is required</div>
                          </div>
                        </div>
                        <div class="col-sm-6">
                          <select type="text" id="endYear{{i}}" formControlName="endYear" class="form-control input-sm"
                            (change)="onChangeYear(i,'edu', null)"
                            [ngClass]="{ 'is-invalid': eduSaveFlag && getEducationFormGroup(i).controls['endYear'].hasError }">
                            <option value="null" disabled>Year</option>
                            <option *ngFor="let year of years1" [value]="year" [disabled]="checkYear(year,i,'edu')">
                              {{year}}</option>
                          </select>
                          <div *ngIf="eduSaveFlag && getEducationFormGroup(i).controls['endYear'].hasError ||
                                                    getEducationFormGroup(i).controls['endYear'].hasError &&
                                                    (getEducationFormGroup(i).controls['endYear'].dirty ||
                                                    getEducationFormGroup(i).controls['endYear'].touched) "
                            class="error-msg">
                            <div *ngIf="getEducationFormGroup(i).controls['endYear'].hasError('required')">
                              End Year is required</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <hr *ngIf="!lastItem"> -->
            </div>
          </div>
        </form>
      </div>
      <div class="custom-panel-footer" *ngIf="commonVariables.educationFlag">
        <div class="panel-footer">
          <div class="shifu">
            <button id="business_post_save_education_button" class="btn  btn-primary" type="submit" (click)="saveEducation()">Add
              Education</button>
            <button id="business_post_education_cancel_button" class="btn btn-default" (click)="closeEducation()">Cancel</button>
          </div>
        </div>
      </div>
    </div>
    <!-- Candidate posting -->
    <div *ngIf="commonVariables.candidatePostingFlag" [ngClass]="callMethod()">
      <!-- [@slide-in]="animState2" -->
      <div class="common-header-flex">
        <div>Create Candidate</div>
        <div *ngIf="parseSuccess" class="parsed-indicator">
          <ng-icon name="tablerCircleCheck" class="text-success"></ng-icon>
          <small class="text-success">Resume data parsed successfully</small>
        </div>
        <button id="business_post_candidate_close_wrapper_button">
          <span id="business_post_candidate_close_button" class="common-close" (click)="cancelcloseCandidate()">&times;</span>
        </button>
      </div>

      <div class="panel-body border-radius-top-left-right-6 custom-modal-body jobCandidateForm" style="background: transparent;"
        *ngIf="commonVariables.candidatePostingFlag">
        <form formValues [formGroup]="candidatePostForm" id="candidatefrom" formName="landingPagecandidatePostForm"
          formId action="">
          <div class="flecs">
            <div class="row">
              <div class="col-sm-3 griddd">
                <img *ngIf="fileshow" src="{{fileshow}}" class="candidate-image" alt="">
                <div *ngIf="!fileshow && candidatePostForm.value.firstName && candidatePostForm.value.lastName">
                  <div class="createcandcircles"
                    [style.background-color]="getColortwo(candidatePostForm.value.firstName, candidatePostForm.value.lastName)">
                    <div style="padding-top:18px;" class="circle-text" [style.color]="getTextColor(candidatePostForm.value.firstName, candidatePostForm.value.lastName)">
                      {{ getInitialstwo(candidatePostForm.value.firstName, candidatePostForm.value.lastName) }}
                    </div>
                  </div>
                </div>
                <!-- Empty placeholder when no photo and no name entered yet -->
                <img *ngIf="!fileshow && !(candidatePostForm.value.firstName && candidatePostForm.value.lastName)"
                  src="assets/images/userAvatar.png" class="candidate-image" alt="User Avatar" />

                <div>
                  <div id="business_post_candidate_upload_photo_div" (keydown.enter)="$event.preventDefault()">
                    <button id="business_post_candidate_upload_photo_button" class="btn  btn-primary upload-button-908"  (click)="uploadPhotoHere()"> Upload Photo </button>
                  </div>
                </div>
                <div>
                  <b *ngIf="candidatePostForm.value.candidateId != null">{{candidatePostForm.value.candidateId}}</b>
                </div>
              </div>
              <!-- <div class="col-sm-9">
                <div class="dropdox-908" appDnd (fileDropped)="onFileDropped($event)" for="fileDropRef">
                  <input style="display: none" accept=".pdf,.doc,.docx,.txt,.jpg,.jpeg,.png" type="file" #fileDropRef id="fileDropRef"
                    (change)="fileBrowseHandler($event.target.files)" /> 
                  <div class="file-icon-908" for="fileDropRef">
                    <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                      <polyline points="14 2 14 8 20 8"></polyline>
                      <line x1="12" y1="18" x2="12" y2="12"></line>
                      <line x1="9" y1="15" x2="15" y2="15"></line>
                    </svg>
                  </div>
                  
                  <div>
                    <label for="fileDropRef" class="upload-title-908">Upload Your Resume</label>
                  </div>
                  
                  <div>
                    <label for="fileDropRef" class="upload-instruction-908">Drag your files here or click in this area.</label>
                  </div>
                  
                  <div>
                    <small class="upload-hint-908">Only PDF, DOCX, DOC, and TXT file formats supported.</small>
                  </div>
                  
                  <div *ngIf="fileDragdrop" class="file-preview-908 file-preview-entered-908">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path>
                      <polyline points="13 2 13 9 20 9"></polyline>
                    </svg>
                    <span class="file-name-908">{{fileDragdrop?.name | truncate: 28}}</span> 
                    <ng-icon name="tablerX" id="business_post_candidate_remove_file_button" class="svg-position file-remove-908"  (click)="removeFiles()"></ng-icon>
  
                  </div>
                </div>
              </div> -->
              <div class="col-sm-9">
                <div class="dropdox-908" 
                     appDnd 
                     (fileDropped)="onFileDropped($event)" 
                     for="fileDropRef">
                  <input 
                    #fileDropRef 
                    style="display: none" 
                    type="file" 
                    accept=".pdf,.doc,.docx,.txt,.jpg,.jpeg,.png" 
                    id="fileDropRef"
                    (change)="fileBrowseHandler($event.target.files)" />
                    
                  <div class="file-icon-908">
                    <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                      <polyline points="14 2 14 8 20 8"></polyline>
                      <line x1="12" y1="18" x2="12" y2="12"></line>
                      <line x1="9" y1="15" x2="15" y2="15"></line>
                    </svg>
                  </div>
                  <div>
                    <label class="upload-title-908" for="fileDropRef">Upload Your Resume</label>
                  </div>
                  <div>
                    <label class="upload-instruction-908" for="fileDropRef" id="aad">Drag your files here or click in this area.</label>
                  </div>
                  <div for="fileDropRef">
                    <small class="upload-hint-908">Only PDF, DOCX, DOC, and TXT file formats supported.</small>
                  </div>

                  <!-- Upload Progress Bar - Shows immediately during file upload -->
                  <div *ngIf="isUploading" class="upload-progress-container-908">
                    <div class="upload-progress-info-908">
                      <span class="uploading-text-908">Parsing Resume...</span>
                      <span class="upload-percentage-908">{{uploadProgress}}%</span>
                    </div>
                    <div class="progress-bar-wrapper-908">
                      <div class="progress-bar-908" [style.width.%]="uploadProgress"></div>
                    </div>
                  </div>

                  <div *ngIf="fileDragdrop" class="file-preview-908 file-preview-entered-908">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path>
                      <polyline points="13 2 13 9 20 9"></polyline>
                    </svg>
                    <span class="file-name-908" [title]="fileDragdrop?.fileName || fileDragdrop?.name">{{fileDragdrop?.fileName || fileDragdrop?.name}}</span>
                    <ng-icon name="tablerX" id="business_post_candidate_remove_file_button2" class="file-remove-908" (click)="removeFiles()"></ng-icon>
                  </div>

                  <!-- Resume Parsing Status Section -->
                  <div class="mt-3" *ngIf="fileDragdrop">
                    <!-- Show parsing status when in progress -->
                    <div *ngIf="isParsing" class="parsing-status mb-2">
                      <span class="spinner-border spinner-border-sm me-2" role="status"></span>
                      <small class="text-info">Parsing resume automatically...</small>
                    </div>

                    <!-- Show retry button only when parsing fails -->
                    <button id="business_post_candidate_retry_parse_resume_button" type="button"
                            class="btn btn-warning btn-sm"
                            (click)="parseResume()"
                            *ngIf="parseFailed && !isParsing">
                      <ng-icon name="tablerRefresh" class="me-1"></ng-icon>
                      Retry Parse Resume
                    </button>

                    <!-- Show success status when parsing succeeds -->
                    <div *ngIf="parseSuccess && !isParsing" class="success-status">
                      <small class="text-success">
                        <ng-icon name="tablerCircleCheck" class="me-1"></ng-icon>
                        Resume parsed successfully! Form fields have been auto-filled.
                      </small>
                    </div>
                  </div>

                </div>

                <!-- Resume Upload Validation Error Message -->
                <!-- <div *ngIf="(candidateSubmit && !resumeupload) && !fileDragdrop.file" 
                  class="error-msg" style="margin-top: 10px;">
                  <div>Resume upload is required</div>
                </div> -->

              </div>


            </div>
          </div>

          <!-- <div class="row"> -->
          <!-- <div class="files-list" *ngIf="fileDragdrop">
            <div class="single-file">
              <div class="file-icon" style="width: 50px"></div>
              <div class="info">
                <h6 class="name m-0">
                  {{ fileDragdrop?.name }}
                </h6>
                <p id="business_post_candidate_download_button" title="Download" class="cursor-pointer top-eye" (click)="onDownload()">
                  <ng-icon name="tablerDownload" aria-hidden="true"></ng-icon>
                </p>
                <div id="business_post_candidate_remove_file_button3" title="Remove File" (click)="removeFiles()" class="tiimes">x</div>
              </div>
            </div>
          </div> -->
          <!-- </div> -->
          <div class="app-form">
            <div class="form-group">
              <div class="col-sm-12">
                <div class="row">
                  <div class="col-sm-12 p-0">
                    <div class="col-sm-6" style="padding-bottom: 15px;">
                      <label for="firstName" class="control-label required-field font-bold">First Name</label>
                      <input type="text" (keydown.enter)="$event.preventDefault()" (keypress)="checkspace($event)"
                        class="form-control input-sm" maxlength="21" placeholder="First Name" id="firstName"
                        formControlName="firstName">
                      <div *ngIf="
                 (candidateSubmit && candidateControls.firstName.invalid) ||
                 (candidateControls.firstName.invalid &&
                   (candidateControls.firstName.dirty ||
                     candidateControls.firstName.touched))
               ">
                        <div class="error-msg w-wrap" *ngIf="candidateControls.firstName.errors.required">
                          First Name is required
                        </div>
                        <div class="error-msg w-wrap " *ngIf="candidateControls.firstName.errors?.minword">
                          {{FORMERROR.FIRSTNAME_MIN}}
                        </div>
                        <div class="error-msg w-wrap " *ngIf="candidateControls.firstName.errors?.maxword">
                          {{FORMERROR.FIRSTNAME_MAX}}
                        </div>
                      </div>
                      <div
                        *ngIf="candidateControls.firstName.errors?.pattern && !candidateControls.firstName.errors?.maxword"
                        class="error-msg">
                        Enter valid first Name
                      </div>
                    </div>
                    <div class="col-sm-6" style="padding-bottom: 15px;">
                      <label for="lastName" class="control-label required-field font-bold">Last Name</label>
                      <input type="text" class="form-control input-sm" maxlength="41" placeholder="Last Name"
                        id="lastName" formControlName="lastName" (keydown.enter)="$event.preventDefault()"
                        (keypress)="checkspace($event)">
                      <div *ngIf="
                 (candidateSubmit && candidateControls.lastName.invalid) ||
                 (candidateControls.lastName.invalid &&
                   (candidateControls.lastName.dirty ||
                     candidateControls.lastName.touched))
               ">
                        <div class="error-msg" *ngIf="candidateControls.lastName.errors.required">
                          Last Name is required
                        </div>
                        <div class="error-msg w-wrap " *ngIf="candidateControls.lastName.errors?.minword">
                          {{FORMERROR.LASTNAME_MIN}}
                        </div>
                        <div class="error-msg w-wrap " *ngIf="candidateControls.lastName.errors?.maxword">
                          {{FORMERROR.LASTNAME_MAX}}
                        </div>
                      </div>
                      <div
                        *ngIf="candidateControls.lastName.errors?.pattern && !candidateControls.lastName.errors?.maxword"
                        class="error-msg">
                        Enter valid Last Name
                      </div>
                    </div> 
                  </div>
                  <div class="col-sm-12 p-0">
                    <div class="col-sm-6" style="padding-bottom: 15px;">
                      <label for="phone" class="control-label required-field font-bold">Phone</label>
                      <input (keydown.enter)="$event.preventDefault()" type="text" class="form-control input-sm"
                        placeholder="Phone" id="phone" formControlName="phone" maxlength="16">
                      <div *ngIf="
                                     (candidateSubmit && candidateControls.phone.invalid) ||
                                     (candidateControls.phone.invalid &&
                                      (candidateControls.phone.dirty ||
                                     candidateControls.phone.touched))
                                     " class="error-msg">
                        <div *ngIf="candidateControls.phone.errors.required">
                          Phone Number is required
                        </div>
                      </div>
                      <div class="error-msg" *ngIf="candidateControls.phone.errors?.maxword">
                        {{FORMERROR.PHONE_MAX}}
                      </div>
                      <div class="error-msg"
                        *ngIf="candidateControls.phone.errors?.minword && !candidateControls.phone.errors?.pattern">
                        {{FORMERROR.PHONE_MIN}}
                      </div>
                      <div class="error-msg"
                        *ngIf="candidateControls.phone.errors?.pattern && !candidateControls.phone.errors?.maxword ">
                        {{FORMERROR.NUMBER_PATTERN}}
                      </div>
                    </div>
                    <div class="col-sm-6" style="padding-bottom: 15px;">
                      <label for="clientName" class="control-label  required-field font-bold">Email ID</label>
                      <input maxlength="51" (keydown.enter)="$event.preventDefault()" type="text"
                        class="form-control input-sm" (input)="patchEmail()" placeholder="Email ID" id="email"
                        formControlName="email">
                      <div *ngIf="
                        (candidateSubmit && candidateControls.email.invalid) ||
                        (candidateControls.email.invalid &&
                          (candidateControls.email.dirty ||
                            candidateControls.email.touched))
                      " class="w-wrap">
                        <div class="error-msg" *ngIf="candidateControls.email.errors.existingEmailAddress">
                          This email already taken
                        </div>
                        <div class="error-msg" *ngIf="candidateControls.email?.errors?.required">
                          Email ID is required
                        </div>
                        <div class="error-msg"
                          *ngIf=" candidateControls.email.errors.pattern && !candidateControls.email.errors.maxword">
                          {{FORMERROR.EMAIL_VALID}}
                        </div>
                        <div class="error-msg" *ngIf="candidateControls.email.errors.maxword">
                          {{FORMERROR.EMAIL_MAX}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-12 p-0">
                    <div class="col-sm-6" style="padding-bottom: 15px;">
                      <label for="availableIn" class="control-label required-field font-bold">Availability</label>
                      <select class="form-control input-sm" id="availableIn" formControlName="availableIn" type="text"
                        (change)="onChangePeriod($event.target.value)">
                        <option value="null" selected disabled>Select One</option>
                        <option *ngFor="let list of periodList" [value]="list">
                          {{list}}</option>
                      </select>
                      <div *ngIf="
                  (candidateSubmit && candidateControls.availableIn.invalid) ||
                  (candidateControls.availableIn.invalid &&
                    (candidateControls.availableIn.dirty ||
                      candidateControls.availableIn.touched))
                " class="error-msg">
                        <div *ngIf="candidateControls.availableIn.errors.required">
                          Availablility is required
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-6" style="padding-bottom: 15px;">
                      <label for="engagementType" class="control-label required-field font-bold">Engagement Type</label>
                      <select class="form-control input-sm" id="engagementType" formControlName="engagementType" type="text"
                        (change)="onCandidateEngagementTypeChange($event.target.value)">
                        <option value="null" selected disabled>Select Your Engagement Type</option>
                        <option *ngFor="let engagementType of engagementTypeList" [value]="engagementType">
                          {{engagementType}}</option>
                      </select>
                      <div *ngIf="
                             (candidateSubmit && candidateControls.engagementType.invalid) ||
                             (candidateControls.engagementType.invalid &&
                             (candidateControls.engagementType.dirty ||
                               candidateControls.engagementType.touched))  " class="error-msg">
                        <div *ngIf="candidateControls.engagementType.errors.required">
                          Engagement Type is required
                        </div>
                      </div>
                      <!-- Corp-to-Corp info alert -->
                      <div *ngIf="isCandidateCorpToCorp" class="alert alert-info mt-2 mb-0" style="font-size: 12px; padding: 8px 12px; border-radius: 4px;">
                        <ng-icon name="tablerInfoCircle" style="margin-right: 6px;"></ng-icon>
                        Corp-to-Corp engagement requires your company to have a supplier profile in the Contract Center for sub-contracted jobs. Ensure your organization is registered before applying to jobs.
                      </div>
                    </div>
                  </div>

                  <!-- Corp-to-Corp conditional fields -->
                  <div class="col-sm-12 p-0" *ngIf="isCandidateCorpToCorp">
                    <div class="row" style="margin: 0;">
                      <div class="col-sm-6" style="padding-bottom: 15px;">
                        <label class="control-label required-field font-bold">Client Type</label>
                        <select class="form-control input-sm" formControlName="clientType">
                          <option value="null" selected disabled>Select Client Type</option>
                          <option *ngFor="let ct of clientTypeList" [value]="ct">{{ct}}</option>
                        </select>
                        <div *ngIf="(candidateSubmit && candidateControls.clientType?.invalid) ||
                          (candidateControls.clientType?.invalid && (candidateControls.clientType?.dirty || candidateControls.clientType?.touched))"
                          class="error-msg">
                          <div *ngIf="candidateControls.clientType?.errors?.required">Client Type is required</div>
                        </div>
                        <div class="form-check mt-1">
                          <input type="checkbox" class="form-check-input" formControlName="showClientType" id="showClientTypeCreate">
                          <label class="form-check-label" for="showClientTypeCreate" style="font-size: 12px; color: #718096;">Show Client Type on profile</label>
                        </div>
                      </div>
                      <div class="col-sm-6" style="padding-bottom: 15px;">
                        <label class="control-label required-field font-bold">Client Name</label>
                        <input type="text" class="form-control input-sm" formControlName="clientName" placeholder="Enter client name">
                        <div *ngIf="(candidateSubmit && candidateControls.clientName?.invalid) ||
                          (candidateControls.clientName?.invalid && (candidateControls.clientName?.dirty || candidateControls.clientName?.touched))"
                          class="error-msg">
                          <div *ngIf="candidateControls.clientName?.errors?.required">Client Name is required</div>
                        </div>
                        <div class="form-check mt-1">
                          <input type="checkbox" class="form-check-input" formControlName="showClientName" id="showClientNameCreate">
                          <label class="form-check-label" for="showClientNameCreate" style="font-size: 12px; color: #718096;">Show Client Name on profile</label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-sm-12">
                    <div class="col-sm-6">
                      <div class="row">
                        <div class="col-sm-12 pl-0" style="margin-bottom: 8px;">
                          <label for="title" class="control-label required-field font-bold">Job Title</label>
                          <div  [attr.title]="selectedJobTitle">
                            <ng-select [inputAttrs]="{maxlength: '101'}" [items]="candidateJobTitleList"
                              [addTag]="true" [hideSelected]="false"
                              dropdownPosition="bottom" id="candidateJobTitle" formControlName="jobTitle" [multiple]="false" [(ngModel)]="selectedJobTitle"
                              placeholder="Job Title" [clearable]="true">
                              <ng-template ng-option-tmp let-item="item">
                                <div class="custom-option multi-line-option" [attr.title]="item">
                                  {{ item }}
                                </div>
                              </ng-template>
                              <ng-template ng-label-tmp let-item="item" let-index="index" let-clear="clear">
                                <div class="custom-option single-line-truncate" [attr.title]="item">
                                   
                                  {{ item.length > 30 ? (item | slice:0:30) + '...' : item }}
                                </div>
                              </ng-template>
                            </ng-select>
                          </div>
                          <div *ngIf="
                                (candidateSubmit && candidateControls.jobTitle.invalid) ||
                                (candidateControls.jobTitle.invalid &&
                                  (candidateControls.jobTitle.dirty ||
                                    candidateControls.jobTitle.touched))
                              " class="error-msg">
                            <div *ngIf="candidateControls.jobTitle.errors.required">
                              Job Title is required
                            </div>
                            <div *ngIf="candidateControls.jobTitle.errors.minword">
                              {{FORMERROR.JOBTITLE_MIN}}
                            </div>
                            <div *ngIf="candidateControls.jobTitle.errors.maxword">
                              {{FORMERROR.JOBTITLE_MAX}}
                            </div>
                          </div>
                        </div>
                      </div> 
                    </div>  
                    <div class="col-sm-6 pr-0" style="padding-bottom: 15px;">
                      <label for="totalExperience" class="control-label required-field font-bold">Total
                        Experience</label>
                      <select type="text" id="totalExperience" formControlName="totalExperience" class="form-control input-sm">
                        <option value=null disabled selected hidden>Select the number of years of experience
                        </option>
                        <option *ngFor="let totalExperience of totalExperienceList" [value]="totalExperience">
                          {{totalExperience}}</option>
                      </select>
                      <div *ngIf="
                          (candidateSubmit && candidateControls.totalExperience.invalid) ||
                          (candidateControls.totalExperience.invalid &&
                            (candidateControls.totalExperience.dirty ||
                              candidateControls.totalExperience.touched))
                        " class="error-msg">
                        <div *ngIf="candidateControls.totalExperience.errors.required">
                          Total Experience is required
                        </div>
                      </div>
                    </div>
                  </div>

                    <div class="col-sm-12">
                          <label for="location" class="control-label required-field font-bold">Current Location</label>
                          <div class="row">
                            <div class="col-sm-6" style="padding-bottom: 15px;margin-bottom:20px;">
                              <select class="form-control input-sm" id="candidateCountry" formControlName="country" type="text"
                                (change)="onChangeCountry($event.target.value, 'candidates')">
                                <option value="null" selected disabled>Country</option>
                                <option *ngFor="let country of countryList" [value]="country.countryCode">
                                  {{country.countryName}}</option>
                              </select>
                              <div *ngIf="
                                                    (candidateSubmit && candidateControls.country.invalid) ||
                                                    (candidateControls.country.invalid &&
                                                      (candidateControls.country.dirty ||
                                                        candidateControls.country.touched))
                                                  " class="error-msg">
                                <div *ngIf="candidateControls.country.errors.required">
                                  Country is required
                                </div>
                              </div>
                            </div>
                            <div class="col-sm-6" *ngIf="candidatePostForm.value.country=='US'">
                              <select class="form-control input-sm" id="candidateStateUS" formControlName="state" type="text">
                                <option value="null" selected=true disabled>State</option>
                                <option *ngFor="let state of usStatesList" [value]="state">{{state}}
                                </option>
                              </select>
                              <div *ngIf="
                                                  (candidateSubmit && candidateControls.state.invalid) ||
                                                  (candidateControls.state.invalid &&
                                                    (candidateControls.state.dirty ||
                                                      candidateControls.state.touched))
                                                " class="error-msg">
                                <div *ngIf="candidateControls.state.errors.required">
                                  State is required
                                </div>
                              </div>
                            </div>
                            <div class="col-sm-6" *ngIf="candidatePostForm.value.country=='CA'">
                              <select class="form-control input-sm" id="candidateStateCA" formControlName="state" type="text">
                                <option value="null" selected=true disabled>State</option>
                                <option *ngFor="let state of stateListCA" [value]="state.stateName">{{state.stateName}}
                                </option>
                              </select>
                              <div *ngIf="
                                                  (candidateSubmit && candidateControls.state.invalid) ||
                                                  (candidateControls.state.invalid &&
                                                    (candidateControls.state.dirty ||
                                                      candidateControls.state.touched))
                                                " class="error-msg">
                                <div *ngIf="candidateControls.state.errors.required">
                                  State is required
                                </div>
                              </div>
                            </div>
                            <div class="col-sm-6" *ngIf="candidatePostForm.value.country=='IN'">
                              <select class="form-control input-sm" id="candidateStateIN" formControlName="state" type="text">
                                <option value="null" selected=true disabled>State</option>
                                <option *ngFor="let state of stateListIN" [value]="state.stateName">{{state.stateName}}
                                </option>
                              </select>
                              <div *ngIf="
                                                  (candidateSubmit && candidateControls.state.invalid) ||
                                                  (candidateControls.state.invalid &&
                                                    (candidateControls.state.dirty ||
                                                      candidateControls.state.touched))
                                                " class="error-msg">
                                <div *ngIf="candidateControls.state.errors.required">
                                  State is required
                                </div>
                              </div>
                            </div>
                            <div class="col-sm-6" *ngIf="candidatePostForm.value.country=='AU'">
                              <select class="form-control input-sm" id="candidateStateAU" formControlName="state" type="text">
                                <option value="null" selected=true disabled>State</option>
                                <option *ngFor="let state of stateListAU" [value]="state.stateName">{{state.stateName}}
                                </option>
                              </select>
                              <div *ngIf="
                                                  (candidateSubmit && candidateControls.state.invalid) ||
                                                  (candidateControls.state.invalid &&
                                                    (candidateControls.state.dirty ||
                                                      candidateControls.state.touched))
                                                " class="error-msg">
                                <div *ngIf="candidateControls.state.errors.required">
                                  State is required
                                </div>
                              </div>
                            </div>
                            <div class="col-sm-6"
                              *ngIf="candidatePostForm.value.country!='AU'&&
                                                                                          candidatePostForm.value.country!='IN'&&
                                                                                          candidatePostForm.value.country!='CA'&&
                                                                                          candidatePostForm.value.country!='US'">
                              <input maxlength="51" (keydown.enter)="$event.preventDefault()" type="text"
                                placeholder="State" id="candidateStateOther" formControlName="state" class="form-control input-sm">
                              <div *ngIf="
                                                      (candidateSubmit && candidateControls.state.invalid) ||
                                                      (candidateControls.state.invalid &&
                                                        (candidateControls.state.dirty ||
                                                          candidateControls.state.touched))
                                                    " class="error-msg">
                                <div *ngIf="candidateControls.state.errors.required">
                                  State is required.
                                </div>
                                <div *ngIf="candidateControls.state.errors.maxword">
                                  {{FORMERROR.STATE_MAX}}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row pt-7">
                            <div class="col-sm-6" style="padding-bottom: -25px;">
                              <input maxlength="51" (keydown.enter)="$event.preventDefault()" type="text"
                                placeholder="City" id="candidateCity" formControlName="city" class="form-control input-sm">
                              <div *ngIf="
                                                      (candidateSubmit && candidateControls.city.invalid) ||
                                                      (candidateControls.city.invalid &&
                                                        (candidateControls.city.dirty ||
                                                          candidateControls.city.touched))
                                                    " class="error-msg">
                                <div *ngIf="candidateControls.city.errors.required">
                                  City is required
                                </div>
                                <div *ngIf="candidateControls.city.errors.maxword">
                                  {{FORMERROR.CITY_MAX}}
                                </div>
                              </div>
                            </div>
                            <div class="col-sm-6">
                              <input type="text" maxlength="12" placeholder="Zip Code" id="candidateZipCode" formControlName="zipCode"
                                class="form-control input-sm">
                              <div *ngIf="
                              (candidateSubmit && candidateControls.zipCode.invalid) ||
                              (candidateControls.zipCode.invalid &&
                                (candidateControls.zipCode.dirty ||
                                  candidateControls.zipCode.touched))
                            " class="error-msg">
                                <div *ngIf="candidateControls.zipCode.errors?.required">
                                  Zipcode is required
                                </div>
                                <div class="w-wrap" *ngIf="candidateControls.zipCode.errors?.minword">
                                  {{FORMERROR.ZIPCODE_MIN}}
                                </div>
                                <div class="w-wrap" *ngIf="candidateControls.zipCode.errors?.maxword">
                                  {{FORMERROR.ZIPCODE_MAX}}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                  <div class="col-sm-12 pt-7">
                    <div class="row" style="padding-bottom: 15px;">
                      <div class="col-sm-6">
                        <label for="primarySkills" class="control-label required-field font-bold">Primary Skills</label>
                        <div >
                          <ng-select class="multiselectlable" [items]="primarySkillsList" [addTag]="true" [hideSelected]="false"
                            dropdownPosition="bottom" id="candidatePrimarySkills" formControlName="primarySkills" maxSelectedItems="3"
                            [multiple]="true" [closeOnSelect]="false" [clearSearchOnAdd]="true"
                            placeholder="e.g. Java, Spring, Hibernate" [(ngModel)]="primarySkillsSelected">
                            <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                              <div class="ng-select-checkbox-label">
                                <span class="ng-select-checkmark" [class.checked]="item$.selected"></span>
                                <span class="ng-select-checkbox-text">{{item}}</span>
                              </div>
                            </ng-template>
                          </ng-select>
                        </div>
                        <div class="flex">
                          <div>
                            <small style="font-size: 12px;">Enter no more than 3</small>
                          </div>
                        </div>
                           <div style="display:flex; float: right;">
                             <div *ngIf="
                       (candidateSubmit && candidateControls.primarySkills.invalid) ||
                       (candidateControls.primarySkills.invalid &&
                         (candidateControls.primarySkills.dirty ||
                           candidateControls.primarySkills.touched))" class="error-msg">
                               <div *ngIf="candidateControls.primarySkills.errors.required">
                                 Primary Skills is required
                               </div>
                             </div>
                           </div>
                      </div>
                      <div class="col-sm-6">
                        <label for="secondarySkills" class="control-label  font-bold">Secondary
                          Skills</label>
                        <div >
                          <ng-select class="multiselectlable" [items]="secondarySkillsList" [addTag]="true" [hideSelected]="false"
                            dropdownPosition="bottom" id="candidateSecondarySkills" formControlName="secondarySkills" maxSelectedItems="3"
                            [multiple]="true" [closeOnSelect]="false" [clearSearchOnAdd]="true"
                            placeholder="e.g. Java, Spring, Hibernate" [(ngModel)]="secondarySkillsSelected">
                            <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                              <div class="ng-select-checkbox-label">
                                <span class="ng-select-checkmark" [class.checked]="item$.selected"></span>
                                <span class="ng-select-checkbox-text">{{item}}</span>
                              </div>
                            </ng-template>
                          </ng-select>
                        </div>
                        <div style="display:flex">
                          <div>
                            <small style="font-size: 12px;">Enter no more than 3</small>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-sm-6" style="padding-bottom: 15px;">
                    <label for="workAuthorization" class="control-label required-field font-bold">Work
                      Authorization</label>
                    <select class="form-control input-sm" [disabled]="workflag" id="workAuthorization" formControlName="workAuthorization"
                      type="text">
                      <option value="null" selected disabled>Select Work Authorization</option>
                      <option *ngFor="let workAuthorization of workAuthorizationList" [value]="workAuthorization"
                        [disabled]="workAuthorization?.length==0">
                        {{workAuthorization}} </option>
                    </select>
                    <div *ngIf="
                      (candidateSubmit && candidateControls.workAuthorization.invalid) ||
                      (candidateControls.workAuthorization.invalid &&
                        (candidateControls.workAuthorization.dirty ||
                          candidateControls.workAuthorization.touched))
                    " class="error-msg">
                      <div *ngIf="candidateControls.workAuthorization.errors.required">
                        Work Authorization is required
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-6" style="padding: 0px;">
                    <div class="col-sm-12">
                      <label for="payType" class="control-label required-field font-bold">Pay Type</label>
                      <select (change)="onChangePayType($event.target.value, 'candidates')" type="text"
                        id="candidatePayType" formControlName="payType" class="form-control input-sm">
                        <option [selected]=true value=null disabled>Select Pay Type</option>
                        <option *ngFor="let list of payTypeList" [value]="list">{{list}}</option>
                      </select>
                      <div *ngIf="
                                (candidateSubmit && candidateControls.payType.invalid) ||
                                (candidateControls.payType.invalid &&
                                  (candidateControls.payType.dirty ||
                                    candidateControls.payType.touched))
                              " class="error-msg">
                        <div *ngIf="candidateControls.payType.errors?.required">
                          Pay Type is required
                        </div>
                      </div>
                    </div>
                  </div>
                <div class="col-sm-12">
                  <label for="targetRateFrom"
                  class="control-label required-field font-bold">Target Rate
                  Range</label>
                </div>

                  <div class="col-sm-12" style="padding-bottom: 15px;">
                      <div class="col-sm-6 pl-0">
                        <div class="input-group-append">
                          <span class="input-group-text currency-type-1">
                            <label
                              *ngIf="candidatePostForm.value.country=='US' || candidatePostForm.value.country == null"
                              for="USD" class="currency-type">USD</label>
                            <label *ngIf="candidatePostForm.value.country=='IN'" for="INR"
                              class="currency-type">INR</label>
                            <label *ngIf="candidatePostForm.value.country=='CA'" for="CAD"
                              class="currency-type">CAD</label>
                            <label *ngIf="candidatePostForm.value.country=='AU'" for="AUD"
                              class="currency-type">AUD</label>
                            <label
                              *ngIf="candidatePostForm.value.country!='US' && candidatePostForm.value.country!='IN' && candidatePostForm.value.country!='CA' && candidatePostForm.value.country!='AU' && candidatePostForm.value.country!=null"
                              for="CUR" class="currency-type">CUR</label>
                            </span>
                          </div>
                        <div>
                     
                          <input (keyup)="onTargetRateTyped($event.target.value, 'candidates')"
                            (keypress)="decimalFilter($event)" type="text" maxlength="9"
                            class="form-control input-sm" placeholder="From" id="candidateTargetRateFrom"
                            formControlName="targetRateFrom">
                        </div>
                        <div *ngIf="
                                                    (candidateSubmit && candidateControls.targetRateFrom.invalid) ||
                                                    (candidateControls.targetRateFrom.invalid &&
                                                      (candidateControls.targetRateFrom.dirty ||
                                                        candidateControls.targetRateFrom.touched))
                                                  " class="error-msg">
                          <div *ngIf="candidateControls.targetRateFrom.errors?.required">
                            Target Rate is required
                          </div>
                          <div *ngIf="candidateControls.targetRateFrom.errors.minword">
                            {{FORMERROR.TARGETRATE_MIN}}
                          </div>
                          <div *ngIf="candidateControls.targetRateFrom.errors.maxword">
                            {{FORMERROR.TARGETRATE_MAX}}
                          </div>
                          <div
                            *ngIf="candidateControls.targetRateFrom.errors?.invalidDecimal&& !candidateControls?.targetRateFrom?.errors?.maxword">
                            {{FORMERROR.TARGETRATE_PATTERN}}
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-6 pr-0">
                        <div>
                          <input (keyup)="onTargetRateTyped($event.target.value, 'candidates')"
                            (keypress)="decimalFilter($event)" type="text" maxlength="9"
                            class="form-control input-sm" placeholder="To" id="candidateTargetRateTo"
                            formControlName="targetRateTo">
                        <div class="input-group-append">
                          <span class="input-group-text currency-type-2">
                              <label
                                *ngIf="candidatePostForm.value.country=='US' || candidatePostForm.value.country == null"
                                for="USD" class="currency-type">USD</label>
                              <label *ngIf="candidatePostForm.value.country=='IN'" for="INR"
                                class="currency-type">INR</label>
                              <label *ngIf="candidatePostForm.value.country=='CA'" for="CAD"
                                class="currency-type">CAD</label>
                              <label *ngIf="candidatePostForm.value.country=='AU'" for="AUD"
                                class="currency-type">AUD</label>
                              <label
                                *ngIf="candidatePostForm.value.country!='US' && candidatePostForm.value.country!='IN' && candidatePostForm.value.country!='CA' && candidatePostForm.value.country!='AU' && candidatePostForm.value.country!=null"
                                for="CUR" class="currency-type">CUR</label>
                            </span>
                            </div>
                        </div>
                        <div *ngIf="
                                          (candidateSubmit ) ||
                                          (
                                            (candidateControls.targetRateTo.dirty ||
                                              candidateControls.targetRateTo.touched))
                                        " class="error-msg">
                          <div *ngIf="candidateControls?.targetRateTo.errors?.required">
                            Target Rate is required
                          </div>
                          <div *ngIf="candidateControls?.targetRateTo?.errors?.minword">
                            {{FORMERROR.TARGETRATE_MIN}}
                          </div>
                          <div *ngIf="candidateControls?.targetRateTo?.errors?.maxword">
                            {{FORMERROR.TARGETRATE_MAX}}
                          </div>
                          <div class="w-wrap"
                            *ngIf="candidatePostForm.errors && candidatePostForm?.errors?.rangevalidation&&!candidateControls.targetRateFrom.errors?.invalidDecimal">
                            Invalid target rate range</div>
                          <div
                            *ngIf="candidateControls.targetRateTo.errors?.invalidDecimal&& !candidateControls?.targetRateTo?.errors?.maxword">
                            {{FORMERROR.TARGETRATE_PATTERN}}
                          </div>
                        </div>
                      </div>
                 
                  </div>

                  <div class="col-sm-12 p-0" style="padding-bottom: 15px !important;">
                    <div class="col-sm-6">
                        <label for="workMode" class="control-label required-field font-bold">Work Mode</label>
                        <select class="form-control input-sm" id="candidateWorkMode" formControlName="workMode" type="text">
                          <option [value]="null" disabled>Select Your Work Mode</option>
                          <option value="Onsite">Onsite</option>
                          <option value="Remote">Remote</option>
                          <option value="Hybrid">Hybrid</option>
                        </select>
                        <div *ngIf="
                                                 (candidateSubmit && candidateControls.workMode.invalid) ||
                                                 (candidateControls.workMode.invalid &&
                                                 (candidateControls.workMode.dirty ||
                                                 candidateControls.workMode.touched))  " class="error-msg">
                          <div *ngIf="candidateControls.workMode.errors.required">
                            Work Mode is required
                          </div>
                        </div>
                      </div>

                      <div class="col-sm-6">
                      <label class="control-label required-field font-bold">Publish To</label>
                      <ng-select class="multiselectlable" [items]="networkGroups" bindLabel="name" bindValue="id" placeholder="Select networks"
                        [multiple]="true" [closeOnSelect]="false" [(ngModel)]="selectedNetworks"
                        id="candidateSelectedNetworks" formControlName="selectedNetworks" (change)="onNetworkSelectionChange(candidatePostForm)">

                        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                          <ng-container *ngIf="item.type">

                            <ng-container *ngIf="index === 0 || networkGroups[index - 1].type !== item.type">
                              <div class="networktype">{{ item.type }}</div>
                            </ng-container>

                            <div class="ng-select-checkbox-label"
                              [class.marketplace-locked]="(membershipType === 'Free' || userType === 'JOB_SEEKER') && item.id === '1'">
                              <span class="ng-select-checkmark" [class.checked]="item$.selected"></span>
                              <span class="ng-select-checkbox-text" [attr.title]="item.name">{{ item.name }}</span>
                            </div>
                          </ng-container>
                        </ng-template>
                        <ng-template ng-label-tmp let-item="item" let-index="index" let-clear="clear">
                          <div class="selected-item"  [attr.title]="item.name">
                            <span id="business_post_candidate_network_remove" class="ng-value-clear remove-icon" (click)="clear(item); $event.stopPropagation()"
                              *ngIf="!((membershipType === 'Free' || userType === 'JOB_SEEKER') && item.id === '1')">
                              ✕
                            </span>

                            <span class="ng-value-label">{{ item.name }}</span>
                          </div>
                        </ng-template>
                      </ng-select>
                      <div *ngIf="
                                          (candidateSubmit && candidateControls.selectedNetworks.invalid) ||
                                          (candidateControls.selectedNetworks.invalid &&
                                            (candidateControls.selectedNetworks.dirty ||
                                            candidateControls.selectedNetworks.touched))
                                        " class="error-msg">
                        <div *ngIf="candidateControls.selectedNetworks.errors.required">
                          Publish to is required
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-sm-6" >
                    <div class="form-group">
                      <div class="custom-checkbox">
                        <label class="checkbox-label font-bold w-wrap"> Other
                          Preferred States
                          <input type="checkbox" name="otherPrefered" id="otherPrefered" formControlName="otherPrefered">
                          <span class="checkmark"
                            title="You can check or uncheck this to show or hide  client type"></span>
                        </label>
                      </div>
                    </div>
                    <div >
                      <ng-select [inputAttrs]="{maxlength: '50'}"
                        *ngIf="candidatePostForm.value.otherPrefered == true" [items]="otherStatesList"
                        [addTag]="true" [hideSelected]="false" dropdownPosition="bottom" [closeOnSelect]="false"
                        [clearSearchOnAdd]="true" [(ngModel)]="otherSelectedStates"
                        id="otherPreferedStates" formControlName="otherPreferedStates" [multiple]="true"
                        placeholder="Other Preferred States">
                        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                          <div class="ng-select-checkbox-label">
                            <span class="ng-select-checkmark" [class.checked]="item$.selected"></span>
                            <span class="ng-select-checkbox-text">{{item}}</span>
                          </div>
                        </ng-template>
                      </ng-select>
                    </div>
                  </div>


                  <div class="col-sm-6">
                    <div class="row">
                      <div class="col-sm-7" style="padding-bottom: 15px;">
                        <label for="securityClearance" class="control-label font-bold">Security Clearance</label>
                      </div>
                      <div class="col-sm-5" style="position: relative; right: 22px;">
                        <div class="row" style="    margin-top: 6px;">
                          <div class="col-sm-6" style="padding-bottom: 15px;">
                            <div class="custom-checkbox margin-top-5">
                              <label class="checkbox-label font-normal"> Yes
                                <input type="radio" [value]="true" id="candidateSecurityClearanceYes" formControlName="securityClearance"
                                  name="securityClearance">
                                <span title="Check Working Days" class="checkmark"></span>
                              </label>
                            </div>
                          </div>
                          <div class="col-sm-6" style="padding-bottom: 15px;">
                            <div class="custom-checkbox margin-top-5">
                              <label class="checkbox-label font-normal"> No
                                <input type="radio" [value]="false" id="candidateSecurityClearanceNo" formControlName="securityClearance"
                                  name="securityClearance">
                                <span title="Check Working Days" class="checkmark"></span>
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row" *ngIf="userType != 'JOB_SEEKER'">
                    <div class="col-sm-6" >
                      <div class="custom-checkbox">
                        <label class="checkbox-label font-bold w-wrap" style="padding-left: 22px !important;"> Create
                          Candidate Profile on the Platform
                          <input id="business_post_create_candidate_platform_checkbox" type="checkbox" name="createCandidateOnPlatform"
                            (click)="createCandidateOnProf($event)" formControlName="createCandidateOnPlatform">
                          <span class="checkmark"
                            title="You can check or uncheck this to show or hide  client type"></span>
                        </label>
                      </div>
                    </div>
                  </div>
 
                </div>
              </div>
              <div class="col-sm-12 R-summary">
                <label class="control-label required-field font-bold">Resume Summary</label>
                <div (paste)="onPaste4($event)" id="resumeSummary" formControlName="resumeSummary" [ngxSummernote]="config2"
                  class="note-editor.note-frame"></div>
                <div *ngIf="
            (candidateSubmit && candidateControls.resumeSummary.invalid) ||
            (candidateControls.resumeSummary.invalid &&
              (candidateControls.resumeSummary.dirty ||
                candidateControls.resumeSummary.touched))
          " class="error-msg">
                  <div *ngIf="candidateControls.resumeSummary.errors.required">
                    Resume Summary is required
                  </div>
                  <div *ngIf="candidateControls.resumeSummary.errors.minChar">
                    Resume summary should at least have {{ RESUME_SUMMARY.min }} Characters
                  </div>
                  <div *ngIf="candidateControls.resumeSummary.errors.maxChar">
                    Resume Summary can have a maximum of {{ RESUME_SUMMARY.max }} Characters.
                  </div>
                </div>
                <small>Maximum of {{ RESUME_SUMMARY.max }} Characters allowed</small>
              </div>
            </div>
          </div>
        </form>
      </div>

      <div class="custom-panel-footer">
        <div class="panel-footer">
          <div class="footer-flex">
            <button id="business_post_candidate_cancel_button" [ngClass]="{'disabled': disable_for_draft==true}" class="btn btn-default"
              (click)="cancelcloseCandidate()">Cancel</button>
            <button id="business_post_candidate_clear_button" [ngClass]="{'disabled': disable_for_draft==true}" class="btn btn-default"
              (click)="candidateformreset()">Clear</button>
            <button id="business_post_candidate_save_draft_button" class="btn  btn-primary" type="submit" (click)="saveCandidate('DRAFTED')"
              [disabled]="candidateControls.firstName.invalid || candidateControls.lastName.invalid ||disable_for_draft==true">Save
              as Draft</button>
            <button id="business_post_candidate_make_available_button" class="btn  btn-primary" type="submit" (click)="saveCandidate('ACTIVE')">Make
              Available</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
</ng-template>
<div class="margin-bottom-5" *ngIf="postView=='GIG_HOME_PAGE'
        ||businessPage
        ||(postView=='COMMUNITY' && communityType == 'true' &&  ( (isCommunityJoined == 'true' ) || (values?.adminviewnavigation == true) || (values?.membersflage == true) || (values?.isAdmin == true) || (values?.isSuperAdmin == true)))
        || (postView=='COMMUNITY' && communityType == 'false')
        ||postView=='NETWORK'
        ||postView=='TEAM'
        ||postView=='owner';else  modeltempview">
  <div class="hpanel" *ngIf="showPostTool()">

    <!-- ───── New activity-feed composer (matches Gigsumo unified mock) ─────
         Also used on the business Home tab (businessPage) with Photo/Video/Link + Post;
         the legacy composer below is kept for it — drop `|| businessPage` here and
         `&& !businessPage` there to revert. -->
    <div class="gs-composer" *ngIf="postView=='GIG_HOME_PAGE' || businessPage">
      <div class="gsc-top">
        <div class="gsc-av" (click)="userprofile(undefined, loginUser?.userId)">
          <ng-container *ngIf="composerAvatarUrl; else gscInitials">
            <img [src]="composerAvatarUrl" alt="" referrerpolicy="no-referrer"
                 (load)="logComposerAvatar('LOADED', composerAvatarUrl)"
                 (error)="logComposerAvatar('ERROR', composerAvatarUrl); profPhoto = null;
                          profileitems && (profileitems.photo = null);
                          loginUser && (loginUser.photo = null)" />
          </ng-container>
          <ng-template #gscInitials>
            <span class="gsc-av-initials"
                  [style.background-color]="getColortwo(profileitems?.firstName, profileitems?.lastName)"
                  [style.color]="getTextColor(profileitems?.firstName, profileitems?.lastName)">
              {{ getInitialstwo(profileitems?.firstName, profileitems?.lastName) }}
            </span>
          </ng-template>
        </div>
        <input class="gsc-input" type="text" readonly
               [placeholder]="'What\'s on your mind' + (profileitems?.firstName ? ', ' + profileitems.firstName : '') + '?'"
               (click)="startAPost(postTemplate)" />
        <input id="gscFileInputImg" style="display: none;" multiple type="file" accept=".jpg, .jpeg, .png"
               #gscFileInputImg (click)="gscFileInputImg.value=null"
               (change)="fileUpload($event, 'image', fileuploadPopUp)" />
        <input id="gscFileInputVid" style="display: none;" multiple type="file" accept="video/*"
               #gscFileInputVid (click)="gscFileInputVid.value=null"
               (change)="fileUpload($event, 'video', fileuploadPopUp)" />
      </div>
      <div class="gsc-actions">
        <button type="button" class="gsca" (click)="gscFileInputImg.click()">
          <ng-icon name="tablerCamera"></ng-icon>
          <span>Photo</span>
        </button>
        <button type="button" class="gsca" (click)="gscFileInputVid.click()">
          <ng-icon name="tablerVideo"></ng-icon>
          <span>Video</span>
        </button>
        <ng-container *ngIf="!businessPage">
          <button type="button" class="gsca" (click)="startAPost(postTemplate)">
            <ng-icon name="tablerThumbUp"></ng-icon>
            <span>Like</span>
          </button>
          <button type="button" class="gsca" (click)="startAPost(postTemplate)">
            <ng-icon name="tablerCalendar"></ng-icon>
            <span>Event</span>
          </button>
          <button type="button" class="gsca" (click)="startAPost(postTemplate)">
            <ng-icon name="tablerArticle"></ng-icon>
            <span>Article</span>
          </button>
        </ng-container>
        <button type="button" class="gsca" *ngIf="businessPage" (click)="startAPost(postTemplate)">
          <ng-icon name="tablerLink"></ng-icon>
          <span>Link</span>
        </button>
        <button type="button" class="gsca gsca-primary" (click)="startAPost(postTemplate)">
          <ng-icon name="tablerSend"></ng-icon>
          <span>Post</span>
        </button>
      </div>
    </div>

    <!-- ───── Legacy composer (community / network / team / business pages) ───── -->
    <div class="panel-body border-radius-top-left-right-6 PaddTP-0 post-tool-container" *ngIf="postView!='GIG_HOME_PAGE' && !businessPage">
      <div class="row post">
        <div class="col-md-1">
          <div class="create-a-post-img">
            <a>
              <div *ngIf="loginUser?.photo != undefined">
                <img id="business_post_user_avatar_image" (click)="userprofile(undefined, loginUser.userId)" src="{{ loginUser.photo }}" />
              </div>
              <div id="business_post_user_avatar_div" *ngIf="loginUser?.photo == undefined" (click)="userprofile(undefined, loginUser.userId)"
                style="margin-top: 14px;">
                <div class="circles"
                  [style.background-color]="getColortwo(profileitems?.firstName, profileitems?.lastName)">
                  <div [style.color]="getTextColor(profileitems?.firstName, profileitems?.lastName)" class="circle-text" style="font-size: 18px !important; font-weight: bold;">{{ getInitialstwo(profileitems?.firstName, profileitems?.lastName) }}</div>
                </div>
              </div>
            </a>
          </div>
        </div>
        <div class="col-md-11">
          <div class="post-text">
            <div>
              <input id="business_post_create_post_input" [ngClass]="{'disabled': beingEdited==true}" placeholder="Create a post"
                class="start-post form-control" (click)="startAPost(postTemplate)" />
              <input id="myFileInput1" style="display: none;" multiple type="file" accept=".jpg, .jpeg, .png"
                #myFileInput1 (click)="myFileInput1.value=null"
                (change)="fileUpload($event, 'image', fileuploadPopUp)" />
              <input multiple id="myFileInput2" style="display: none;" type="file" accept="video/*"
                (change)="fileUpload($event, 'video', fileuploadPopUp)" #myFileInput2
                (click)="myFileInput2.value=null" />
            </div>
            <div class="m-t-15">
              <div class="col-sm-12 text-right p-00" dropdown>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div class="row interactive-item-pos">
        <div class="col-lg-12">
          <nav class="flex-container" role="navigation psot-items"
            [ngClass]="{'disabled': !gigsumoService.buttonClicked }">
            <ul class="nav navbar-nav no-borders customPost overflow overFlow"
              [ngClass]="{'disabled': beingEdited==true}">
              <li id="business_post_create_post_button" title='Create a post' style='cursor: pointer;' class="dropdown" (click)="startAPost(postTemplate)">
                <a class="dropdown-toggle" data-toggle="dropdown">
                  <div class="enetitytitle">
                    <span class="m-r-9">
                      <svg class="create-a-post-svg" width="20px" height="20px" viewBox="0 0 24 24" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M19.186 2.09c.521.25 1.136.612 1.625 1.101.49.49.852 1.104 1.1 1.625.313.654.11 1.408-.401 1.92l-7.214 7.213c-.31.31-.688.541-1.105.675l-4.222 1.353a.75.75 0 0 1-.943-.944l1.353-4.221a2.75 2.75 0 0 1 .674-1.105l7.214-7.214c.512-.512 1.266-.714 1.92-.402zm.211 2.516a3.608 3.608 0 0 0-.828-.586l-6.994 6.994a1.002 1.002 0 0 0-.178.241L9.9 14.102l2.846-1.496c.09-.047.171-.107.242-.178l6.994-6.994a3.61 3.61 0 0 0-.586-.828zM4.999 5.5A.5.5 0 0 1 5.47 5l5.53.005a1 1 0 0 0 0-2L5.5 3A2.5 2.5 0 0 0 3 5.5v12.577c0 .76.082 1.185.319 1.627.224.419.558.754.977.978.442.236.866.318 1.627.318h12.154c.76 0 1.185-.082 1.627-.318.42-.224.754-.559.978-.978.236-.442.318-.866.318-1.627V13a1 1 0 1 0-2 0v5.077c0 .459-.021.571-.082.684a.364.364 0 0 1-.157.157c-.113.06-.225.082-.684.082H5.923c-.459 0-.57-.022-.684-.082a.363.363 0 0 1-.157-.157c-.06-.113-.082-.225-.082-.684V5.5z"
                          fill="#9ca3af" />
                      </svg>
                      <!-- <ng-icon name="tablerEdit"></ng-icon> -->
                    </span>
                    Create a post
                  </div>
                </a>
              </li>
              <!-- UI transformation: Create-a-job hidden on home feed to match the new composer mock.
                   Markup preserved verbatim; restore by uncommenting.
              <li
                *ngIf="postView!='COMMUNITY' && postView!='NETWORK' && !businessPage && postView!='TEAM' && isJobOwner"
                class="dropdown" style='cursor: pointer;'>
                <a class="dropdown-toggle" data-toggle="dropdown">
                  <div id="business_post_create_job_button" title="Create Job" class="enetitytitle" (click)="createJobsOrCandidates('JOBS')">
                    <span class="m-r-9">
                      <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none">
                        <path
                          d="M9 14H15M12 11V17M8 7H7.8C6.11984 7 5.27976 7 4.63803 7.32698C4.07354 7.6146 3.6146 8.07354 3.32698 8.63803C3 9.27976 3 10.1198 3 11.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V11.8C21 10.1198 21 9.27976 20.673 8.63803C20.3854 8.07354 19.9265 7.6146 19.362 7.32698C18.7202 7 17.8802 7 16.2 7H16M8 7V6C8 4.34315 9.34315 3 11 3H13C14.6569 3 16 4.34315 16 6V7M8 7H16"
                          stroke="#9ca3af" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                    </span>
                    Create a job
                  </div>
                </a>
              </li>
              -->

              <li title='Photo' *ngIf="postView=='COMMUNITY' || postView=='NETWORK' || businessPage || postView=='TEAM'"
                class="dropdown" style='cursor: pointer;'>
                <a class="dropdown-toggle" id="upload-photo-1" data-toggle="dropdown">
                  <div id="business_post_upload_photo_menu_button" title="Upload a photo" class="enetitytitle image-upload" (click)="uploadMediaHere('photo')">
                    <span class="m-r-9">
                      <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none">
                        <circle cx="12" cy="13" r="3" stroke="#9ca3af" stroke-width="1.5" />
                        <path
                          d="M9.77778 21H14.2222C17.3433 21 18.9038 21 20.0248 20.2646C20.51 19.9462 20.9267 19.5371 21.251 19.0607C22 17.9601 22 16.4279 22 13.3636C22 10.2994 22 8.76721 21.251 7.6666C20.9267 7.19014 20.51 6.78104 20.0248 6.46268C19.3044 5.99013 18.4027 5.82123 17.022 5.76086C16.3631 5.76086 15.7959 5.27068 15.6667 4.63636C15.4728 3.68489 14.6219 3 13.6337 3H10.3663C9.37805 3 8.52715 3.68489 8.33333 4.63636C8.20412 5.27068 7.63685 5.76086 6.978 5.76086C5.59733 5.82123 4.69555 5.99013 3.97524 6.46268C3.48995 6.78104 3.07328 7.19014 2.74902 7.6666C2 8.76721 2 10.2994 2 13.3636C2 16.4279 2 17.9601 2.74902 19.0607C3.07328 19.5371 3.48995 19.9462 3.97524 20.2646C5.09624 21 6.65675 21 9.77778 21Z"
                          stroke="#9ca3af" stroke-width="1.5" />
                        <path d="M19 10H18" stroke="#9ca3af" stroke-width="1.5" stroke-linecap="round" />
                      </svg>
                    </span>
                    Photo
                  </div>
                </a>
              </li>
              <li title='Video' *ngIf="postView=='COMMUNITY' || postView=='NETWORK' || businessPage || postView=='TEAM'"
                class="dropdown" style='cursor: pointer;'>
                <a class="dropdown-toggle" data-toggle="dropdown">
                  <div id="business_post_upload_video_menu_button" title="Upload a video" class="enetitytitle image-upload" (click)="uploadMediaHere('video')">
                    <span class="m-r-9">
                      <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none">
                        <path
                          d="M12.53 20.4201H6.21C3.05 20.4201 2 18.3201 2 16.2101V7.79008C2 4.63008 3.05 3.58008 6.21 3.58008H12.53C15.69 3.58008 16.74 4.63008 16.74 7.79008V16.2101C16.74 19.3701 15.68 20.4201 12.53 20.4201Z"
                          stroke="#9ca3af" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        <path
                          d="M19.52 17.0999L16.74 15.1499V8.83989L19.52 6.88989C20.88 5.93989 22 6.51989 22 8.18989V15.8099C22 17.4799 20.88 18.0599 19.52 17.0999Z"
                          stroke="#9ca3af" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        <path
                          d="M11.5 11C12.3284 11 13 10.3284 13 9.5C13 8.67157 12.3284 8 11.5 8C10.6716 8 10 8.67157 10 9.5C10 10.3284 10.6716 11 11.5 11Z"
                          stroke="#9ca3af" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                    </span>
                    Video
                  </div>
                </a>
              </li>
              <!-- UI transformation: Create-a-candidate hidden on home feed to match the new composer mock.
                   Markup preserved verbatim; restore by uncommenting.
              <li class="dropdown" style='cursor: pointer;'
                *ngIf="postView!='COMMUNITY' && postView!='NETWORK' && !businessPage && postView!='TEAM' && isCandidateOwner">
                <a class="dropdown-toggle" data-toggle="dropdown">
                  <div id="business_post_create_candidate_button" class="enetitytitle" title="Create Candidates" (click)="createJobsOrCandidates('CANDIDATE')">
                    <span class="m-r-9">
                      <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none">
                        <path
                          d="M20 18L17 18M17 18L14 18M17 18V15M17 18V21M11 21H4C4 17.134 7.13401 14 11 14C11.695 14 12.3663 14.1013 13 14.2899M15 7C15 9.20914 13.2091 11 11 11C8.79086 11 7 9.20914 7 7C7 4.79086 8.79086 3 11 3C13.2091 3 15 4.79086 15 7Z"
                          stroke="#9ca3af" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                    </span>
                    Create a candidate
                  </div>
                </a>
              </li>
              -->

              <li title='Link' *ngIf="postView=='COMMUNITY' || postView=='NETWORK' || businessPage || postView=='TEAM'"
                style='cursor: pointer;' class="dropdown">
                <a class="dropdown-toggle" data-toggle="dropdown">
                  <div id="business_post_create_link_button" class="enetitytitle" title="Post a link" (click)="startAPost(postTemplate)">
                    <span class="m-r-9">
                      <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none">
                        <path
                          d="M12.7917 15.7991L14.2223 14.3676C16.5926 11.9959 16.5926 8.15054 14.2223 5.7788C11.8521 3.40707 8.0091 3.40707 5.63885 5.7788L2.77769 8.64174C0.407436 11.0135 0.407436 14.8588 2.77769 17.2306C3.87688 18.3304 5.29279 18.9202 6.73165 19"
                          stroke="#9ca3af" stroke-width="1.5" stroke-linecap="round" />
                        <path
                          d="M11.2083 8.20092L9.77769 9.63239C7.40744 12.0041 7.40744 15.8495 9.77769 18.2212C12.1479 20.5929 15.9909 20.5929 18.3612 18.2212L21.2223 15.3583C23.5926 12.9865 23.5926 9.14118 21.2223 6.76945C20.1231 5.66957 18.7072 5.07976 17.2683 5"
                          stroke="#9ca3af" stroke-width="1.5" stroke-linecap="round" />
                      </svg>
                    </span>
                    Link
                  </div>
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  </div>

  <!-- Trending hashtags strip (activity feed only) -->
  <div class="gs-trending-strip" *ngIf="postView=='GIG_HOME_PAGE'">
    <span class="gs-trending-label">Trending</span>
    <a class="gs-trend-tag" *ngFor="let t of trendingTags">#{{ t }}</a>
  </div>

  <!-- Feed filter tabs (activity feed only) -->
  <div class="gs-feed-tabs" *ngIf="postView=='GIG_HOME_PAGE'">
    <button type="button" class="gs-ftab"
            *ngFor="let f of feedFilters"
            [class.active]="activeFeedFilter===f.id"
            (click)="setFeedFilter(f.id)">
      <ng-icon *ngIf="f.id==='for-you'" name="tablerSparkles"></ng-icon>
      {{ f.label }}
    </button>
  </div>

  <app-common-skeleton *ngIf="loadApicall" [NameOftheScreen]="'postPage'"></app-common-skeleton>



  <div *ngIf="userData && userData?.length > 0" style="min-height: 100vh !important" infiniteScroll
    [infiniteScrollDistance]="5" [infiniteScrollThrottle]="1500" (scrolled)="onScrollDown()"
    class="search-results1 main-panel1">

    <!-- <div class="social-board" *ngIf="showWelcomePost">
      <div class="hpanel margin-bottom-5">

      </div>
    </div> -->


    <div *ngFor="let post of movedatafirst(userData); let i = index; trackBy: trackByPostId">
      <div class="social-board">
        <div class="hpanel margin-bottom-5" [ngClass]="{'disabled': post?.status=='BLOCKED'}">
          <div class="panel-body border-radius-top-left-right-6 border-radius-bottom-left-right-0"
            [ngClass]="{'b-r-6': post.postId==='WELCOME001'|| post.postId==='INSTRUCTION001'|| post.postId==='INSTRUCTION002'}">
            <div class="media social-profile clearfix mt-m12 m-b-15 pd-tp-10">

              <a class="pull-left">
                <!-- Every post shows the person who wrote it, whatever it was posted to.
                     There used to be a branch per entity here, each reading that entity's
                     own logo: the business logo, the community logo, the network or
                     workspace logo. The entity is still named beside this avatar, with its
                     own icon, so nothing is lost by dropping them.
                     This also removes the loading flicker those branches caused. An entity
                     logo had to be fetched per post, so the slot held a placeholder and
                     then swapped once the lookup returned. The poster arrives with the post
                     itself, so there is nothing to wait for and nothing to swap. -->
                <img src="" alt="" *ngIf="post.isPlatformPost" src="assets/icon/Sumoface_final.png"
                  >
                <img id="business_post_user_profile_photo"
                  *ngIf="!post?.isPlatformPost && post?.postedByUserData?.photo"
                  (click)="userprofile(post, post.postedBy)" src="{{ photoUrl+post?.postedByUserData?.photo }}"
                  (error)="onProfilePhotoError($event, post)" />
                <!-- Initials of the poster, for a poster with no photo. No entity is
                     excluded any more, because every entity now lands here. -->
                <div *ngIf="!post?.isPlatformPost && !post?.postedByUserData?.photo"
                  class="circles"
                  [style.background-color]="getColortwo(post?.postedByUserData?.firstName, post?.postedByUserData?.lastName)">
               
                  <div [style.color]="getTextColor(post?.postedByUserData?.firstName, post?.postedByUserData?.lastName)"
                    class="circle-text" style="font-size: 18px !important; font-weight: bold;">
                    {{ getInitialstwo(post?.postedByUserData?.firstName, post?.postedByUserData?.lastName) }}
                  </div>
                </div>
              </a>
              <div class="media-body">
                <h6 id="business_post_user_name_link" *ngIf="post.postEntity == 'USER' && !post?.isPlatformPost && !post?.privacyEntityLabel" (click)="userprofile(post, post.postedBy)" data-toggle="tooltip"
                  data-placement="top" title="{{ post?.postedByUserData?.fullName }}" class="cursor-pointer fw-bold post-font ellipse1 m-0">
                  {{ post.isPlatformPost== true ? post.userName : post?.postedByUserData?.fullName }}
                </h6>
                <h6 id="business_post_user_name_link" *ngIf="post.postEntity == 'USER' && post?.isPlatformPost== true" data-toggle="tooltip"
                  data-placement="top" class="fw-bold ellipse1 m-0" style="margin-top: 10px;">
                  {{post.userName}}
                </h6>
                <!-- Connections-only post: poster > the connections it was shared with. -->
                <ng-container *ngIf="post.postEntity == 'USER' && !post?.isPlatformPost && post?.privacyEntityLabel">
                  <div class="m-0 cursor-pointer ellipse2 post-font">
                    <a id="business_post_posted_by_user_link" class="ellipse-flex" data-toggle="tooltip" data-placement="top" title="{{ post?.postedByUserData?.fullName }}"
                      (click)="userprofile(post, post?.postedBy)">
                      <h6 class="m-0 fw-bold ellipse-text"> {{ post?.postedByUserData?.fullName }} </h6>
                    </a>
                    <img src="assets/icon/arrow.png" alt="" srcset="" class="profilelink" />
                    <ng-icon name="tablerUsers" class="profilelink privacy-entity-icon"></ng-icon>
                    <h6 class="fw-bold m-0 ellipse-flex privacy-entity-label">
                      <span id="business_post_privacy_entities" class="ellipse-text" data-toggle="tooltip" data-placement="top"
                        title="{{ post?.privacyEntityLabel }}">{{ post?.privacyEntityLabel }}</span>
                    </h6>
                  </div>
                </ng-container>
                <ng-container
                  *ngIf="(post.postEntity == 'COMMUNITY' || post.postEntity == 'NETWORK' || post.postEntity == 'TEAM' || post.postEntity == 'BUSINESS')">
                  <div data-toggle="tooltip" data-placement="top" title="{{ post?.postedByUserData?.fullName }}"
                    class="m-0 cursor-pointer ellipse2 post-font">
                    <a id="business_post_posted_by_user_link" class="ellipse-flex" data-toggle="tooltip" data-placement="top" title="{{ post?.postedByUserData?.fullName }}"
                      (click)="openPosterProfile(post)">
                      <h6 class="m-0 fw-bold ellipse-text"> {{ post?.postedByUserData?.fullName }} </h6>
                    </a>
                    <img *ngIf="post.postEntity == 'COMMUNITY' && post?.postedBy && !post?.communityWelcomePost" src="assets/icon/arrow.png" alt="" srcset=""
                      class="profilelink" />
                    <img *ngIf="post.postEntity != 'COMMUNITY'" src="assets/icon/arrow.png" alt="" srcset=""
                      class="profilelink" />
                    <img src="assets/icon/icons8-myspace-400.png" *ngIf="post.postEntity == 'COMMUNITY' " alt=""
                      srcset="" class="profilelink" />
                    <img src="assets/icon/icons8-share-400.png" *ngIf="post.postEntity == 'NETWORK'  " alt="" srcset=""
                      class="profilelink" />
                    <img src="assets/icon/icons8-people-100.png" *ngIf="post.postEntity == 'TEAM'" alt="" srcset=""
                      class="profilelink" />
                    <img src="assets/images/gallery/company.png" *ngIf="post.postEntity == 'BUSINESS'" alt=""
                      srcset="" class="profilelink" />
                      <h6 class="fw-bold m-0 ellipse-flex">
                        <a id="business_post_community_route_link" data-toggle="tooltip" class="ellipse-text" data-placement="top" title="{{ post?.userName }}"
                          (click)="communityroute(post)">
                          <span>{{ post?.userName}}</span>
                        </a>
                      </h6>
                  </div>
                </ng-container>
                <!-- <div class="btn-group three_icon_cmon1 hovers" dropdown container="body"
                  #postKebab="bs-dropdown"
                  (onShown)="bindKebabAutoClose(postKebab)"
                  (onHidden)="unbindKebabAutoClose()"
                  *ngIf="post.postId!='WELCOME001'&& post.postId!='INSTRUCTION001'&& post.postId!='INSTRUCTION002'">
                  <a id="button-animated" dropdownToggle *ngIf="post.postedBy == userId" class="three-dot-a">
                    <img src="assets/icon/icons8-more-96.png" alt="" srcset="" class="three-dot-img" />
                  </a>
                  <a id="button-animated" dropdownToggle *ngIf="post.postedBy != userId" class="three-dot-a">
                    <img src="assets/icon/icons8-more-96.png" alt="" srcset="" class="three-dot-img" />
                  </a>
                  <ul id="dropdown-animated" *dropdownMenu class="dropdown-menu" role="menu"
                    aria-labelledby="button-animated">
                    <ng-container *ngIf="post.postedBy == userId">
                      <li role="menuitem">
                        <a id="business_post_edit_post_button" (click)="findPost(post, editpost)">
                          <ng-icon name="tablerPencil" class="m-5"></ng-icon>Edit</a>
                      </li>
                      <li role="menuitem">
                        <a id="business_post_delete_post_button" (click)="removepost(post)">
                          <ng-icon name="tablerTrash" class="m-5"></ng-icon> Delete
                        </a>
                      </li>
                    </ng-container>
                    <ng-container *ngIf="post.postedBy != userId">
                      <li class="report" role="menuitem">
                        <app-flag [type]="post.postEntity" [id]="post.postId" [flagTo]="post.postedBy"
                          (onReport)="loadPost($event)"
                          [flags]="['Abuse','Sexual content','Politics', ' Particularly in relation to religion','Vulgar language']">
                        </app-flag>
                      </li>
                    </ng-container>
                  </ul>
                </div> -->

                <div class="btn-group position-relative three_icon_cmon1 hovers" dropdown placement="bottom right"
  #postKebab="bs-dropdown"
  (onShown)="bindKebabAutoClose(postKebab)"
  (onHidden)="unbindKebabAutoClose()"
  *ngIf="post.postId!='WELCOME001'&& post.postId!='INSTRUCTION001'&& post.postId!='INSTRUCTION002'">
 
  <!-- 3-Dots Button -->
  <button id="button-animated" dropdownToggle type="button" class="three-dots-btn" aria-label="More options">
    <ng-icon name="tablerDotsVertical"></ng-icon>
  </button>
 
  <!-- Dropdown Menu -->
  <ul id="dropdown-animated" *dropdownMenu class="dropdown-menu modern-post-dropdown" role="menu" aria-labelledby="button-animated">
    <ng-container *ngIf="post.postedBy == userId">
      <li role="menuitem">
        <a id="business_post_edit_post_button" (click)="findPost(post, editpost)" class="dropdown-item d-flex align-items-center">
          <ng-icon name="tablerPencil" class="mr-1"></ng-icon> Edit
        </a>
      </li>
      <li role="menuitem">
        <a id="business_post_delete_post_button" (click)="removepost(post)" class="dropdown-item d-flex align-items-center text-danger">
          <ng-icon name="tablerTrash" class="mr-1"></ng-icon> Delete
        </a>
      </li>
    </ng-container>
    <ng-container *ngIf="post.postedBy != userId">
      <li class="report" role="menuitem">
        <a class="dropdown-item d-flex align-items-center text-danger">
          <app-flag [type]="post.postEntity" [id]="post.postId" [flagTo]="post.postedBy"
            (onReport)="loadPost($event)"
            [flags]="['Abuse','Sexual content','Politics', ' Particularly in relation to religion','Vulgar language']">
          </app-flag>
        </a>
      </li>
    </ng-container>
  </ul>
</div>

                <div class="time" *ngIf="post?.userName!='Gigsumo'&&!post.isPlatformPost">
                  <ng-icon name="tablerClock" style="font-size: 14px"></ng-icon>
                  <small class="text-muted">{{ post?.postedOn | timezoneDate:'MMM dd, yyyy hh:mm a' }}</small>


                </div>
              </div>
            </div>
            <div class="gigsumo-welcome-card" *ngIf="post.isWelcomePost">
              <h4 class="welcome-title">Welcome To GigSumo! <span class="welcome-emoji" aria-hidden="true">🎉</span></h4>
              <p class="form-group padrtt content-align welcome-body-text">
                <span class="welcome-greeting-name" title="{{firstName}} {{lastName}}">Hi {{firstName}} {{lastName}},</span> <span class="welcome-body-content"> GigSumo is an inclusive community for Recruitment professionals. Our mission is to help recruiters and job seekers connect and grow through the power of a community. You can connect with other members, join communities, follow businesses, share, learn, and discover new tools for success.</span>
              </p>

              <div class="welcome-stats-banner">
                <div class="welcome-stats-banner-title">Connect &middot; Match</div>
                <div class="welcome-stats-banner-subtitle">The Recruiting Platform Built for Growth</div>
                <div class="welcome-stats-row">
                  <div class="welcome-stat">
                    <div class="welcome-stat-value stat-purple">10K+</div>
                    <div class="welcome-stat-label">MEMBERS</div>
                  </div>
                  <span class="welcome-stat-divider"></span>
                  <div class="welcome-stat">
                    <div class="welcome-stat-value stat-green">92%</div>
                    <div class="welcome-stat-label">MATCH RATE</div>
                  </div>
                  <span class="welcome-stat-divider"></span>
                  <div class="welcome-stat">
                    <div class="welcome-stat-value stat-blue">47K</div>
                    <div class="welcome-stat-label">JOBS POSTED</div>
                  </div>
                </div>
              </div>

              <div class="welcome-hashtags">
                <span class="welcome-hashtag">#Recruiting</span>
                <span class="welcome-hashtag">#TechJobs</span>
                <span class="welcome-hashtag">#GigSumo</span>
                <span class="welcome-hashtag">#Community</span>
              </div>

              <hr class="welcome-divider" />

              <div class="gig-subscribe-btn welcome-footer-row">
                <div class="welcome-footer-note">
                  <ng-icon name="tablerMessage"></ng-icon>
                  <span>Introduce yourself and meet other members!</span>
                </div>
                <button id="business_post_join_community_button" type="button" style="margin-bottom: 20px;" disabled *ngIf="!globalCommunity.joined"
                  class="btn-primary btn" (click)="subscribeGigSumoCommunity()">Join Community</button>
                <button id="business_post_joined_community_button" type="button" style="margin-bottom: 20px;" disabled *ngIf="globalCommunity.joined"
                  class="btn-primary btn">Joined
                  Community</button>
              </div>
            </div>
            <div class="social-content m-t-md mx-fety platform-html-content" *ngIf="post.isPlatformPost &&post.postId!='WELCOME001'"
              [innerHtml]="post.postContent"></div>
            <div class="social-content m-t-md mx-fety"
              *ngIf="post.isPlatformPost!=true && !post.isWelcomePost && post.isPlatformPost && post.postContent  && post.postContent.length > 600">
              <div class="showmore break-word" *ngIf="post.isWelcomePost" [class.show]="post.visible"
                [innerHtml]="post.postContent"></div>

              <div class="rowbay">

                <div *ngIf="post.medias?.length==1">
                  <div *ngFor="let imageshare of post.medias; let i = index;">
                    <ng-container class="col-sm-12" *ngIf="imageshare.type === 'image'">
                      <div class="carousel-image">
                        <img id="business_post_single_media_image" [src]="imageshare.url" class="hover-effect" (click)="pushImages(post.medias, i)" />
                      </div>
                    </ng-container>
                    <ng-container class="col-sm-12" *ngIf="imageshare.type === 'video'">
                      <video id="business_post_single_media_video" width="100%" controls (click)="pushImages(post.medias, i)" class="hover-effect"
                        #videoPlayer>
                        <source [src]="imageshare.url" />
                      </video>

                    </ng-container>
                  </div>
                </div>
                <div *ngIf="post.medias?.length>1">
                  <section id="photos">
                    <div *ngIf="post.medias.length === 2 || post.medias.length === 4">
                      <div class="even" *ngFor="let photos of post.medias; let i = index;">

                        <ng-container *ngIf="photos.type=='image'">
                          <img id="business_post_media_gallery_image_{{i}}" [src]=[photos.url] alt="datas" class="hover-effect" (click)="pushImages(post.medias, i)">
                        </ng-container>
                        <ng-container>
                          <video id="business_post_media_gallery_video_{{i}}" *ngIf="photos.type=='video'" width="100%" controls (click)="pushImages(post.medias, i)"
                            class="hover-effect" #videoPlayer>
                            <source [src]="photos.url" />
                          </video>
                        </ng-container>
                      </div>
                    </div>
                    <div *ngIf="post.medias?.length === 3">
                      <div class="three" *ngFor="let photos of post.medias; let i = index;">

                        <ng-container *ngIf="photos.type=='image'">
                          <img id="business_post_media_gallery_image_{{i}}" [src]=[photos.url] alt="datas" class="hover-effect" (click)="pushImages(post.medias, i)">
                        </ng-container>
                        <ng-container>
                          <video id="business_post_media_gallery_video_{{i}}" *ngIf="photos.type=='video'" width="100%" controls (click)="pushImages(post.medias, i)"
                            class="hover-effect" #videoPlayer>
                            <source [src]="photos.url" />
                          </video>
                        </ng-container>
                      </div>
                    </div>
                    <div *ngIf="post.medias?.length === 5">
                      <div class="five" *ngFor="let photos of post.medias; let i = index;">

                        <ng-container *ngIf="photos.type=='image'">
                          <img id="business_post_media_gallery_image_{{i}}" [src]=[photos.url] alt="datas" class="hover-effect" (click)="pushImages(post.medias, i)">
                        </ng-container>
                        <ng-container>
                          <video id="business_post_media_gallery_video_{{i}}" *ngIf="photos.type=='video'" width="100%" controls (click)="pushImages(post.medias, i)"
                            class="hover-effect" #videoPlayer>
                            <source [src]="photos.url" />
                          </video>
                        </ng-container>
                      </div>
                    </div>
                    <div *ngIf="post.medias?.length === 6">
                      <div class="even" *ngFor="let photos of post.medias; let i = index;">

                        <ng-container *ngIf="photos.type=='image'">
                          <img id="business_post_media_gallery_image_{{i}}" [src]=[photos.url] alt="datas" class="hover-effect" (click)="pushImages(post.medias, i)">
                        </ng-container>
                        <ng-container>
                          <video id="business_post_media_gallery_video_{{i}}" *ngIf="photos.type=='video'" width="100%" controls (click)="pushImages(post.medias, i)"
                            class="hover-effect" #videoPlayer>
                            <source [src]="photos.url" />
                          </video>
                        </ng-container>
                      </div>
                    </div>
                    <div *ngIf="post.medias?.length > 6">
                      <div class="sixPlus" *ngFor="let photos of post.medias; let i = index;">

                        <ng-container *ngIf="photos.type=='image' && 4>i">
                          <img id="business_post_media_gallery_image_{{i}}" [src]=[photos.url] alt="datas" class="hover-effect" (click)="pushImages(post.medias, i)">
                        </ng-container>
                        <ng-container>
                          <video *ngIf="photos.type=='video' && 4>i" width="100%" controls
                            (click)="pushImages(post.medias, i)" class="hover-effect" #videoPlayer>
                            <source [src]="photos.url" />
                          </video>
                        </ng-container>
                        <span id="business_post_media_gallery_plus_icon_{{i}}" class="plusIcon" (click)="pushImages(post.medias, i)"
                          *ngIf="post.medias.length>6 && i==3">+{{post.medias.length-4}} more</span>
                      </div>
                    </div>
                  </section>
                </div>
              </div>
            </div>
            <div class="social-content m-t-md mx-efty img-post-algn break-word"
              *ngIf="!post.isPlatformPost && !post.isWelcomePost">
              <div [class.show]="post.visible" *ngIf="!post.isPlatformPost && !post.isWelcomePost"
                [innerHtml]="post.postContent" class="post-content"></div>

              <div *ngIf="post.medias != null && post.medias.length > 0">
                <div class="rowbay">

                  <div *ngIf="post.medias?.length==1">
                    <div *ngFor="let imageshare of post.medias; let i = index;">

                      <ng-container class="col-sm-12" *ngIf="imageshare.type === 'image'">
                        <div class="carousel-image">
                          <img id="business_post_single_carousel_image" [src]="imageshare?.url" class="hover-effect" (click)="pushImages(post.medias, i)" />
                        </div>
                      </ng-container>
                      <ng-container class="col-sm-12" *ngIf="imageshare.type === 'video'">
                        <video id="business_post_single_carousel_video" width="100%" controls    (click)="pushImages(post.medias, i)" class="hover-effect"
                          #videoPlayer>
                          <source [src]="imageshare?.url" />
                        </video>

                      </ng-container>
                    </div>
                  </div>
                  <div *ngIf="post.medias?.length>1">
                    <section id="photos">
                      <div *ngIf="post.medias?.length === 2 || post.medias.length === 4">
                        <div class="even" *ngFor="let photos of post.medias; let i = index;">

                          <ng-container *ngIf="photos.type=='image'">
                            <img [src]=[photos.url] alt="datas" class="hover-effect"
                              (click)="pushImages(post.medias, i)">
                          </ng-container>
                          <ng-container>
                            <video *ngIf="photos.type=='video'" width="100%" controls
                              (click)="pushImages(post.medias, i)" class="hover-effect" #videoPlayer>
                              <source [src]="photos.url" />
                            </video>
                          </ng-container>
                        </div>
                      </div>
                      <div *ngIf="post.medias?.length === 3">
                        <div class="three" *ngFor="let photos of post.medias; let i = index;">

                          <ng-container *ngIf="photos.type=='image'">
                            <img [src]=[photos.url] alt="datas" class="hover-effect"
                              (click)="pushImages(post.medias, i)">
                          </ng-container>
                          <ng-container>
                            <video *ngIf="photos.type=='video'" width="100%" controls
                              (click)="pushImages(post.medias, i)" class="hover-effect" #videoPlayer>
                              <source [src]="photos.url" />
                            </video>
                          </ng-container>
                        </div>
                      </div>
                      <div *ngIf="post.medias?.length === 5">
                        <div class="five" *ngFor="let photos of post.medias; let i = index;">

                          <ng-container *ngIf="photos.type=='image'">
                            <img [src]=[photos.url] alt="datas" class="hover-effect"
                              (click)="pushImages(post.medias, i)">
                          </ng-container>
                          <ng-container>
                            <video *ngIf="photos.type=='video'" width="100%" controls
                              (click)="pushImages(post.medias, i)" class="hover-effect" #videoPlayer>
                              <source [src]="photos.url" />
                            </video>
                          </ng-container>
                        </div>
                      </div>
                      <div *ngIf="post.medias?.length === 6">
                        <div class="even" *ngFor="let photos of post.medias; let i = index;">

                          <ng-container *ngIf="photos.type=='image'">
                            <img [src]=[photos.url] alt="datas" class="hover-effect"
                              (click)="pushImages(post.medias, i)">
                          </ng-container>
                          <ng-container>
                            <video *ngIf="photos.type=='video'" width="100%" controls
                              (click)="pushImages(post.medias, i)" class="hover-effect" #videoPlayer>
                              <source [src]="photos.url" />
                            </video>
                          </ng-container>
                        </div>
                      </div>
                      <div *ngIf="post.medias?.length > 6">
                        <div class="sixPlus" *ngFor="let photos of post.medias; let i = index;">

                          <ng-container *ngIf="photos.type=='image' && 4>i">
                            <img [src]=[photos.url] alt="datas" class="hover-effect"
                              (click)="pushImages(post.medias, i)">
                          </ng-container>
                          <ng-container>
                            <video *ngIf="photos.type=='video' && 4>i" width="100%" controls
                              (click)="pushImages(post.medias, i)" class="hover-effect" #videoPlayer>
                              <source [src]="photos.url" />
                            </video>
                          </ng-container>
                          <span id="business_post_media_gallery_plus_icon_{{i}}" class="plusIcon" (click)="pushImages(post.medias, i)"
                            *ngIf="post.medias.length>6 && i==3">+{{post.medias.length-4}} more</span>
                        </div>
                      </div>
                    </section>  
                  </div>
                </div>
              </div>
            </div>
            <app-carousel *ngIf="selectedImage1 !== null" (closeCarousel)="closeCarouselAndReopenShareModal()" [images]="images"
              [selectedImage1]="selectedImage1">
            </app-carousel>
            <ng-container *ngFor="let data of post.shareduser">
              <div *ngIf="data.postEntity == 'USER' || data.postEntity == 'BUSINESS'"
                class="panel-body border-radius-top-left-right-6">
                <div class="media social-profile clearfix mt-m12">
                  <a class="pull-left">
                    <!-- The person who wrote the source post. The business branch here used
                         to read `photo`, which holds the company logo on a business post.
                         Both entities read the poster now, and the business is still named
                         to the right. -->
                    <img *ngIf="data?.postedByUserData?.photo"
                      (click)="userprofile(post, data?.postedBy)" [src]="photoUrl + data?.postedByUserData?.photo"
                      (error)="onProfilePhotoError($event, post)" />

                    <!-- Initials of the poster. Keyed off their full name rather than
                         `userName`, which holds the business name on a business post. -->
                    <div *ngIf="!data?.postedByUserData?.photo">
                      <div class="circles" [style.background-color]="getColor(data?.postedByUserData?.fullName || data?.userName)">
                        <!-- Letter colour is derived from the same name the circle colour
                             above uses. It read `firstName`/`lastName`, which this record
                             never carries, so every repost hashed the same empty text and
                             landed on one colour that did not match its circle. Pairing
                             matches the Share dialog's block below. -->
                        <div class="circle-text" [style.color]="getFullNameTextColor(data?.postedByUserData?.fullName || data?.userName)" style="font-size: 18px !important; font-weight: bold;">{{ getInitials(data?.postedByUserData?.fullName || data?.userName) }}
                        </div>
                      </div>
                    </div>
                  </a>
                  <div class="media-body">
                    <!-- Was a single span printing `userName` for both entities. For a
                         business source that field holds the business name, so the poster
                         never appeared on the reposted card. -->
                    <span id="business_post_shared_user_name_link" *ngIf="data.postEntity == 'USER'"
                      (click)="userprofile(data, data.postedBy)" class="cursor-pointer post-font ellipse" title="{{ data.userName }}">
                      {{ data.userName }}
                    </span>

                    <!-- Poster then business, the same pair the top-level business post
                         header renders in the feed: poster name opens the person, business
                         name opens the business page through the same entity handler the
                         top-level header uses. -->
                    <div *ngIf="data.postEntity == 'BUSINESS'"
                      class="cursor-pointer post-font post-name-entity-inline">
                      <a class="fw-bold" data-toggle="tooltip" data-placement="top"
                        title="{{ data.postedByUserData?.fullName }}"
                        (click)="openPosterProfile(data)">
                        <span>{{ data.postedByUserData?.fullName }}</span>
                      </a>
                      <img src="assets/icon/arrow.png" alt="" srcset="" class="profilelink" />
                      <img src="assets/images/gallery/company.png" alt="" srcset="" class="profilelink" />
                      <a class="fw-bold community-name-link" data-toggle="tooltip" data-placement="top"
                        title="{{ data?.userName }}" (click)="communityroute(data)">
                        <span>{{ data?.userName }}</span>
                      </a>
                    </div>
                    <!-- Only the user branch needs this. Its name is an inline span, so the
                         break is what puts the timestamp on the next line. The business
                         branch above is a block and already breaks on its own; leaving the
                         break unconditional would add an empty line under it. -->
                    <br *ngIf="data.postEntity == 'USER'" />
                    <div class="time" style="margin-top: 0px;">
                      <ng-icon name="tablerClock" class="clock-icon" style="margin-left: 1px; font-size: 14px"></ng-icon>
                      <small class="text-muted">{{ data.postedOn | timezoneDate:'MMM dd, yyyy hh:mm a' }}</small>
                    </div>
                  </div>
                </div>
                <!-- The original was deleted after it was shared. The header above still names
                     the poster from the snapshot on the share row; this stands in for the
                     text and media, which are gone. -->
                <div class="gs-shared-unavailable" *ngIf="data.sourceUnavailable">
                  <ng-icon name="tablerInfoCircle"></ng-icon>
                  <span>This post is no longer available</span>
                </div>
                <!-- Guarded the way the Share dialog's equivalent block already is. Without
                     it, a source post with no text still reserved the clamp height below,
                     which showed as an empty box between the header and the media. Trimmed,
                     because empty post content is assigned a whitespace-only string
                     elsewhere in this component. -->
                <div class="social-content m-t-15" *ngIf="data.postContent && data.postContent.trim()">
                  <div class="showmore1 break-word" [class.show1]="data.visible" [innerHtml]="data.postContent"></div>

                </div>
                <div *ngIf="data.medias?.length==1" class="m-t-15">
                  <div *ngFor="let imageshare of data.medias; let i = index">
                    <ng-container class="col-sm-12" *ngIf="imageshare.type === 'image'">
                      <div class="carousel-image">
                        <img id="business_post_data_single_media_image" [src]="imageshare.url" class="hover-effect" (click)="pushImages(data.medias,i)" />
                      </div>
                    </ng-container>
                    <ng-container class="col-sm-12" *ngIf="imageshare.type === 'video'">
                      <video id="business_post_data_single_media_video" width="100%" controls (click)="pushImages(data.medias,i)" class="hover-effect"
                        #videoPlayer>
                        <source [src]="imageshare.url" />
                      </video>

                    </ng-container>
                  </div>
                </div>
                <div *ngIf="data.medias?.length>1" class="m-t-15">
                  <section id="photos">
                    <div *ngIf="data.medias.length === 2 || data.medias.length === 4">
                      <div class="even" *ngFor="let photos of data.medias; let i = index;">
                        <ng-container *ngIf="photos.type=='image'">
                          <img [src]=[photos.url] alt="datas" class="hover-effect" (click)="pushImages(data.medias, i)">
                        </ng-container>
                        <ng-container>
                          <video *ngIf="photos.type=='video'" width="100%" controls (click)="pushImages(data.medias, i)"
                            class="hover-effect" #videoPlayer>
                            <source [src]="photos.url" />
                          </video>
                        </ng-container>
                      </div>
                    </div>
                    <div *ngIf="data.medias?.length === 3">
                      <div class="three" *ngFor="let photos of data.medias; let i = index;">

                        <ng-container *ngIf="photos.type=='image'">
                          <img [src]=[photos.url] alt="datas" class="hover-effect" (click)="pushImages(data.medias, i)">
                        </ng-container>
                        <ng-container>
                          <video *ngIf="photos.type=='video'" width="100%" controls (click)="pushImages(data.medias, i)"
                            class="hover-effect" #videoPlayer>
                            <source [src]="photos.url" />
                          </video>
                        </ng-container>
                      </div>
                    </div>
                    <div *ngIf="data.medias?.length === 5">
                      <div class="five" *ngFor="let photos of data.medias; let i = index;">

                        <ng-container *ngIf="photos.type=='image'">
                          <img [src]=[photos.url] alt="datas" class="hover-effect" (click)="pushImages(data.medias, i)">
                        </ng-container>
                        <ng-container>
                          <video *ngIf="photos.type=='video'" width="100%" controls (click)="pushImages(data.medias, i)"
                            class="hover-effect" #videoPlayer>
                            <source [src]="photos.url" />
                          </video>
                        </ng-container>
                      </div>
                    </div>
                    <div *ngIf="data.medias?.length === 6">
                      <div class="even" *ngFor="let photos of data.medias; let i = index;">

                        <ng-container *ngIf="photos.type=='image'">
                          <img [src]=[photos.url] alt="datas" class="hover-effect" (click)="pushImages(data.medias, i)">
                        </ng-container>
                        <ng-container>
                          <video *ngIf="photos.type=='video'" width="100%" controls (click)="pushImages(data.medias, i)"
                            class="hover-effect" #videoPlayer>
                            <source [src]="photos.url" />
                          </video>
                        </ng-container>
                      </div>
                    </div>
                    <div *ngIf="data.medias?.length > 6">
                      <div class="sixPlus" *ngFor="let photos of data.medias; let i = index;">

                        <ng-container *ngIf="photos.type=='image' && 4>i">
                          <img [src]=[photos.url] alt="datas" class="hover-effect" (click)="pushImages(data.medias, i)">
                        </ng-container>
                        <ng-container>
                          <video *ngIf="photos.type=='video' && 4>i" width="100%" controls
                            (click)="pushImages(data.medias, i)" class="hover-effect" #videoPlayer>
                            <source [src]="photos.url" />
                          </video>
                        </ng-container>
                        <span class="plusIcon" (click)="pushImages(data.medias, i)"
                          *ngIf="data.medias.length>6 && i==3">+{{data.medias.length-4}} more</span>
                      </div>
                    </div>
                  </section>
                </div>
              </div>
              <div *ngIf="data.postEntity == 'COMMUNITY' || data.postEntity == 'NETWORK' || data.postEntity == 'TEAM'"
                class="panel-body border-radius-top-left-right-6">
                <div class="media social-profile clearfix mt-m12">
                  <a class="pull-left">
                    <!-- The person who wrote the source post, not the community, network or
                         workspace it was posted to. This used to read `logo`, which carried
                         that entity's own avatar. The entity is still named to the right.
                         `postedByUserData.photo` is a bare file id, so it takes the
                         download prefix; the entity logos it replaces were absolute. -->
                    <img *ngIf="data?.postedByUserData?.photo" (click)="userprofile(data, data.postedBy)"
                      class="share-logo" [src]="photoUrl + data?.postedByUserData?.photo"
                      (error)="onProfilePhotoError($event, data)" />
                    <!-- Community is no longer excluded: with the entity logo gone, a
                         community post with a photoless poster needs these initials too. -->
                    <div (error)="onProfilePhotoError($event, data)"
                      *ngIf="!data?.postedByUserData?.photo">
                      <div class="circles mr-rt-10"
                        [style.background-color]="getColor(data?.postedByUserData?.fullName)">
                        <div [style.color]="getTextColor(data?.postedByUserData?.firstName, data?.postedByUserData?.lastName)" class="circle-text pad-7"
                        style="font-family: Arial,sans-serif; font-size: 18px; font-weight: bold;"
                        >{{ getInitials(data?.postedByUserData?.fullName) }}</div>
                      </div>
                    </div>
                  </a>
                  <div class="media-body">

                    <ng-container>
                      <div data-toggle="tooltip" data-placement="top" title="{{ data.postedByUserData?.fullName }}"
                        class="m-0 cursor-pointer post-font post-name-entity-inline">
                       <h6 class="fw-bold m-0">
                         <a data-toggle="tooltip" data-placement="top" title="{{ data.postedByUserData?.fullName }}"
                           (click)="userprofile(data, data.postedBy)">
                           <span> {{ data.postedByUserData?.fullName }} </span>
                         </a>
                       </h6>
                        <img *ngIf="data.postEntity == 'COMMUNITY' && data?.postedBy && !data?.communityWelcomePost" src="assets/icon/arrow.png" alt="" srcset=""
                          class="profilelink" />
                        <img *ngIf="data.postEntity != 'COMMUNITY'" src="assets/icon/arrow.png" alt="" srcset=""
                          class="profilelink" />
                        <img src="assets/icon/icons8-myspace-400.png" *ngIf="data.postEntity == 'COMMUNITY' " alt=""
                          srcset="" class="profilelink" />
                        <img src="assets/icon/icons8-share-400.png" *ngIf="data.postEntity == 'NETWORK'  " alt=""
                          srcset="" class="profilelink" />
                        <img src="assets/icon/icons8-people-100.png" *ngIf="data.postEntity == 'TEAM'" alt="" srcset=""
                          class="profilelink" />
                        <img src="assets/icon/icons8-small-business-100.png" *ngIf="data.postEntity == 'BUSINESS'"
                          alt="" srcset="" class="profilelink" />
                          <h6 class="fw-bold m-0">
                            <a data-toggle="tooltip" data-placement="top" title="{{ data?.userName }}"
                              (click)="communityroute(data)">
                              <span>{{ data?.userName}}</span>
                            </a>
                          </h6>
                      </div>
                    </ng-container>

                    <div class="time" style="margin-top: 0px;">
                      <ng-icon name="tablerClock" class="clock-icon" style="margin-left: 1px; font-size: 14px"></ng-icon>
                      <small class="text-muted">{{ data.postedOn | timezoneDate:'MMM dd, yyyy hh:mm a' }}</small>
                    </div>
                  </div>
                </div>
                <!-- The original was deleted after it was shared. The header above still names
                     the poster from the snapshot on the share row; this stands in for the
                     text and media, which are gone. -->
                <div class="gs-shared-unavailable" *ngIf="data.sourceUnavailable">
                  <ng-icon name="tablerInfoCircle"></ng-icon>
                  <span>This post is no longer available</span>
                </div>
                <!-- Guarded the way the Share dialog's equivalent block already is. Without
                     it, a source post with no text still reserved the clamp height below,
                     which showed as an empty box between the header and the media. Trimmed,
                     because empty post content is assigned a whitespace-only string
                     elsewhere in this component. -->
                <div class="social-content m-t-15" *ngIf="data.postContent && data.postContent.trim()">
                  <div class="showmore1 break-word" [class.show1]="data.visible" [innerHtml]="data.postContent"></div>

                </div>
                <!-- Separates the media from the header above it. The text block above
                     carries this same 15px, but it only renders when the source post has
                     text, so a picture-only post dropped its image flush against the
                     header and the avatar — the tallest item in that flex row — read as
                     overlapping it. The user/business branch above already puts this on
                     both of its media wrappers; this branch was missed. One wrapper, so
                     every media count is covered. -->
                <div class="m-t-15" *ngIf="data.medias != null && data.medias.length > 0">

                  <div *ngIf="data.medias?.length==1">
                    <div *ngFor="let imageshare of data.medias; let i = index;">
                      <ng-container class="col-sm-12" *ngIf="imageshare.type === 'image'">
                        <div class="carousel-image">
                          <img [src]="imageshare.url" class="hover-effect" (click)="pushImages(data.medias, i)" />
                        </div>
                      </ng-container>
                      <ng-container class="col-sm-12" *ngIf="imageshare.type === 'video'">
                        <video width="100%" controls (click)="pushImages(data.medias, i)" class="hover-effect"
                          #videoPlayer>
                          <source [src]="imageshare.url" />
                        </video>

                      </ng-container>
                    </div>
                  </div>
                  <div *ngIf="data.medias?.length>1">
                    <section id="photos">
                      <div *ngIf="data.medias?.length === 2 || data.medias.length === 4">
                        <div class="even" *ngFor="let photos of data.medias; let i = index;">
                          <ng-container *ngIf="photos.type=='image'">
                            <img [src]=[photos.url] alt="datas" class="hover-effect"
                              (click)="pushImages(data.medias, i)">
                          </ng-container>
                          <ng-container>
                            <video *ngIf="photos.type=='video'" width="100%" controls
                              (click)="pushImages(data.medias, i)" class="hover-effect" #videoPlayer>
                              <source [src]="photos.url" />
                            </video>
                          </ng-container>
                        </div>
                      </div>
                      <div *ngIf="data.medias?.length === 3">
                        <div class="three" *ngFor="let photos of data.medias; let i = index;">
                          <!-- <img [src]=[photos.url] alt="datas" class="hover-effect" (click)="pushImages(data.medias, i)"> -->
                          <ng-container *ngIf="photos.type=='image'">
                            <img [src]=[photos.url] alt="datas" class="hover-effect"
                              (click)="pushImages(data.medias, i)">
                          </ng-container>
                          <ng-container>
                            <video *ngIf="photos.type=='video'" width="100%" controls
                              (click)="pushImages(data.medias, i)" class="hover-effect" #videoPlayer>
                              <source [src]="photos.url" />
                            </video>
                          </ng-container>
                        </div>
                      </div>
                      <div *ngIf="data.medias?.length === 5">
                        <div class="five" *ngFor="let photos of data.medias; let i = index;">
                          <!-- <img [src]=[photos.url] alt="datas" class="hover-effect" (click)="pushImages(data.medias, i)"> -->
                          <ng-container *ngIf="photos.type=='image'">
                            <img [src]=[photos.url] alt="datas" class="hover-effect"
                              (click)="pushImages(data.medias, i)">
                          </ng-container>
                          <ng-container>
                            <video *ngIf="photos.type=='video'" width="100%" controls
                              (click)="pushImages(data.medias, i)" class="hover-effect" #videoPlayer>
                              <source [src]="photos.url" />
                            </video>
                          </ng-container>
                        </div>
                      </div>
                      <div *ngIf="data.medias?.length === 6">
                        <div class="even" *ngFor="let photos of data.medias; let i = index;">
                          <!-- <img [src]=[photos.url] alt="datas" class="hover-effect" (click)="pushImages(data.medias, i)"> -->
                          <ng-container *ngIf="photos.type=='image'">
                            <img [src]=[photos.url] alt="datas" class="hover-effect"
                              (click)="pushImages(data.medias, i)">
                          </ng-container>
                          <ng-container>
                            <video *ngIf="photos.type=='video'" width="100%" controls
                              (click)="pushImages(data.medias, i)" class="hover-effect" #videoPlayer>
                              <source [src]="photos.url" />
                            </video>
                          </ng-container>
                        </div>
                      </div>
                      <div *ngIf="data.medias?.length > 6">
                        <div class="sixPlus" *ngFor="let photos of data.medias; let i = index;">
                          <!-- <img *ngIf="4>i" [src]=[photos.url] alt="datas" class="hover-effect"
                            (click)="pushImages(data.medias, i)"> -->
                          <ng-container *ngIf="photos.type=='image' && 4>i">
                            <img [src]=[photos.url] alt="datas" class="hover-effect"
                              (click)="pushImages(data.medias, i)">
                          </ng-container>
                          <ng-container>
                            <video *ngIf="photos.type=='video' && 4>i" width="100%" controls
                              (click)="pushImages(data.medias, i)" class="hover-effect" #videoPlayer>
                              <source [src]="photos.url" />
                            </video>
                          </ng-container>
                          <span class="plusIcon" (click)="pushImages(data.medias, i)"
                            *ngIf="data.medias.length>6 && i==3">+{{data.medias.length-4}} more</span>
                        </div>
                      </div>
                    </section>
                  </div>
                </div>
              </div>
              <!-- Share made before the poster snapshot existed, whose original is already
                   gone: nothing is known about the poster, so only the message renders. -->
              <div *ngIf="data.sourceUnavailable && !data.postEntity"
                class="panel-body border-radius-top-left-right-6">
                <div class="gs-shared-unavailable">
                  <ng-icon name="tablerInfoCircle"></ng-icon>
                  <span>This post is no longer available</span>
                </div>
              </div>
            </ng-container>
          </div>
          <div class="panel-footer footerpost border-radius-top-left-right-0 footer-line"
            *ngIf="post?.isPlatformPost==null || post.isPlatformPost!=true">
            <div class="row">
              <div class="col-md-12">
                <ul class="social-details-social-counts" *ngIf="post.likesCount > 0 || post.commentsCount > 0">
                  <li class="social-details-social-counts__item" *ngIf="post.likesCount > 0">
                    <span class="lk-icon" aria-hidden="true">
                      <!-- Filled thumbs-up in emoji colours (yellow hand, darker cuff) — an SVG so it
                           renders identically on every OS, unlike the mock's 👍 glyph. -->
                      <svg viewBox="0 0 24 24">
                        <path class="lk-cuff" d="M1 21h4V9H1v12z"/>
                        <path class="lk-hand" d="M23 10c0-1.1-.9-2-2-2h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 1 7.59 7.59C7.22 7.95 7 8.45 7 9v10c0 1.1.9 2 2 2h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73v-2z"/>
                      </svg>
                    </span>
                    <span class="mr-2 ml-2">{{ post.likesCount }}</span>
                    <span>like<ng-container *ngIf="post.likesCount > 1">s</ng-container></span>
                  </li>
                  <li class="social-details-social-counts__item" *ngIf="post.commentsCount > 0">
                    <span class="mr-2 ml-2">{{ post.commentsCount }}</span>
                    <span>comment<ng-container *ngIf="post.commentsCount > 1">s</ng-container></span>
                  </li>
                  <!-- <li class="social-details-social-counts__item" *ngIf="post.sharedCount > 0">
                    <span class="mr-2 ml-2">{{ post.sharedCount }}</span>
                    <span>share<ng-container *ngIf="post.sharedCount > 1">s</ng-container></span>
                  </li> -->
                </ul>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="social-form">
                  <!-- Icons mirror the wireframe `.fc-act` set (thumbs-up / speech bubble /
                       share-nodes); `stroke="currentColor"` so the liked/hover colour is CSS-driven. -->
                  <a class="card-link common-font-12 rel-5-fill-liked" *ngIf="post.userLikedStatus" (click)="like(post, i, false)">
                    <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3H14z"/>
                      <path d="M7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3"/>
                    </svg>
                    <span > Like</span></a>
                  <a class="card-link common-font-12 rel-5-fill" *ngIf="!post.userLikedStatus" (click)="like(post, i, true)">
                    <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3H14z"/>
                      <path d="M7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3"/>
                    </svg>
                    <span > Like</span>
                  </a>
                  <a class="card-link common-font-12 rel-5" (click)="commentBox.focus()">
                    <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
                    </svg>
                    <span >
                      Comment</span></a>
                  <a class="card-link common-font-12 rel-5" (click)="share(post, shareModelData)" *ngIf="!post.isWelcomePost">
                    <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/>
                      <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/>
                    </svg>
                    <span > Share</span></a>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <ng-container *ngFor="let cmd of post.comments">
                  <div class="social-talk">
                    <div class="media social-profile clearfix">
                      <a class="pull-left">

                        <img *ngIf="cmd?.photo != undefined && cmd?.photo != null"
                          (click)="userprofile(post, cmd?.userId)" src="{{ cmd?.photo }}" />

                        <div (click)="userprofile(post, cmd?.userId)"
                          *ngIf="cmd?.photo == undefined || cmd?.photo == null">
                          <div class="circles h-w-35" [style.background-color]="getColor(cmd?.userName)">
                            <div [style.color]="getFullNameTextColor(cmd?.userName)" class="circle-text ft-18">{{ getInitials(cmd?.userName) }}
                            </div>
                          </div>
                        </div>

                      </a>
                      <div class="media-body" style="font-size: 13px">
                        <span class="font-extra-bold mr-2 cursor-pointer ellipse"
                          (click)="userprofile(undefined, cmd.userId)">{{ cmd.userName }}</span>
                        <small class="text-muted">{{ cmd.commentedOn | timezoneDate:'MMM dd, yyyy hh:mm a' }}</small>
                        <div class="comment-actions btn-group" dropdown placement="bottom right"
                          #cmtKebab="bs-dropdown"
                          (onShown)="bindKebabAutoClose(cmtKebab)"
                          (onHidden)="unbindKebabAutoClose()"
                          *ngIf="cmd.userId == userId || post.postedBy == userId">
                          <button dropdownToggle type="button" class="three-dots-btn comment-kebab" aria-label="More options">
                            <ng-icon name="tablerDotsVertical"></ng-icon>
                          </button>
                          <ul id="dropdown-animated" *dropdownMenu class="dropdown-menu modern-post-dropdown comment-dropdown" role="menu">
                            <li role="menuitem" *ngIf="cmd.userId == userId && editingCommentId !== cmd.commentId">
                              <a (click)="startEditComment(cmd)" class="dropdown-item d-flex align-items-center">
                                <ng-icon name="tablerPencil" class="mr-1"></ng-icon> Edit
                              </a>
                            </li>
                            <li role="menuitem">
                              <a (click)="deleteComment(post, cmd)" class="dropdown-item d-flex align-items-center text-danger">
                                <ng-icon name="tablerTrash" class="mr-1"></ng-icon> Delete
                              </a>
                            </li>
                          </ul>
                        </div>
                        <div class="social-content" *ngIf="editingCommentId !== cmd.commentId" [innerHtml]="cmd.comment"></div>
                        <div class="comment-edit-box" *ngIf="editingCommentId === cmd.commentId">
                          <textarea class="form-control comment-area" rows="2" [(ngModel)]="editingCommentText"
                            name="editComment{{cmd.commentId}}" (keydown.escape)="cancelEditComment()"></textarea>
                          <div class="text-danger" *ngIf="editingCommentText && editingCommentText.length > 500">Maximum 500 characters allowed.</div>
                          <div class="comment-edit-footer">
                            <button type="button" class="btn btn-default btn-sm" (click)="cancelEditComment()">Cancel</button>
                            <button type="button" class="btn btn-primary btn-sm"
                              [disabled]="!editingCommentText?.trim() || editingCommentText.length > 500"
                              (click)="saveEditComment(post, cmd)">Save</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-container>
                <div class="load-more-less">
                  <ng-container *ngIf="
                      post.commentsCount > 3 &&
                      post.comments &&
                      post.comments.length != post.commentsCount
                    ">
                    <button id="business_post_load_more_comments_button" type="button" class="btn btn-default load-more-btn" (click)="loadMoreComments(post)">
                      More Comments
                    </button>
                  </ng-container>
                  <ng-container *ngIf="post.comments && post.comments.length >= 6">
                    <button id="business_post_load_previous_comments_button" type="button" class="btn btn-default load-more-btn pull-right"
                      (click)="loadPreviousComments(post)">
                      Previous Comments
                    </button>
                  </ng-container>
                </div>
              </div>
              <div class="col-sm-12">
                <div class="social-talk">
                  <div class="media social-profile clearfix">
                    <a class="pull-left">



                      <img *ngIf="loginUser.photo != undefined && loginUser.photo != null"
                        (click)="userprofile(undefined, loginUser.userId)" src="{{ loginUser.photo }}" />

                      <div (click)="userprofile(undefined, loginUser.userId)"
                        *ngIf="loginUser.photo == undefined || loginUser.photo == null">
                        <div class="circles h-w-35"
                          [style.background-color]="getColortwo(loginUser.firstName, loginUser.lastName)">
                          <div [style.color]="getTextColor(loginUser?.firstName, loginUser?.lastName)" class="ft-18">{{ getInitialstwo(loginUser.firstName,
                            loginUser.lastName) }}
                          </div>
                        </div>
                      </div>
                    </a>
                    <div class="media-body">
                      <textarea
                        #commentBox
                        [(ngModel)]="post.cmd"
                        #commentInput="ngModel"
                        name="comment"
                        class="form-control comment-area com-height"
                        placeholder="Add a comment..."
                        [ngClass]="{'is-invalid': commentInput.invalid && commentInput.touched}"
                        (input)="adjustHeight($event)"
                        required
                        rows="1"
                      ></textarea>
                      <div class="text-danger">
                        <div *ngIf="post.cmd && post.cmd.length > 500">Maximum 500 characters allowed.</div>
                    </div>
                    </div>
                    <button id="business_post_comment_post_button" [disabled]="post.cmd?.length > 500 || !post.cmd"  *ngIf="post.cmd" (click)="(cmdpage(post, 'comment', i, ''))"class="btn  btn-primary m-lbp">Post</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <app-common-skeleton *ngIf="loadApicall" [NameOftheScreen]="'postPage'"></app-common-skeleton>


    <ng-template #shareModelData>

      <div class="common-header-flex" *ngIf="!commonVariables.postPrivacyFlag">
        <div>Share</div>
        <button id="business_post_share_close_wrapper_button">
          <span class="common-close" (click)="closeSharePage()">&times;</span>
        </button>
      </div>
      <div>
        <hr style="margin: 0px !important; padding: 0px !important" *ngIf="commonVariables.postPrivacyFlag">
      </div>
      <div *ngIf="!commonVariables.postPrivacyFlag" class="panel-body border-radius-top-left-right-6">
        <div class="row encased" [class.has-media]="selectedMediaType === 'photo' || selectedMediaType === 'video' || uploadFiles.length > 0" style="display: flex; align-items: flex-start;">
          <div class="col-sm-2 pd-rt-0">
            <img *ngIf="profPhoto" class="avtar" style="border-radius: 50% !important;" src="{{profPhoto}}" />
            <div *ngIf="!profPhoto">
              <div class="circles" [style.background-color]="getColor(profName)">
                <div [style.color]="getFullNameTextColor(profName)" class="circle-text" style="font-size: 18px !important; font-weight: bold;">{{ getInitials(profName) }}</div>
              </div>
            </div>
          </div>
          <div class="col-sm-4 pd-lt-0">
            <div class="row" [class.name-row-no-menu]="Commomdatass != 'USER'">
              <h6 class="ellipse2 text-only" title="{{profName}}">{{profName}}</h6>
            </div>
            <div>

              <div class="row" [formGroup]="postTypeForm" style="display: flex;"
                *ngIf="(editPost && privacyValue == 'Connections') || !editPost">
                <input id="postType" formControlName="postType" [value]="privacyValue" style="display: none!important;">

                <div yPosition="below" *ngIf="showSharePrivacyMenu()" xPosition="after" [matMenuTriggerFor]="menu">
                  <button id="business_post_share_privacy_menu_button" class="btn btn-default">
                    <ng-icon name="tablerWorld" *ngIf="privacyValue == 'Everyone'"></ng-icon>
                    <ng-icon name="tablerUsers" *ngIf="privacyValue == 'Connections'"></ng-icon>
                    <ng-icon name="tablerNetwork" *ngIf="privacyValue == 'Network'"></ng-icon>
                    <ng-icon name="tablerUsers" *ngIf="privacyValue == 'Community'"></ng-icon>
                    <span class="opaa1"> {{privacyValue}}
                      <ng-icon name="tablerChevronDown" style="padding-left: 0.3rem;"></ng-icon>
                    </span>
                  </button>
                  <mat-menu #menu="matMenu">
                    <button id="business_post_share_privacy_everyone_button" class="mat-menu-height" mat-menu-item [disabled]="editPost"
                      (click)="changePostModal('Everyone', 'post')">
                      <ng-icon name="tablerWorld"></ng-icon>
                      <span class="opaa">Everyone</span>
                    </button>
                    <button id="business_post_share_privacy_connections_button" type="button" [disabled]="editPost && privacyValue != 'Connections'"
                      (click)="changePostModal('Connections', 'post')" class="mat-menu-height" mat-menu-item>
                      <ng-icon name="tablerUsers"></ng-icon>
                      <span class="opaa">Connections</span>
                    </button>
                    <button id="business_post_share_privacy_network_button" type="button" [disabled]="editPost" (click)="changePostModal('Network', 'post')"
                      class="mat-menu-height" mat-menu-item>
                      <ng-icon name="tablerNetwork"></ng-icon>
                      <span class="opaa">Network</span>
                    </button>
                    <button id="business_post_share_privacy_community_button" type="button" [disabled]="editPost" (click)="changePostModal('Community', 'post')"
                      class="mat-menu-height" mat-menu-item>
                      <ng-icon name="tablerUsers"></ng-icon>
                      <span class="opaa">Community</span>
                    </button>
                  </mat-menu>
                </div>

                <div style="position: relative; left: 1rem; display: flex; column-gap: 0.5rem;">
                  <div *ngFor="let entity of selectedEntities; let i = index;">
                    <div *ngIf="i<2">

                      <div title="{{entity}}" class="ioxlp">
                        {{entity}}
                      </div>
                    </div>
                    <span class="uwmp" *ngIf="selectedEntities.length>2 && i==2">and {{selectedEntities.length - 2}}
                      others</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div [formGroup]="urlLinkDetctForm" class="post-text" style="margin-top: 3px">
          <div formControlName="snippedLinkText" [(ngModel)]="sharePost.thoughts" name="message" id="summessage"
            [ngxSummernote]="config1" class="form-control note-editor.note-frame"></div>
          <div class="kjsiopzx"
            *ngIf="linkTitle != null || linkImage != null || linkDescription != null || linkURL != null">
            <div class="djwjpbf">
              <img src="{{linkImage}}" alt="">
            </div>
            <div class="sdiuqwfp">
              <h5>{{linkTitle}}</h5>
              <div>{{linkDescription}}</div>
              <div class="sdfkfldp">
                <a href="{{linkURL}}" target="_blank">{{linkURL}}</a>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div *ngIf="!commonVariables.postPrivacyFlag" class="modal-body" style="padding: 12px 15px !important">
        <div class="p-10">
          <div class="media social-profile clearfix share-preview-header">
            <a class="pull-left">

              <!-- The Share screen shows the person who wrote the source post, not the
                   business, network, workspace or community it was posted to. That entity
                   is still named beside it, with its own icon, in the row to the right.
                   There used to be four branches here, one per entity, each reading that
                   entity's logo; they all resolve to the poster now.
                   `postedByUserData.photo` is a bare file id, so it takes the download
                   prefix — unlike the entity logos, which were already absolute. -->
              <img class="share-logo" *ngIf="sharePost?.postedByUserData?.photo"
                (click)="userprofile(sharePost, sharePost?.postedBy)"
                [src]="photoUrl + sharePost?.postedByUserData?.photo"
                (error)="onProfilePhotoError($event, sharePost)" />

              <!-- Initials of the poster, for a poster with no photo. Keyed off their full
                   name rather than `userName`, which holds the entity's name on an entity
                   post. No entity is excluded any more, since every entity now falls here. -->
              <div *ngIf="!sharePost?.postedByUserData?.photo">
                <div class="circles mr-rt-10"
                  [style.background-color]="getColor(sharePost?.postedByUserData?.fullName || sharePost?.userName)">
                  <div class="circle-text "
                    [style.color]="getFullNameTextColor(sharePost?.postedByUserData?.fullName || sharePost?.userName)"
                    style="font-weight: bold; font-size: 15px; font-family: Arial, sans-serif;">{{ getInitials(sharePost?.postedByUserData?.fullName || sharePost?.userName) }}</div>
                </div>
              </div>
            </a>
            <div class="media-body">
              <!-- Was `(sharePost.postEntity == 'USER' || sharePost.postEntity == 'BUSINESS')`,
                   which printed `userName` alone. For a business post that field holds the
                   business name, so the poster never appeared. Business now renders below. -->
              <h6 *ngIf="(sharePost.postEntity == 'USER')"
                (click)="redirectUserFromShareModel(sharePost, sharePost.postedBy)" data-toggle="tooltip"
                data-placement="top" title="{{ sharePost.firstName }}" class="m-0 cursor-pointer post-font ellipse1">
                {{ sharePost.userName }}
              </h6>

              <!-- Poster then business, the same pair the top-level business post header
                   renders in the feed. The business name closes this dialog and opens the
                   business page through the same entity handler the feed header uses. -->
              <div *ngIf="sharePost.postEntity == 'BUSINESS'"
                class="cursor-pointer post-font post-name-entity-inline">
                <a class="fw-bold" data-toggle="tooltip" data-placement="top"
                  title="{{ sharePost.postedByUserData?.fullName }}"
                  (click)="redirectUserFromShareModel(undefined, sharePost.postedBy)">
                  <span>{{ sharePost.postedByUserData?.fullName }}</span>
                </a>
                <img src="assets/icon/arrow.png" alt="" srcset="" class="profilelink" />
                <img src="assets/images/gallery/company.png" alt="" srcset="" class="profilelink" />
                <a class="fw-bold community-name-link" data-toggle="tooltip" data-placement="top"
                  title="{{ sharePost?.userName }}" (click)="redirectEntityFromShareModal(sharePost)">
                  <span>{{ sharePost?.userName }}</span>
                </a>
              </div>
              <ng-container
                *ngIf="(sharePost.postEntity == 'COMMUNITY' || sharePost.postEntity == 'NETWORK' || sharePost.postEntity == 'TEAM')">
                <div data-toggle="tooltip" data-placement="top" title="{{ sharePost.postedByUserData?.fullName }}"
                  class="cursor-pointer post-font post-name-entity-inline">
                  <a class="fw-bold" data-toggle="tooltip" data-placement="top" title="{{ sharePost.postedByUserData?.fullName }}"
                    (click)="redirectUserFromShareModel(sharePost, sharePost.postedBy)">
                    <span>{{ sharePost.postedByUserData?.fullName }}</span>
                  </a>
                  <img *ngIf="sharePost.postEntity == 'COMMUNITY' && sharePost?.postedBy && !sharePost?.communityWelcomePost" src="assets/icon/arrow.png" alt="" srcset=""
                    class="profilelink" />
                  <img *ngIf="sharePost.postEntity != 'COMMUNITY'" src="assets/icon/arrow.png" alt="" srcset=""
                    class="profilelink" />
                  <img src="assets/icon/icons8-myspace-400.png" *ngIf="sharePost.postEntity == 'COMMUNITY' " alt=""
                    srcset="" class="profilelink" />
                  <img src="assets/icon/icons8-share-400.png" *ngIf="sharePost.postEntity == 'NETWORK'  " alt=""
                    srcset="" class="profilelink" />
                  <img src="assets/icon/icons8-people-100.png" *ngIf="sharePost.postEntity == 'TEAM'" alt="" srcset=""
                    class="profilelink" />
                  <img src="assets/icon/icons8-small-business-100.png" *ngIf="sharePost.postEntity == 'BUSINESS'" alt=""
                    srcset="" class="profilelink" />
                  <a class="fw-bold community-name-link" data-toggle="tooltip" data-placement="top" title="{{ sharePost?.userName }}"
                    (click)="redirectEntityFromShareModal(sharePost)">
                    <span>{{ sharePost?.userName }}</span>
                  </a>
                </div>
              </ng-container>

              <div class="time" style="margin-top: 0px;">
                <ng-icon name="tablerClock" class="clock-icon" style="margin-left: 1px; font-size: 14px"></ng-icon>
                <small class="text-muted">{{ sharePost.postedOn | timezoneDate:'MMM dd, yyyy hh:mm a' }}</small>
              </div>
            </div>
          </div>
          <div class="social-content m-t-md mx-efty" *ngIf="sharePost.postContent">
            <!-- The guard belongs on the text, not on the block. Unlike the reposted cards
                 in the feed, where the media is a sibling, this block holds the text AND
                 the media, so guarding the block hides the image on a picture-only post.
                 Trimmed because share() writes four spaces in place of empty content, which
                 passed a plain truthiness check and left this element rendering its fixed
                 68px clamp as a blank band between the header and the image. -->
            <div class="showmore break-word" *ngIf="sharePost.postContent.trim()"
              [class.show-share]="sharePost.visible" [innerHtml]="sharePost.postContent">
            </div>

            <!-- Separates the media from the body above it. The body used to be a fixed
                 68px tall, so its unused height doubled as this gap; now that it sizes to
                 its content, the spacing has to be stated. 15px is what the reposted card
                 in the feed puts on its own media wrapper. -->
            <div class="m-t-15">

              <div *ngIf="sharePost.medias?.length==1">
                <div *ngFor="let imageshare of sharePost.medias; let i = index;">
                  <ng-container class="col-sm-12" *ngIf="imageshare.type === 'image'">
                    <div class="carousel-image">
                      <img [src]="imageshare.url" class="hover-effect" (click)="pushImages(sharePost.medias, i)" />
                    </div>
                  </ng-container>
                  <ng-container class="col-sm-12" *ngIf="imageshare.type === 'video'">
                    <video width=100% controls (click)="pushImages(sharePost.medias, i)" class="hover-effect"
                      #videoPlayer>
                      <source [src]="imageshare.url" />
                    </video>

                  </ng-container>
                </div>
              </div>
              <div *ngIf="sharePost.medias?.length>1">
                <section id="photos">
                  <div *ngIf="sharePost.medias?.length === 2 || sharePost.medias.length === 4">
                    <div class="even" *ngFor="let photos of sharePost.medias; let i = index;">
                      <!-- <img [src]=[photos.url] alt="sharePosts"> -->
                      <ng-container *ngIf="photos.type=='image'">
                        <img [src]=[photos.url] alt="datas" class="hover-effect"
                          (click)="pushImages(sharePost.medias, i)">
                      </ng-container>
                      <ng-container>
                        <video *ngIf="photos.type=='video'" width="100%" controls
                          (click)="pushImages(sharePost.medias, i)" class="hover-effect" #videoPlayer>
                          <source [src]="photos.url" />
                        </video>
                      </ng-container>
                    </div>
                  </div>
                  <div *ngIf="sharePost.medias?.length === 3">
                    <div class="three" *ngFor="let photos of sharePost.medias; let i = index;">
                      <!-- <img [src]=[photos.url] alt="sharePosts"> -->
                      <ng-container *ngIf="photos.type=='image'">
                        <img [src]=[photos.url] alt="datas" class="hover-effect"
                          (click)="pushImages(sharePost.medias, i)">
                      </ng-container>
                      <ng-container>
                        <video *ngIf="photos.type=='video'" width="100%" controls
                          (click)="pushImages(sharePost.medias, i)" class="hover-effect" #videoPlayer>
                          <source [src]="photos.url" />
                        </video>
                      </ng-container>
                    </div>
                  </div>
                  <div *ngIf="sharePost.medias?.length === 5">
                    <div class="five" *ngFor="let photos of sharePost.medias; let i = index;">
                      <!-- <img [src]=[photos.url] alt="sharePosts"> -->
                      <ng-container *ngIf="photos.type=='image'">
                        <img [src]=[photos.url] alt="datas" class="hover-effect"
                          (click)="pushImages(sharePost.medias, i)">
                      </ng-container>
                      <ng-container>
                        <video *ngIf="photos.type=='video'" width="100%" controls
                          (click)="pushImages(sharePost.medias, i)" class="hover-effect" #videoPlayer>
                          <source [src]="photos.url" />
                        </video>
                      </ng-container>
                    </div>
                  </div>
                  <div *ngIf="sharePost.medias?.length === 6">
                    <div class="even" *ngFor="let photos of sharePost.medias; let i = index;">
                      <!-- <img [src]=[photos.url] alt="sharePosts"> -->
                      <ng-container *ngIf="photos.type=='image'">
                        <img [src]=[photos.url] alt="datas" class="hover-effect"
                          (click)="pushImages(sharePost.medias, i)">
                      </ng-container>
                      <ng-container>
                        <video *ngIf="photos.type=='video'" width="100%" controls
                          (click)="pushImages(sharePost.medias, i)" class="hover-effect" #videoPlayer>
                          <source [src]="photos.url" />
                        </video>
                      </ng-container>
                    </div>
                  </div>
                  <div *ngIf="sharePost.medias?.length > 6">
                    <div class="sixPlus" *ngFor="let photos of sharePost.medias; let i = index;">
                      <!-- <img *ngIf="4>i" [src]=[photos.url] alt="sharePosts"> -->
                      <ng-container *ngIf="photos.type=='image' && 4>i">
                        <img [src]=[photos.url] alt="datas" class="hover-effect"
                          (click)="pushImages(sharePost.medias, i)">
                      </ng-container>
                      <ng-container>
                        <video *ngIf="photos.type=='video' && 4>i" width="100%" controls
                          (click)="pushImages(sharePost.medias, i)" class="hover-effect" #videoPlayer>
                          <source [src]="photos.url" />
                        </video>
                      </ng-container>
                      <span class="plusIcon" *ngIf="sharePost.medias.length>6 && i==3">+{{sharePost.medias.length-4}}
                        more</span>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>
      </div>
      <app-carousel *ngIf="selectedImage1 !== null" (closeCarousel)="closeCarouselAndReopenShareModal()" [images]="images"
        [selectedImage1]="selectedImage1">
      </app-carousel>
      <div *ngIf="!commonVariables.postPrivacyFlag" class="modal-footer">
        <div class="row">
          <div class="col-md-12">
            <button id="business_post_share_page_button" type="button " class="btn primary-btn float-r done-btn-size" (click)="sharePostPage()">
              Share
            </button>
            <button id="business_post_close_share_page_button" type="button " class="btn secondary-btn float-r m-r-15" (click)="closeSharePage()">
              Close
            </button>
          </div>
        </div>
      </div>
      <div class="custom-panel-heading">
        <div class="panel-heading" *ngIf="commonVariables.postPrivacyFlag">
          <label class="control-label padding-top-0 margin-bottom-5 margin-top-5 post-header">Select
            {{ postviewModelName }}</label>
          <div class="row panel-tools">
            <div class="col-sm-2">
              <button id="business_post_privacy_settings_close_button" type="button" class="close close-red" aria-label="Close" (click)="close()">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <hr *ngIf="commonVariables.postPrivacyFlag" style="margin: 0px !important" />
      <div class="app-form" *ngIf="commonVariables.postPrivacyFlag">
        <div class="modal-body">
          <div class="lbl" *ngIf="networkZeroFlag">
            You do not have anybody in your Network
          </div>
          <div class="lbl" *ngIf="teamZeroFlag">
            You do not have anybody in Workspace
          </div>
          <div class="lbl" *ngIf="connectionZeroFlag">
            You do not have connections
          </div>
          <div class="lbl" *ngIf="communityZeroFlag">
            You do not have anybody in your Community
          </div>
          <div class="m-t-mins-9 post-search-box"
            *ngIf="!networkZeroFlag && !communityZeroFlag && !teamZeroFlag && !connectionZeroFlag">
            <ng-icon name="tablerSearch" class="post-search-icon"></ng-icon>
            <input type="text" class="form-control tr post-search-input" name="searchName" id=""
              aria-describedby="helpId" placeholder="Search" (keyup)="onSearch($event)" [(ngModel)]="searchName" />
          </div>
          <!-- Inline skeleton rows while the list loads; same markup as the create-post
               picker at line 218 so both dialogs show an identical placeholder. -->
          <div class="modal-scroll-list" *ngIf="modalListLoading">
            <div class="row" *ngFor="let s of [1,2,3,4,5,6]">
              <div class="col-lg-12 oi">
                <div class="row poi">
                  <div class="col-sm-1"><span class="gs-net-skel-avatar"></span></div>
                  <div class="col-sm-10">
                    <span class="gs-net-skel-line gs-net-skel-line--name"></span>
                    <span class="gs-net-skel-line gs-net-skel-line--sub"></span>
                  </div>
                  <div class="col-sm-1 rm"><span class="gs-net-skel-check"></span></div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-scroll-list"
               *ngIf="!modalListLoading"
               [class.modal-scroll-list--capped]="(modelList?.length || 0) > 6"
               infiniteScroll
               [infiniteScrollDistance]="2"
               [infiniteScrollThrottle]="300"
               [scrollWindow]="false"
               [infiniteScrollDisabled]="postviewModelName !== 'Connections' && postviewModelName !== 'Network'"
               (scrolled)="onModalScrollDown()">
            <div class="row" *ngFor="
                let data of modelList
                  | filter: searchName;
                let i = index
              ">
            <!-- Connections -->
            <div class="col-lg-12 oi" *ngIf="postviewModelName == 'Connections'">
              <div class="row poi">
                <div class="col-sm-1">
                  <img *ngIf="data['photo']" class="img-profile" [src]="imgUrl + data['photo']" />
                  <div *ngIf="!data['photo']">
                    <div class="circles mr-rt-10 avtar"
                      [style.background-color]="getColortwo(data?.firstName,data?.lastName)">
                      <div class="circle-text" [style.color]="getTextColor(data?.firstName, data?.lastName)" style="font-size: 15px; font-weight: bold;font-family: Arial,sans-serif;">{{ getInitialstwo(data?.firstName,data?.lastName) }}</div>
                    </div>
                  </div>
                </div>
                <div class="col-sm-10">
                  <label title="{{ data.firstName }} {{ data.lastName }} ">
                    <a class="ft-12">{{ data.firstName }} {{ data.lastName }}</a>
                  </label>
                  <div class="overflow-hiden-" title="{{ data.title }}">
                    {{ data.title }}
                  </div>
                </div>
                <div class="col-sm-1 rm">
                  <!-- <input
                    type="checkbox"
                    [(ngModel)]="data.checked"
                    value="{{ data.userId }}"
                    (change)="onCheckboxChange(data, $event)"
                  /> -->
                  <div class="custom-checkbox em">
                    <label class="checkbox-label font-bold" style="text-align: center">
                      <input type="checkbox" [(ngModel)]="data.checked" value="{{ data.userId }}"
                        (change)="onCheckboxChange(data, $event)" />
                      <span class="checkmark"></span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <!-- Network -->
            <div class="col-lg-12 oi" *ngIf="postviewModelName == 'Network'">
              <div class="row poi">
                <div class="col-sm-1 p0">
                  <img class="img-profile" [src]="imgUrl + data['logo']"
                    onerror="src='assets/icon/icons8-share-400.png'" />
                </div>
                <div class="col-sm-10 rm">
                  <label data-toggle="tooltip" data-placement="top" title="{{ data.networkName }}  ">
                    <a class="ft-12">{{ data.networkName }} </a>
                  </label>
                </div>
                <div class="col-sm-1 rm">
                  <div class="custom-checkbox em">
                    <label class="checkbox-label font-bold" style="text-align: center">
                      <input type="checkbox" [(ngModel)]="data.checked" value="{{ data.userId }}"
                        (change)="onCheckboxChange(data, $event)" />
                      <span class="checkmark"></span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <!-- Community kjkhkjh-->
            <div *ngIf="postviewModelName == 'Community'">
              <div class="col-lg-12 oi">
                <div class="row poi">
                  <div class="col-sm-1 p0">
                    <img *ngIf="data['logo']" class="img-profile" [src]="imgUrl + data['logo']" />
                    <div *ngIf="!data['logo']" class="svg-background-community">
                      <ng-icon name="tablerUsersGroup" class="svg-position"></ng-icon>
                    </div>
                  </div>

                  <div class="col-sm-10 rm">
                    <label data-toggle="tooltip" data-placement="top" title="{{ data.communityName }}  ">
                      <h6 class="fw-bold m-0">
                        <a class="ft-12"><span> {{ data.communityName }} </span></a>
                      </h6>
                    </label>
                  </div>
                  <div class="col-sm-1 p0 rm">
                    <div class="custom-checkbox em">
                      <label class="checkbox-label font-bold" style="text-align: center">
                        <input type="checkbox" [(ngModel)]="data.checked" value="{{ data.userId }}"
                          (change)="onCheckboxChange(data, $event)" />
                        <span class="checkmark"></span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        <!-- Bottom skeleton rows shown while the next page loads on scroll. -->
        <ng-container *ngIf="connectionLoadingMore || networkLoadingMore">
          <div class="row" *ngFor="let s of [1, 2]">
            <div class="col-lg-12 oi">
              <div class="row poi">
                <div class="col-sm-1">
                  <span class="gs-net-skel-avatar"></span>
                </div>
                <div class="col-sm-10">
                  <span class="gs-net-skel-line gs-net-skel-line--name"></span>
                  <span class="gs-net-skel-line gs-net-skel-line--sub"></span>
                </div>
                <div class="col-sm-1 rm">
                  <span class="gs-net-skel-check"></span>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
        <div class="" *ngIf="postviewModelName === 'Connections' || postviewModelName === 'Network'"></div>
        <div class="connections-lbl text-center"
             *ngIf="!modalListLoading && !connectionLoadingMore && postviewModelName === 'Connections' && !connectionsHasMore && modelList?.length > 0">
          <div class="col-sm-12">
            <ng-icon name="tablerCircleCheck" class="end-of-list-icon"></ng-icon>
          </div>
          <div class="col-sm-12">
            <p class="biase" style="padding-bottom: 2rem;">You've reached the bottom of the page</p>
          </div>
        </div>
        <div class="" *ngIf="postviewModelName === 'Connections'"></div>
        <div class="network-lbl text-center"
             *ngIf="!modalListLoading && !networkLoadingMore && postviewModelName === 'Network' && !networkHasMore && modelList?.length > 0">
          <div class="col-sm-12">
            <ng-icon name="tablerCircleCheck" class="end-of-list-icon"></ng-icon>
          </div>
          <div class="col-sm-12">
            <p class="biase" style="padding-bottom: 2rem;">You've reached the bottom of the page</p>
          </div>
          <!-- <div class="network-bottom-spacer"></div> -->
        </div>
          <!-- Community used to be tested against the raw `modelList`, on the
               assumption its search was server-side. It is not: community/check/user
               ignores `searchContent` and always returns the user's full community
               set, so `modelList.length` was never 0 and the message never appeared.
               Test the SAME filtered list the rows above are rendered from — the
               Connections / Network path, and what the other three dialogs do. -->
          <div class="lbl"
             [class.connections-no-record]="postviewModelName === 'Connections'"
             *ngIf="!modalListLoading && (postviewModelName === 'Network' || postviewModelName === 'Connections' || postviewModelName === 'Community') && searchName && (modelList | filter: searchName)?.length === 0">
          No records available!
        </div>
        </div>
        <div class="modal-footer">
          <div class="footerContainer" style="float: right">
            <div class="footerIteam1">
              <button id="business_post_privacy_selection_cancel_button" class="btn btn-Success   mr-2" (click)="dismiss()">
                Cancel
              </button>
            </div>
            <div class="footerIteam2"
              *ngIf="!networkZeroFlag && !communityZeroFlag && !teamZeroFlag && !connectionZeroFlag">
              <button id="business_post_privacy_selection_continue_button" class="btn primary-btn btn-close-gap" [disabled]="checkedList.length === 0"
                (click)="savePostSelected(postviewModelName)">
                Continue
              </button>
            </div>
          </div>
          <!-- <pagination-controls *ngIf="!networkZeroFlag && !communityZeroFlag && !teamZeroFlag && !connectionZeroFlag"
            class="left-page-align" (click)="pagecount(page)" (pageChange)="page = $event">
          </pagination-controls> -->
        </div>
      </div>
      </div>
    </ng-template>

    <div class="gs-feed-end" *ngIf="stopscroll&&movedatafirst(userData)?.length>0">
      <!-- `--biz` variants are hidden by default (empty-state.scss) and swapped in
           only on the business Home tab (business.component.scss, wireframe .caught-up). -->
      <span class="gs-empty-icon">
        <ng-icon name="tablerCircleCheck" class="gs-feed-end-default"></ng-icon>
        <ng-icon name="tablerCheck" class="gs-feed-end--biz"></ng-icon>
      </span>
      <div class="gs-empty-title">You're all caught up</div>
      <div class="gs-empty-sub gs-feed-end-default">You've seen everything — stay tuned for more updates.</div>
      <div class="gs-empty-sub gs-feed-end--biz">Check back later for new posts.</div>
    </div>
  </div>
  <!-- Modal -->
  <ng-template #fileuploadPopUp>

    <div class="common-header-flex" *ngIf="!commonVariables.postPrivacyFlag">
      <div>Create A Post</div>
      <button id="business_post_edit_close_wrapper_button">
        <span class="common-close" (click)="close()">&times;</span>
      </button>
    </div>

    <div *ngIf="!commonVariables.postPrivacyFlag">
      <hr style="margin: 0px !important; padding: 0px !important">
    </div>
    <div class="modal-body post-text-for-model" style="margin-top: 3px !important;"
      *ngIf="!commonVariables.postPrivacyFlag">
      <div *ngIf="!commonVariables.postPrivacyFlag">
        <div class="row encased" [class.has-media]="selectedMediaType === 'photo' || selectedMediaType === 'video' || uploadFiles.length > 0">
          <div class="col-sm-2 pd-rt-0">
            <img *ngIf="profPhoto!==null" class="avtar" style="border-radius: 50% !important;" src="{{profPhoto}}" />
            <div *ngIf="!profPhoto">
              <div class="circles" [style.background-color]="getColor(profName)">
                <div class="circle-text" [style.color]="getFullNameTextColor(profName)" style="font-size: 18px !important; font-weight: bold; font-family: Arial,sans-serif;">{{ getInitials(profName) }}</div>
              </div>
            </div>
          </div>
          <div class="col-sm-10 pd-lt-0">
            <div class="row" [class.name-row-no-menu]="Commomdatass != 'USER'">
              <h5 class="ellipse2 text-only" title="{{profName}}">{{profName}}</h5>
            </div>
            <div class="row" [formGroup]="postTypeForm" style="display: flex;"
              *ngIf="(editPost && privacyValue == 'Connections') || !editPost">
              <input id="postType" formControlName="postType" [value]="privacyValue" style="display: none!important;">
              <div yPosition="below" *ngIf="Commomdatass == 'USER'" xPosition="after" [matMenuTriggerFor]="menu">
                <input id="postType" formControlName="postType" [value]="privacyValue" style="display: none!important;">
                <button id="business_post_file_upload_privacy_menu_button" class="btn btn-default">
                  <ng-icon name="tablerWorld" *ngIf="privacyValue == 'Everyone'"></ng-icon>
                  <ng-icon name="tablerUsers" *ngIf="privacyValue == 'Connections'"></ng-icon>
                  <ng-icon name="tablerNetwork" *ngIf="privacyValue == 'Network'"></ng-icon>
                  <ng-icon name="tablerUsers" *ngIf="privacyValue == 'Community'"></ng-icon>
                  <span class="opaa1"> {{privacyValue}}
                    <ng-icon name="tablerChevronDown" style="padding-left: 0.3rem;"></ng-icon>
                    <!-- <ng-icon name="tablerChevronUp"></ng-icon> -->
                  </span>
                </button>
                <mat-menu #menu="matMenu">
                  <button id="business_post_file_upload_privacy_everyone_button" class="mat-menu-height" mat-menu-item [disabled]="editPost"
                    (click)="changePostModal('Everyone', 'post')">
                    <ng-icon name="tablerWorld"></ng-icon>
                    <span class="opaa">Everyone</span>
                  </button>
                  <button id="business_post_file_upload_privacy_connections_button" type="button" [disabled]="editPost && privacyValue != 'Connections'"
                    (click)="changePostModal('Connections', 'post')" class="mat-menu-height" mat-menu-item>
                    <ng-icon name="tablerUsers"></ng-icon>
                    <span class="opaa">Connections</span>
                  </button>
                  <button id="business_post_file_upload_privacy_network_button" type="button" [disabled]="editPost" (click)="changePostModal('Network', 'post')"
                    class="mat-menu-height" mat-menu-item>
                    <ng-icon name="tablerNetwork"></ng-icon>
                    <span class="opaa">Network</span>
                  </button>
                  <button id="business_post_file_upload_privacy_community_button" type="button" [disabled]="editPost" (click)="changePostModal('Community', 'post')"
                    class="mat-menu-height" mat-menu-item>
                    <ng-icon name="tablerUsers"></ng-icon>
                    <span class="opaa">Community</span>
                  </button>
                </mat-menu>
              </div>
              <!-- <label *ngIf="selectedEntities.length>0">Shared with</label> -->
              <!-- Same chip row as the Edit modal (#editpost): first two names collapsed,
                   "and N others" expands the full list inside a scrolling element. -->
              <div class="privacy-entity-chips">
                <div class="privacy-entity-chips__list" [class.privacy-entity-chips__list--scroll]="showAllPrivacyEntities">
                  <div title="{{entity}}" class="ioxlp"
                    *ngFor="let entity of (showAllPrivacyEntities ? selectedEntities : selectedEntities.slice(0, 2))">
                    {{entity}}
                  </div>
                </div>
                <span class="jc-v3-skill-more" role="button" *ngIf="selectedEntities.length > 2"
                  (click)="togglePrivacyEntities(); $event.stopPropagation()">
                  <ng-container *ngIf="!showAllPrivacyEntities">and {{ selectedEntities.length - 2 }} others</ng-container>
                  <ng-container *ngIf="showAllPrivacyEntities">Show less</ng-container>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="post-text post-summernot" [formGroup]="urlLinkDetctForm">
          <div class="form-control" formControlName="snippedLinkText" [(ngModel)]="commanddata1" name="message"
            id="summessage" [ngxSummernote]="config1">
            <div class="custom-summernote-design"></div>
          </div>
          <div class="kjsiopzx"
            *ngIf="linkTitle != null || linkImage != null || linkDescription != null || linkURL != null">
            <div class="djwjpbf">
              <img src="{{linkImage}}" alt="">
            </div>
            <div class="sdiuqwfp">
              <h5>{{linkTitle}}</h5>
              <div>{{linkDescription}}</div>
              <div class="sdfkfldp">
                <a href="{{linkURL}}" target="_blank">{{linkURL}}</a>
              </div>
            </div>
          </div>
          <!-- <div class="posdkfp">
            <mat-form-field appearance="outline">
              <mat-label>Start a post...</mat-label>
                <textarea [(ngModel)]="commanddata1" name="message" id="summessage" matInput matTextareaAutosize matLinkPreview minRows="6"></textarea>
              <mat-link-preview-container [multiple]="true"></mat-link-preview-container>
            </mat-form-field>
          </div> -->
        </div>
        <div class="uisd">
          <div class="row post-img-align udlfphg">
            <!-- <div class="row post-img-align"> -->
            <carousel [noWrap]="true" [showIndicators]="false" [interval]="0">
              <slide *ngFor="let item of uploadFiles">
                <ng-container class="col-sm-6" *ngIf="item['t'] === 'image'">
                  <img [src]="item['src']" width="100%" />
                </ng-container>
                <ng-container class="col-sm-6" *ngIf="item['t'] === 'video'">
                  <video width="100%" controls (click)="toggleVideo()" #videoPlayer>
                    <source [src]="item['src']" [type]="item['ft']" />
                  </video>
                </ng-container>
                <ng-container class="col-sm-6" *ngIf="item['t'] === 'others'">
                  <div class="attach-others">name</div>
                </ng-container>
              </slide>
            </carousel>
            <!-- </div> -->
          </div>
        </div>
      </div>
      <!-- <div class="modal-footer" *ngIf="!commonVariables.postPrivacyFlag"> -->
      <div class="row" *ngIf="!commonVariables.postPrivacyFlag">
        <!-- <div class="col-sm-10"></div>
          <div class="col-sm-2"> -->
        <!-- <button class="btn primary-btn " id="postbtn1" (click)="savewithattachment('new')">Post</button> -->
        <!-- <div class="btn-group" dropdown style="display: flex">
              <button class="btn primary-btn right" id="postbtn1" (click)="savewithattachment('new')">
                Post
              </button>
            </div> -->
        <div class="row ajkl2">
          <div class="dkjgwwx">
            <label>Add to your post</label>
          </div>
          <div title="Photo" (click)="uploadMediaHere1('photo')">
            <!-- <img src="assets/icon/icons8-camera-100.png" alt="" class="iconImg ixggp" /> -->
            <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="13" r="3" stroke="#6a6c6f" stroke-width="1.5" />
              <path
                d="M9.77778 21H14.2222C17.3433 21 18.9038 21 20.0248 20.2646C20.51 19.9462 20.9267 19.5371 21.251 19.0607C22 17.9601 22 16.4279 22 13.3636C22 10.2994 22 8.76721 21.251 7.6666C20.9267 7.19014 20.51 6.78104 20.0248 6.46268C19.3044 5.99013 18.4027 5.82123 17.022 5.76086C16.3631 5.76086 15.7959 5.27068 15.6667 4.63636C15.4728 3.68489 14.6219 3 13.6337 3H10.3663C9.37805 3 8.52715 3.68489 8.33333 4.63636C8.20412 5.27068 7.63685 5.76086 6.978 5.76086C5.59733 5.82123 4.69555 5.99013 3.97524 6.46268C3.48995 6.78104 3.07328 7.19014 2.74902 7.6666C2 8.76721 2 10.2994 2 13.3636C2 16.4279 2 17.9601 2.74902 19.0607C3.07328 19.5371 3.48995 19.9462 3.97524 20.2646C5.09624 21 6.65675 21 9.77778 21Z"
                stroke="#6a6c6f" stroke-width="1.5" />
              <path d="M19 10H18" stroke="#6a6c6f" stroke-width="1.5" stroke-linecap="round" />
            </svg>
            <div class="image-upload photo-icon-click mt-10">
            </div>
          </div>
          <div title="Video" (click)="uploadMediaHere1('video')">
            <!-- <img src="assets/icon/icons8-video-call-100.png" alt="" srcset="" class="iconImg ixggp" /> -->
            <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none">
              <path
                d="M12.53 20.4201H6.21C3.05 20.4201 2 18.3201 2 16.2101V7.79008C2 4.63008 3.05 3.58008 6.21 3.58008H12.53C15.69 3.58008 16.74 4.63008 16.74 7.79008V16.2101C16.74 19.3701 15.68 20.4201 12.53 20.4201Z"
                stroke="#6a6c6f" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path
                d="M19.52 17.0999L16.74 15.1499V8.83989L19.52 6.88989C20.88 5.93989 22 6.51989 22 8.18989V15.8099C22 17.4799 20.88 18.0599 19.52 17.0999Z"
                stroke="#6a6c6f" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path
                d="M11.5 11C12.3284 11 13 10.3284 13 9.5C13 8.67157 12.3284 8 11.5 8C10.6716 8 10 8.67157 10 9.5C10 10.3284 10.6716 11 11.5 11Z"
                stroke="#6a6c6f" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            <div class="image-upload1 photo-icon-click mt-10">
            </div>
          </div>
          <div title="Link">
            <!-- <img src="assets/icon/icons8-link-100.png" alt="" srcset="" class="iconImg ixggp" /> -->
            <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none">
              <path
                d="M12.7917 15.7991L14.2223 14.3676C16.5926 11.9959 16.5926 8.15054 14.2223 5.7788C11.8521 3.40707 8.0091 3.40707 5.63885 5.7788L2.77769 8.64174C0.407436 11.0135 0.407436 14.8588 2.77769 17.2306C3.87688 18.3304 5.29279 18.9202 6.73165 19"
                stroke="#6a6c6f" stroke-width="1.5" stroke-linecap="round" />
              <path
                d="M11.2083 8.20092L9.77769 9.63239C7.40744 12.0041 7.40744 15.8495 9.77769 18.2212C12.1479 20.5929 15.9909 20.5929 18.3612 18.2212L21.2223 15.3583C23.5926 12.9865 23.5926 9.14118 21.2223 6.76945C20.1231 5.66957 18.7072 5.07976 17.2683 5"
                stroke="#6a6c6f" stroke-width="1.5" stroke-linecap="round" />
            </svg>
            <div class="image-upload12 photo-icon-click mt-10">
              <label for="file-input12">
                <!-- <a class="card-link common-font-12"> Link </a> -->
              </label>
            </div>
          </div>

        </div>
        <div class="row uqpp1">
          <button class="btn primary-btn btn-block" id="postbtn1"
            (click)="savewithattachment('new', null,privacyentityset?.postEntityId,privacyentityset?.postEntity)">
            Post
          </button>
        </div>

      </div>

    </div>
    <!-- Same dialog header as the create-post / edit-post pickers
         (.common-header-flex + red close). Replaces the old .panel-heading copy so
         the Photo / Video privacy picker matches the other post dialogs. Keeps
         close() — for this media dialog it is what clears the picked file and the
         selectedImage / selectedvideo flags. -->
    <div class="common-header-flex" *ngIf="commonVariables.postPrivacyFlag">
      <div>Select {{ postviewModelName }}</div>
      <button id="business_post_file_upload_privacy_close_wrapper_button">
        <span id="business_post_edit_privacy_settings_close_button" (click)="close()"
          class="common-close">&times;</span>
      </button>
    </div>
    <div class="app-form" *ngIf="commonVariables.postPrivacyFlag">
      <div class="modal-body">
        <div class="lbl" *ngIf="networkZeroFlag">
          You do not have anybody in your Network
        </div>
        <div class="lbl" *ngIf="teamZeroFlag">
          You do not have anybody in Workspace
        </div>
        <div class="lbl" *ngIf="connectionZeroFlag">
          You do not have connections
        </div>
        <div class="lbl" *ngIf="communityZeroFlag">
          You do not have anybody in your Community
        </div>
        <div class="m-t-mins-9 post-search-box" *ngIf="!networkZeroFlag && !communityZeroFlag && !teamZeroFlag && !connectionZeroFlag">
          <ng-icon name="tablerSearch" class="post-search-icon"></ng-icon>
          <input type="text" class="form-control tr post-search-input" name="searchName" id="" aria-describedby="helpId"
            placeholder="Search" (keyup)="onSearch($event)" [(ngModel)]="searchName" />
        </div>
        <!-- Inline skeleton rows while the list loads; same markup as the create-post
             picker at line 218 so both dialogs show an identical placeholder. -->
        <div class="modal-scroll-list" *ngIf="modalListLoading">
          <div class="row" *ngFor="let s of [1,2,3,4,5,6]">
            <div class="col-lg-12 oi">
              <div class="row poi">
                <div class="col-sm-1"><span class="gs-net-skel-avatar"></span></div>
                <div class="col-sm-10">
                  <span class="gs-net-skel-line gs-net-skel-line--name"></span>
                  <span class="gs-net-skel-line gs-net-skel-line--sub"></span>
                </div>
                <div class="col-sm-1 rm"><span class="gs-net-skel-check"></span></div>
              </div>
            </div>
          </div>
        </div>
        <!-- Cursor paging replaced ngx-pagination for Connections / Network, so the
             list now scrolls and pulls the next batch instead of paging. Same
             container and directive settings as the create-post picker. -->
        <div class="modal-scroll-list"
             *ngIf="!modalListLoading"
             [class.modal-scroll-list--capped]="(modelList?.length || 0) > 6"
             infiniteScroll
             [infiniteScrollDistance]="2"
             [infiniteScrollThrottle]="300"
             [scrollWindow]="false"
             [infiniteScrollDisabled]="postviewModelName !== 'Connections' && postviewModelName !== 'Network'"
             (scrolled)="onModalScrollDown()">
        <div class="row" *ngFor="let data of modelList | filter: searchName; let i = index">
          <!-- Connections -->
          <div class="col-lg-12 oi" *ngIf="postviewModelName == 'Connections'">
            <div class="row poi">
              <div class="col-sm-1">
                <img *ngIf="data['photo']" class="img-profile" [src]="imgUrl + data['photo']" />
                <div *ngIf="!data['photo']">
                  <div class="circles mr-rt-10 avtar"
                    [style.background-color]="getColortwo( data?.firstName,data?.lastName)">
                    <div class="circle-text"  [style.color]="getTextColor(data?.firstName, data?.lastName)" style="font-size: 15px; font-weight: bold;font-family: Arial,sans-serif;">{{ getInitialstwo( data?.firstName,data?.lastName) }}</div>
                  </div>
                </div>
              </div>
              <div class="col-sm-10">
                <label title="{{ data.firstName }} {{ data.lastName }} ">
                  <a class="ft-12">{{ data.firstName }} {{ data.lastName }}</a>
                </label>
                <div class="overflow-hiden-" title="{{ data.title }}">
                  {{ data.title }}
                </div>
              </div>
              <div class="col-sm-1 rm">
                <!-- <input
                  type="checkbox"
                  [(ngModel)]="data.checked"
                  value="{{ data.userId }}"
                  (change)="onCheckboxChange(data, $event)"
                /> -->
                <div class="custom-checkbox em">
                  <label class="checkbox-label font-bold" style="text-align: center">
                    <input type="checkbox" [(ngModel)]="data.checked" value="{{ data.userId }}"
                      (change)="onCheckboxChange(data, $event)" />
                    <span class="checkmark"></span>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <!-- Network -->
          <div class="col-lg-12 oi" *ngIf="postviewModelName == 'Network'">
            <div class="row poi">
              <div class="col-sm-1 p0">
                <img class="img-profile" [src]="imgUrl + data['logo']"
                  onerror="src='assets/icon/icons8-share-400.png'" />
              </div>
              <div class="col-sm-10 rm">
                <label class="overflow-hiden-" data-toggle="tooltip" data-placement="top"
                  title="{{ data.networkName }}  ">
                  <h6 class="fw-bold m-0">
                    <a class="ft-12"><span> {{ data.networkName }} </span> </a>
                  </h6>
                </label>
              </div>
              <div class="col-sm-1 rm">
                <div class="custom-checkbox em">
                  <label class="checkbox-label font-bold" style="text-align: center">
                    <input type="checkbox" [(ngModel)]="data.checked" value="{{ data.userId }}"
                      (change)="onCheckboxChange(data, $event)" />
                    <span class="checkmark"></span>
                  </label>
                </div>
                <!-- <input type="checkbox" [(ngModel)]="data.checked" value="{{ data.userId }}"
                  (change)="onCheckboxChange(data, $event)" /> -->
                <!-- <input type="checkbox"    value="{{data.userId}}" (change)="onCheckboxChange(data,$event)"> -->
              </div>
            </div>
          </div>
          <!-- Community kjkhkjh-->
          <div *ngIf="postviewModelName == 'Community'">
            <div class="col-lg-12 oi">
              <div class="row poi">
                <div class="col-sm-1 p0">
                  <img *ngIf="data['logo']" class="img-profile" [src]="imgUrl + data['logo']" />
                  <div *ngIf="!data['logo']" class="svg-background-community">
                    <ng-icon name="tablerUsersGroup" class="svg-position"></ng-icon>
                  </div>
                </div>
                <div class="col-sm-10 rm">
                  <label class="overflow-hiden-" data-toggle="tooltip" data-placement="top"
                    title="{{ data.communityName }}  ">
                    <h6 class="fw-bold m-0">
                      <a class="ft-12"><span> {{ data.communityName }} </span> </a>
                    </h6>
                  </label>
                </div>
                <div class="col-sm-1 p0 rm">
                  <div class="custom-checkbox em">
                    <label class="checkbox-label font-bold" style="text-align: center">
                      <input type="checkbox" [(ngModel)]="data.checked" value="{{ data.userId }}"
                        (change)="onCheckboxChange(data, $event)" />
                      <span class="checkmark"></span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Bottom skeleton rows shown while the next page loads on scroll. -->
        <ng-container *ngIf="connectionLoadingMore || networkLoadingMore">
          <div class="row" *ngFor="let s of [1, 2]">
            <div class="col-lg-12 oi">
              <div class="row poi">
                <div class="col-sm-1"><span class="gs-net-skel-avatar"></span></div>
                <div class="col-sm-10">
                  <span class="gs-net-skel-line gs-net-skel-line--name"></span>
                  <span class="gs-net-skel-line gs-net-skel-line--sub"></span>
                </div>
                <div class="col-sm-1 rm"><span class="gs-net-skel-check"></span></div>
              </div>
            </div>
          </div>
        </ng-container>
        <!-- End-of-list indicators, same blocks and conditions as the create-post
             picker. They sit INSIDE .modal-scroll-list so the message scrolls with
             the list and the dialog height stays bounded by the list cap. -->
        <div class="connections-lbl text-center"
             *ngIf="!modalListLoading && !connectionLoadingMore && postviewModelName === 'Connections' && !connectionsHasMore && modelList?.length > 0">
          <div class="col-sm-12">
            <ng-icon name="tablerCircleCheck" class="end-of-list-icon"></ng-icon>
          </div>
          <div class="col-sm-12">
            <p class="biase" style="padding-bottom: 2rem;">You've reached the bottom of the page</p>
          </div>
        </div>
        <div class="network-lbl text-center"
             *ngIf="!modalListLoading && !networkLoadingMore && postviewModelName === 'Network' && !networkHasMore && modelList?.length > 0">
          <div class="col-sm-12">
            <ng-icon name="tablerCircleCheck" class="end-of-list-icon"></ng-icon>
          </div>
          <div class="col-sm-12">
            <p class="biase" style="padding-top: 1rem; padding-bottom: 2rem;">You've reached the bottom of the page</p>
          </div>
          <div class="network-bottom-spacer"></div>
        </div>
        </div>
        <div class="lbl"
             *ngIf="!modalListLoading && searchName && !(modelList | filter: searchName)?.length
                    && !networkZeroFlag && !connectionZeroFlag && !communityZeroFlag && !teamZeroFlag">
          No records available!
        </div>
      </div>
      <div class="custom-panel-footer" *ngIf="commonVariables.postPrivacyFlag">
        <div class="panel-footer">
          <div class="footer-flex">
            <button id="business_post_edit_privacy_cancel_button" class="btn btn-default mr-2" (click)="dismiss()">
              Cancel
            </button>
            <button id="business_post_edit_privacy_continue_button"
              *ngIf="!networkZeroFlag || !communityZeroFlag || !teamZeroFlag || !connectionZeroFlag"
              class="btn btn-primary" [disabled]="checkedList.length === 0"
              (click)="savePostSelected(postviewModelName)">
              Continue
            </button>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template #postdatasimg>
    <div class="modal-header">
      <h6 class="modal-title pull-left m-0" *ngIf="
          singleimagedata.type === 'video' && singleimagedata.type === 'image'">
        Selected Image & Video
      </h6>
      <h6 class="modal-title pull-left m-0" *ngIf="singleimagedata.type === 'video'">
        Selected Video
      </h6>
      <h6 class="modal-title pull-left m-0" *ngIf="singleimagedata.type === 'image'">
        Selected Image
      </h6>
      <button id="business_post_selected_image_close_button" type="button" class="close pull-right sdz akkj" aria-label="Close" (click)="sdf()">
        <span style="font-weight: 400;" aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="row">
        <ng-container *ngIf="singleimagedata.type === 'image'">
          <img [src]="singleimagedata.url" width="100%" style="max-height: 350px !important" />
        </ng-container>
        <ng-container *ngIf="singleimagedata.type === 'video'">
          <video width="100%" controls (click)="toggleVideopopup()" #videoPlayerpopup>
            <source [src]="singleimagedata.url" />
          </video>
        </ng-container>
      </div>
    </div>
  </ng-template>
  <ng-template #editpost>

    <div class="common-header-flex" *ngIf="!commonVariables.postPrivacyFlag">
      <div>Edit Your Post </div>
      <button id="business_post_edit_post_close_wrapper_button">
        <span class="common-close" (click)="closeEdit()">&times;</span>
      </button>
    </div>
    <div class="panel-body border-radius-top-left-right-6 edit-post-body"
      *ngIf="!commonVariables.postPrivacyFlag">
      <div class="edit-post-author">
        <div class="edit-post-author__avatar">
          <img *ngIf="profPhoto!==null" class="avtar" src="{{profPhoto}}" />
          <div *ngIf="!profPhoto">
            <div class="circles" [style.background-color]="getColor(profName)">
              <div class="circle-text" [style.color]="getFullNameTextColor(profName)" style="font-size: 18px; font-weight: bold; font-family: Arial, sans-serif;">
                {{ getInitials(profName) }}
              </div>
            </div>
          </div>
        </div>
        <div class="edit-post-author__meta" [class.edit-post-author__meta--time]="!showEditPrivacyRow">
          <h6 class="edit-post-author__name" title="{{profName}}">{{profName}}</h6>
          <div class="row" [formGroup]="postTypeForm" style="display: flex;"
            *ngIf="showEditPrivacyRow">
            <input formControlName="postType" [value]="privacyValue" style="display: none!important;">
            <div yPosition="below" *ngIf="Commomdatass == 'USER'" xPosition="after" [matMenuTriggerFor]="menu">
              <button id="business_post_edit_privacy_menu_button" class="btn btn-default">
                <ng-icon name="tablerWorld" *ngIf="privacyValue == 'Everyone'"></ng-icon>
                <ng-icon name="tablerUsers" *ngIf="privacyValue == 'Connections'"></ng-icon>
                <ng-icon name="tablerNetwork" *ngIf="privacyValue == 'Network'"></ng-icon>
                <ng-icon name="tablerUsers" *ngIf="privacyValue == 'Community'"></ng-icon>
                <span class="opaa1"> {{privacyValue}}
                  <ng-icon name="tablerChevronDown" style="padding-left: 0.3rem;"></ng-icon>
                </span>
              </button>
              <mat-menu #menu="matMenu">
                <button id="business_post_edit_privacy_everyone_button" class="mat-menu-height" mat-menu-item [disabled]="editPost"
                  (click)="changePostModal('Everyone', 'post')">
                  <ng-icon name="tablerWorld"></ng-icon>
                  <span class="opaa">Everyone</span>
                </button>
                <button id="business_post_edit_privacy_connections_button" type="button" [disabled]="editPost && privacyValue != 'Connections'"
                  (click)="changePostModal('Connections', 'post')" class="mat-menu-height" mat-menu-item>
                  <ng-icon name="tablerUsers"></ng-icon>
                  <span class="opaa">Connections</span>
                </button>
                <button id="business_post_edit_privacy_network_button" type="button" [disabled]="editPost" (click)="changePostModal('Network', 'post')"
                  class="mat-menu-height" mat-menu-item>
                  <ng-icon name="tablerNetwork"></ng-icon>
                  <span class="opaa">Network</span>
                </button>
                <button id="business_post_edit_privacy_community_button" type="button" [disabled]="editPost" (click)="changePostModal('Community', 'post')"
                  class="mat-menu-height" mat-menu-item>
                  <ng-icon name="tablerUsers"></ng-icon>
                  <span class="opaa">Community</span>
                </button>
              </mat-menu>
            </div>
            <!-- Collapsed to the first two connections until "+N more" is clicked; mirrors the
                 applicant card's skill chips (candidate-card-table-view.component.html:435). -->
            <div class="privacy-entity-chips">
              <!-- Names scroll inside their own element; the toggle chip below is a
                   sibling so "Show less" stays reachable without scrolling. -->
              <div class="privacy-entity-chips__list" [class.privacy-entity-chips__list--scroll]="showAllPrivacyEntities">
                <div title="{{entity}}" class="ioxlp"
                  *ngFor="let entity of (showAllPrivacyEntities ? selectedEntities : selectedEntities.slice(0, 2))">
                  {{entity}}
                </div>
              </div>
              <span class="jc-v3-skill-more" role="button" *ngIf="selectedEntities.length > 2"
                (click)="togglePrivacyEntities(); $event.stopPropagation()">
                <ng-container *ngIf="!showAllPrivacyEntities">and {{ selectedEntities.length - 2 }} others</ng-container>
                <ng-container *ngIf="showAllPrivacyEntities">Show less</ng-container>
              </span>
            </div>
          </div>
          <div class="time" *ngIf="!showEditPrivacyRow">
            <ng-icon name="tablerClock" class="clock-icon" style="margin-left: 1px; font-size: 14px"></ng-icon>
            <small class="text-muted">{{ editPostedOn | timezoneDate:'MMM dd, yyyy hh:mm a' }}</small>
          </div>
        </div>
      </div>
      <div class="post-text post-summernot" [formGroup]="urlLinkDetctForm">
        <div class="R-summary">
          <div formControlName="snippedLinkText" class="form-control" [(ngModel)]="commanddataEdit" name="summessageges"
          id="summessageges" [ngxSummernote]="config1"></div>
          <div class="text-danger" *ngIf="urlLinkDetctForm.controls.snippedLinkText.errors?.maxchar">
            {{FORMERROR.ABOUT_YOUR_MAX}}
          </div>
        </div>
        <div class="kjsiopzx"
          *ngIf="linkTitle != null || linkImage != null || linkDescription != null || linkURL != null">
          <div class="djwjpbf">
            <img src="{{linkImage}}" alt="">
          </div>
          <div class="sdiuqwfp">
            <h5>{{linkTitle}}</h5>
            <div>{{linkDescription}}</div>
            <div class="sdfkfldp">
              <a href="{{linkURL}}" target="_blank">{{linkURL}}</a>
            </div>
          </div>
        </div>

      </div>
      <div class="row xtra">
        <div class="col-sm-6" *ngFor="let url of imagEditData" class="img-wraps">
          <ng-container *ngIf="url.type == 'image'">
            <img *ngIf="url.status == 'ACTIVE'" [src]="PhotoPath + url.fileId" class="img-responsive" height="150" />
            <img *ngIf="url.status == 'INACTIVE'" [src]="url.url" class="img-responsive" height="150" />
            <span class="closes" (click)="deleteImage(url.fileId)" title="Delete">
              <a>&times;</a>
            </span>
          </ng-container>
          <ng-container *ngIf="url.type == 'video'">
            <video width="100%" class="img-responsive" controls height="150" (click)="toggleVideo()" #videoPlayer>
              <source [src]="url.url" />
            </video>
            <span class="closes" (click)="deleteImage(url.fileId)" title="Delete">
              <a>&times;</a>
            </span>
          </ng-container>
        </div>
      </div>
    </div>
    <!-- Bootstrap float grid, deliberately NOT a flex row: `.modal-footer:before/:after` is
         Bootstrap's clearfix, and in a flex container those pseudo-elements become flex items, so
         `justify-content` spreads the buttons across the footer instead of pinning them to the
         edges. The `edit-post-footer` class carries no layout of its own — it only scopes the
         grid-hardening rules in bussiness-post.component.scss to this one footer. -->
    <div class="modal-footer edit-post-footer" *ngIf="!commonVariables.postPrivacyFlag">
      <div class="row">
        <div class="col-sm-10" for="file-input">
          <input id="file-input-upload" #file style="display: none" multiple type="file" accept="image/*,video/*"
            (click)="file.value=''"
            (change)="fileUpload($event, 'both', editfileUpload)" />
          <button id="business_post_add_files_button" style="margin-left: 34px;" class="btn primary-btn add-files" (click)="file.click()">
            Add
          </button>
        </div>
        <div class="col-sm-2">
          <div class="btn-group" style="display: flex">
            <button class="btn primary-btn right" id="postbtn1"
              (click)="savewithattachment('edit', null,privacyentityset?.postEntityId,privacyentityset?.postEntity)">
              Post
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Header, search box, list and footer here are lifted from the create-post
         picker (lines 192-388) so both dialogs render identically. -->
    <div class="common-header-flex" *ngIf="commonVariables.postPrivacyFlag">
      <div>Select {{ postviewModelName }}</div>
      <button id="business_post_edit_privacy_settings_close_wrapper_button">
        <span id="business_post_edit_privacy_settings_close_button" (click)="dismiss()" class="common-close">&times;</span>
      </button>
    </div>
    <div class="app-form" *ngIf="commonVariables.postPrivacyFlag">
      <div class="modal-body">
        <div class="lbl" *ngIf="networkZeroFlag">
          You do not have anybody in your Network
        </div>
        <div class="lbl" *ngIf="teamZeroFlag">
          You do not have anybody in Workspace
        </div>
        <div class="lbl" *ngIf="connectionZeroFlag">
          You do not have connections
        </div>
        <div class="lbl" *ngIf="communityZeroFlag">
          You do not have anybody in your Community
        </div>
        <div class="m-t-mins-9 post-search-box" *ngIf="!networkZeroFlag && !communityZeroFlag && !teamZeroFlag && !connectionZeroFlag">
          <ng-icon name="tablerSearch" class="post-search-icon"></ng-icon>
          <input type="text" class="form-control tr post-search-input" name="searchName" id="" aria-describedby="helpId"
            placeholder="Search" (keyup)="onSearch($event)" [(ngModel)]="searchName" />
        </div>
        <!-- Inline skeleton rows while the list loads; same markup as the create-post
             picker at line 218 so both dialogs show an identical placeholder. -->
        <div class="modal-scroll-list" *ngIf="modalListLoading">
          <div class="row" *ngFor="let s of [1,2,3,4,5,6]">
            <div class="col-lg-12 oi">
              <div class="row poi">
                <div class="col-sm-1"><span class="gs-net-skel-avatar"></span></div>
                <div class="col-sm-10">
                  <span class="gs-net-skel-line gs-net-skel-line--name"></span>
                  <span class="gs-net-skel-line gs-net-skel-line--sub"></span>
                </div>
                <div class="col-sm-1 rm"><span class="gs-net-skel-check"></span></div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-scroll-list"
             *ngIf="!modalListLoading"
             [class.modal-scroll-list--capped]="(modelList?.length || 0) > 6"
             infiniteScroll
             [infiniteScrollDistance]="2"
             [infiniteScrollThrottle]="300"
             [scrollWindow]="false"
             [infiniteScrollDisabled]="postviewModelName !== 'Connections' && postviewModelName !== 'Network'"
             (scrolled)="onModalScrollDown()">
        <div class="row" *ngFor="let data of modelList | filter: searchName; let i = index">
          <!-- Connections -->
          <div class="col-lg-12 oi" *ngIf="postviewModelName == 'Connections'">
            <div class="row poi">
              <div class="col-sm-1">
                <img *ngIf="data['photo']" class="img-profile" [src]="imgUrl + data['photo']" />
                <div *ngIf="!data['photo']">
                  <div class="circles mr-rt-10 avtar"
                    [style.background-color]="getColortwo( data?.firstName,data?.lastName)">
                    <div class="circle-text" [style.color]="getTextColor(data?.firstName, data?.lastName)" style="font-size: 15px; font-weight: bold;font-family: Arial,sans-serif;">{{ getInitialstwo( data?.firstName,data?.lastName) }}</div>
                  </div>
                </div>
              </div>
              <div class="col-sm-10">
                <label title="{{ data.firstName }} {{ data.lastName }} ">
                  <a class="ft-12">{{ data.firstName }} {{ data.lastName }}</a>
                </label>
                <div title="{{ data.title }}" class="overflow-hiden-">
                  {{ data.title }}
                </div>
              </div>
              <div class="col-sm-1 rm">
                <!-- <input
                  type="checkbox"
                  [(ngModel)]="data.checked"
                  value="{{ data.userId }}"
                  (change)="onCheckboxChange(data, $event)"
                /> -->
                <div class="custom-checkbox em">
                  <label class="checkbox-label font-bold" style="text-align: center">
                    <input type="checkbox" [(ngModel)]="data.checked" value="{{ data.userId }}"
                      (change)="onCheckboxChange(data, $event)" />
                    <span class="checkmark"></span>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <!-- Network -->
          <div class="col-lg-12 oi" *ngIf="postviewModelName == 'Network'">
            <div class="row poi">
              <div class="col-sm-1 p0">
                <img class="img-profile" [src]="imgUrl + data['logo']"
                  onerror="src='assets/icon/icons8-share-400.png'" />
              </div>
              <div class="col-sm-10 rm">
                <label data-toggle="tooltip" data-placement="top" title="{{ data.networkName }}  ">
                  <a class="ft-12">{{ data.networkName }} </a>
                </label>
              </div>
              <div class="col-sm-1 rm">
                <div class="custom-checkbox em">
                  <label class="checkbox-label font-bold" style="text-align: center">
                    <input type="checkbox" [(ngModel)]="data.checked" value="{{ data.userId }}"
                      (change)="onCheckboxChange(data, $event)" />
                    <span class="checkmark"></span>
                  </label>
                </div>
                <!-- <input type="checkbox" [(ngModel)]="data.checked" value="{{ data.userId }}"
                  (change)="onCheckboxChange(data, $event)" /> -->
                <!-- <input type="checkbox"    value="{{data.userId}}" (change)="onCheckboxChange(data,$event)"> -->
              </div>
            </div>
          </div>
          <!-- Community kjkhkjh-->
          <div *ngIf="postviewModelName == 'Community'">
            <div class="col-lg-12 oi">
              <div class="row poi">
                <div class="col-sm-1 p0">
                  <img *ngIf="data['logo']" class="img-profile" [src]="imgUrl + data['logo']" />
                  <div *ngIf="!data['logo']" class="svg-background-community">
                    <ng-icon name="tablerUsersGroup" class="svg-position"></ng-icon>
                  </div>
                </div>
                <div class="col-sm-10 rm">
                  <label data-toggle="tooltip" data-placement="top" title="{{ data.communityName }}  ">
                    <h6 class="fw-bold m-0">
                      <a class="ft-12"><span> {{ data.communityName }} </span> </a>
                    </h6>
                  </label>
                </div>
                <div class="col-sm-1 p0 rm">
                  <div class="custom-checkbox em">
                    <label class="checkbox-label font-bold" style="text-align: center">
                      <input type="checkbox" [(ngModel)]="data.checked" value="{{ data.userId }}"
                        (change)="onCheckboxChange(data, $event)" />
                      <span class="checkmark"></span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Bottom skeleton rows shown while the next page loads on scroll. -->
        <ng-container *ngIf="connectionLoadingMore || networkLoadingMore">
          <div class="row" *ngFor="let s of [1, 2]">
            <div class="col-lg-12 oi">
              <div class="row poi">
                <div class="col-sm-1"><span class="gs-net-skel-avatar"></span></div>
                <div class="col-sm-10">
                  <span class="gs-net-skel-line gs-net-skel-line--name"></span>
                  <span class="gs-net-skel-line gs-net-skel-line--sub"></span>
                </div>
                <div class="col-sm-1 rm"><span class="gs-net-skel-check"></span></div>
              </div>
            </div>
          </div>
        </ng-container>
        <!-- End-of-list indicators, same blocks and conditions as the create-post
             picker (lines 365-384). They were missing from this copy, so the edit
             dialog never showed "You've reached the bottom of the page". They sit
             INSIDE .modal-scroll-list, as in create-post, so the message scrolls
             with the list and the dialog height stays bounded by the list cap. -->
        <div class="connections-lbl text-center"
             *ngIf="!modalListLoading && !connectionLoadingMore && postviewModelName === 'Connections' && !connectionsHasMore && modelList?.length > 0">
          <div class="col-sm-12">
            <ng-icon name="tablerCircleCheck" class="end-of-list-icon"></ng-icon>
          </div>
          <div class="col-sm-12">
            <p class="biase" style="padding-bottom: 2rem;">You've reached the bottom of the page</p>
          </div>
        </div>
        <div class="network-lbl text-center"
             *ngIf="!modalListLoading && !networkLoadingMore && postviewModelName === 'Network' && !networkHasMore && modelList?.length > 0">
          <div class="col-sm-12">
            <ng-icon name="tablerCircleCheck" class="end-of-list-icon"></ng-icon>
          </div>
          <div class="col-sm-12">
            <p class="biase" style="padding-top: 1rem; padding-bottom: 2rem;">You've reached the bottom of the page</p>
          </div>
          <div class="network-bottom-spacer"></div>
        </div>
        </div>
        <div class="lbl"
             *ngIf="!modalListLoading && searchName && !(modelList | filter: searchName)?.length
                    && !networkZeroFlag && !connectionZeroFlag && !communityZeroFlag && !teamZeroFlag">
          No records available!
        </div>
      </div>
      <div class="custom-panel-footer" *ngIf="commonVariables.postPrivacyFlag">
        <div class="panel-footer">
          <div class="footer-flex">
            <button id="business_post_edit_privacy_cancel_button" class="btn btn-default mr-2" (click)="dismiss()">
              Cancel
            </button>
            <button id="business_post_edit_privacy_continue_button"
              *ngIf="!networkZeroFlag || !communityZeroFlag || !teamZeroFlag || !connectionZeroFlag"
              class="btn btn-primary" [disabled]="checkedList.length === 0"
              (click)="savePostSelected(postviewModelName)">
              Continue
            </button>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template #editfileUpload>

    <div class="common-header-flex">
      <div *ngIf="selectedvideo && selectedImage"> Add Image & Video </div>
      <div *ngIf="selectedvideo && !selectedImage"> Add Video </div>
      <div *ngIf="selectedImage && !selectedvideo"> Add Image</div>
      <button><span class="common-close" (click)="close()" aria-hidden="true">&times;</span></button>
    </div>
    <div class="modal-body">
      <div class="row post-img-align">
        <carousel [noWrap]="true" [showIndicators]="false" [interval]="0">
          <slide *ngFor="let item of uploadFiles">
            <ng-container class="col-sm-6" *ngIf="item['t'] === 'image'">
              <img [src]="item['src']" width="100%" />
            </ng-container>
            <ng-container class="col-sm-6" *ngIf="item['t'] === 'video'">
              <video width="100%" controls (click)="toggleVideo()" #videoPlayer>
                <source [src]="item['src']" [type]="item['ft']" />
              </video>
            </ng-container>
          </slide>
        </carousel>
      </div>
    </div>
    <div class="modal-footer">
      <div class="footerContainer">
        <div class="footerIteam1">
          <button id="business_post_upload_edit_cancel_button" class="btn btn-Success   mr-2" (click)="close()">
            Cancel
          </button>
        </div>
        <div class="footerIteam2">
          <button id="business_post_upload_edit_ok_button" class="btn primary-btn btn-close-gap" (click)="closeuploadEdit()">
            Ok
          </button>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template #postSelect>

    <div class="modal-body">
      <div class="m-t-mins-9">
        <div class="form-group">
          <div class="row">
            <div class="col-sm-12">
              <input type="text" class="form-control" name="searchName" id="" aria-describedby="helpId"
                placeholder="Search" (keyup)="onSearch($event)" [(ngModel)]="searchName" />
            </div>
          </div>
        </div>
      </div>
      <div class="row" *ngFor="
          let data of modelList
            | filter: searchName
            | paginate: config;
          let i = index
        ">
      </div>
    </div>
    <div class="modal-footer">
      <div class="footerContainer" style="float: right">
        <div class="footerIteam2">
          <button id="business_post_select_privacy_ok_button" class="btn primary-btn btn-close-gap" (click)="savePostSelected(postviewModelName)">
            Ok
          </button>
        </div>
        <div class="footerIteam1">
          <button id="business_post_select_privacy_cancel_button" class="btn btn-Success   mr-2" (click)="dismiss()">
            Cancel
          </button>
        </div>
      </div>
      <pagination-controls class="left-page-align" (click)="pagecount(page)" (pageChange)="page = $event">
      </pagination-controls>
    </div>
  </ng-template>
</div>

<ng-template #modeltempview>
  <div id="blengi" style="visibility: hidden;" class="sklll"
    *ngIf="postView=='COMMUNITY' && communityType == 'true' && (isCommunityJoined == 'false')">
    <div class="col-sm-12">
      <img class="iopwwx" src="assets/icon/no_posts.png" alt="">
    </div>
    <div class="col-sm-12">
      <div>Content will be visible only for the members of the community. Please join the community.</div>
    </div>
  </div>
</ng-template>

<ng-template #profilePhotoUpload>

  <div class="common-header-flex">
    <div>Profile Photo</div>
    <button><span class="common-close" (click)="closePhoto2()" aria-hidden="true">&times;</span></button>
  </div>
  <div class="modal-body">
    <image-cropper [imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="true" [aspectRatio]="4 / 4"
      format="jpeg" (imageCropped)="imageCropped($event)" (cropperReady)="cropperReady()"
      (loadImageFailed)="loadImageFailed()"></image-cropper>
  </div>
  <div class="modal-footer" style="border-radius: 5px !important;">
    <button id="business_post_photo_crop_cancel_button" class="btn btn-default m-r-18" (click)="closePhoto2()">Cancel</button>
    <button id="business_post_photo_crop_apply_button" class="btn primary-btn m-r-18" (click)="imageLoaded2()">Apply</button>
  </div>
</ng-template>
<app-timezonepopup  (modalopen)="timezonepopup()" (response)="modelclose($event)" *ngIf="showModal"></app-timezonepopup>
<app-message-widget *ngIf="messagemodelflag" (closeMessageModel)="closeMessage()" style="z-index: -1;"
  [messageDataPass]="messageData"> </app-message-widget>

<div class="gs-empty" *ngIf="!loadApicall&&userData?.length==0">
  <span class="gs-empty-icon"><ng-icon name="tablerArticle"></ng-icon></span>
  <ng-container *ngIf="businessPage && isBusinessSuperAdmin() == true">
    <div class="gs-empty-title">No posts yet</div>
    <div class="gs-empty-sub">Post something to start your stream.</div>
  </ng-container>
  <ng-container *ngIf="businessPage && isBusinessSuperAdmin() == false">
    <div class="gs-empty-title">No posts to show</div>
    <div class="gs-empty-sub">Currently, there are no posts available.</div>
  </ng-container>
  <ng-container *ngIf="['COMMUNITY', 'NETWORK', 'TEAM'].includes(postView)">
    <div class="gs-empty-title">No posts yet</div>
    <div class="gs-empty-sub">You have no posts to view now.</div>
  </ng-container>
  <ng-container *ngIf="postView == 'GIG_HOME_PAGE'">
    <div class="gs-empty-title">Your feed is quiet right now</div>
    <div class="gs-empty-sub">When people you follow post, you'll see them here.</div>
  </ng-container>
</div>
